<template>
    <div>

        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h2 style="font-size: 40px; font-weight: 700; line-height: 48px; " class="mb-0 mt-5 align-items-center">Client Management <i @click="openHelpModal(0)" class="fa fa-question-circle" style="cursor: pointer; margin-left: 20px;opacity: 0.8;font-size: 25px;"></i>
                </h2>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 pt-4">
                <p>On this page, you can add, edit, or remove your clients.<br />When a new client is added, the system
                    will email them directions for completing their profile, reporting preferences, and payment
                    settings.
                    <br /> Make sure to also add the client's campaigns under the campaign tab for each desired service.
                </p>
            </div>
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 pt-4">
               <div style="display:inline-block">
                <a href="#" @click="modals.helpguide = true" style="display:inline-flex"><i class="far fa-play-circle" style="font-size:21px;padding-right:5px"></i> <span>here for more information.</span></a>
               </div>
            </div> -->
        </div>
        <div class="pt-3 pb-3">&nbsp;</div>

        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <card>
                    <div class="row">
                        <div class="col-12">
                            <div class="row" style="align-items: baseline;">
                            <div class="col-lg-5 col-md-12 col-sm-12">
                                <div>
                                    <base-input>
                                        <el-input type="text" class="mb-3 search-input input__client__management" clearable
                                            prefix-icon="el-icon-search" placeholder="Search Client" v-model="searchQuery"
                                            aria-controls="datatables" @keyup.native.enter="searchKeyWord"
                                            @clear="searchKeyWord">
                                        </el-input>
                                    </base-input>
                                </div>
                            </div>  
                            <div class="col-lg-7 col-md-12 col-sm-12" style="display: flex; justify-content: flex-end; align-items: center; flex-wrap: wrap;">
                                <div style="padding-inline: 4px;">
                                    <el-dropdown ref="dropdown" @visible-change="handleVisibleChange">
                                        <span>
                                        <base-button class="m-0 ml-2" size="sm" style="height:40px">
                                            <i class="fa-solid fa-filter"></i> Filters
                                        </base-button>
                                        </span>

                                        <el-dropdown-menu slot="dropdown" style="width: 240px;"  :class="{ 'dropdown-hidden': !dropdownVisible }" @click.native.stop>
                                        <div class='ml-4 mr-4'>
                                            <el-collapse value="Card Status" style="border: none;" v-if="this.$store.getters.userData.manual_bill === 'F'">
                                            <el-collapse-item title="Card Status" name="Card Status">
                                                <div style="padding-left:8px;" >
                                                <el-checkbox v-model="filters.cardStatus.active">Active</el-checkbox>
                                                <el-checkbox v-model="filters.cardStatus.inactive">Not Setup</el-checkbox>
                                                <el-checkbox v-model="filters.cardStatus.failed">Failed</el-checkbox>
                                                </div>
                                            </el-collapse-item>
                                            </el-collapse>
                                            <el-collapse value="Campaign Status" style="border: none;">
                                            <el-collapse-item title="Campaign Status" name="Campaign Status">
                                                <div style="padding-left:8px;">
                                                <el-checkbox v-model="filters.campaignStatus.active">Active</el-checkbox>
                                                <el-checkbox v-model="filters.campaignStatus.inactive">Inactive</el-checkbox>
                                                </div>
                                            </el-collapse-item>
                                            </el-collapse>
                                        </div>
                                        <div class='d-flex justify-content-end mr-4 mt-4'>
                                            <base-button @click="applyFilters" :simple="true" size="sm">
                                            Save
                                            </base-button>
                                        </div>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                                <div style="padding-inline: 4px;">
                                    <base-button size="sm" style="height:40px" v-if="this.$global.settingMenuShow_create"
                                        @click="AddEditClient('')">
                                        <i class="fas fa-plus-circle"></i> Add Client
                                    </base-button>
                                </div>
                                <div style="padding-inline: 4px;">
                                    <base-button size="sm" style="height:40px"
                                        @click="exportDataClient">
                                        <i class="fas fa-cloud-download-alt pr-2"></i> Export Data
                                    </base-button>
                                </div>
                        </div>
                    </div>
                        </div>
                    </div>

                   

                    <div class="row">
                        <div
                            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap tab-table">
                            <el-table @expand-change="onExpandClick" :data="queriedData" @sort-change="sortdynamic" :row-class-name="tableRowClassName"
                                ref="tableData" :default-sort="{prop: 'company_name', order: 'ascending'}">
                                <template #empty>
                                    <i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...
                                </template>
                                <el-table-column min-width="180" prop="company_name" sortable="custom"
                                    label="Client's Business Name">
                                    <div slot-scope="props">
                                        {{props.row.company_name}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="180" prop="full_name" sortable="custom"
                                    label="Client's Personal Name">
                                    <div slot-scope="props">
                                        {{props.row.name}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="180" prop="email" sortable="custom" label="E-mail">
                                    <div slot-scope="props">
                                        {{props.row.email}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="120" prop="phone" sortable="custom" label="Phone">
                                    <div slot-scope="props">
                                        {{props.row.phonenum}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="120" prop="created_at" sortable="custom" align="center"
                                    label="Created">
                                    <div slot-scope="props">
                                        {{props.row.created_at}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="140" align="center" label="Metrics">
                                    <div slot-scope="props">
                                        <el-popover trigger="hover" content="Card settings" effect="light"
                                            placement="top" v-if="props.row.manual_bill == 'F'">
                                            <base-button slot="reference" @click.native="handleCardSet(props.$index, props.row)"
                                                class="edit btn-link" type="warning" size="sm" icon>
                                                <i class="far fa-credit-card" :style="getCardStatus(props.row)" style="font-size: 16px;"></i>
                                            </base-button>
                                        </el-popover>
                                        <div class="icons-container">
                                            <el-popover trigger="hover" content="Active campaigns" effect="light"
                                                placement="top">
                                                <span slot="reference" class="tag__custom cmpActive">
                                                    {{ props.row.campaign_active }}
                                                </span>
                                                <!-- <i class="iconcampaign cmpActive">{{props.row.campaign_active}}</i> -->
                                            </el-popover>
                                            <el-popover trigger="hover" content="Inactive campaigns"
                                                placement="top">
                                                <span slot="reference" class="tag__custom cmpPauseStop">
                                                    {{ props.row.campaign_not_active }}
                                                </span>
                                                <!-- <i
                                                    class="iconcampaign cmpPauseStop">{{props.row.campaign_not_active}}</i> -->
                                            </el-popover>
                                        </div>
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="140" align="center" label="Actions">
                                    <div slot-scope="props">
                                        <el-popover content="View as agency / client" placement="top-start" width="80" trigger="hover">
                                            <span slot="reference">
                                                <span  class="action cursor-pointer" href="javascript:void(0);">
                                                    <i class="fas fas fa-eye" @click="handleSwitchUser(props.row)"></i>
                                                </span>
                                            </span>
                                        </el-popover>
                                        <el-popover 
                                            v-if="props.row.company_id !== null && $global.hasVisibleIntegrations" 
                                            trigger="hover" 
                                            effect="light"
                                            content="Configure Client Integration Settings" 
                                            placement="top">
                                            <span slot="reference" size="sm" icon style="margin: 0 4px 0 10px">
                                                  <i class="fas fa-plug"
                                                  @click="handleIntegrationClick(props.$index, props.row)"></i>
                                            </span>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Download Agreement File" placement="top" v-if="props.row.company_agreement_file">
                                            <a slot="reference" @click="handleDownloadAgreementFile(props.row)" rel="noopener noreferrer">
                                                <base-button class="edit btn-link" type="neutral" size="xs">
                                                    <i v-if="!downloadingAgreements[props.row.id]" class="fas fa-file-pdf" style="color: green"></i>
                                                    <i v-else class="fas fa-spinner fa-spin" style="color: gray"></i>
                                                </base-button>
                                            </a>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Edit Client" placement="top">
                                            <base-button slot="reference" @click.native="rowClicked(props.row)" class="edit btn-link"
                                                type="neutral" size="sm" icon>
                                                <i class="fa-solid fa-pen-to-square" style="color:gray"></i>
                                            </base-button>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Client Level Exclusion List" effect="light" :open-delay="300"
                                            placement="top" v-if="props.row.company_id !== null">
                                            <base-button slot="reference" @click.native="showWhitelist(props.$index, props.row)"
                                                class="edit btn-link" type="warning" size="sm" icon>
                                                <i class="fas fa-align-slash" style="color:gray"></i>
                                            </base-button>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Default Client Financials" effect="light" :open-delay="300"
                                            placement="top">
                                            <base-button slot="reference" @click.native="handlePriceSet(props.$index, props.row)"
                                                class="edit btn-link" type="warning" size="sm" icon>
                                                <i class="fa-solid fa-dollar-sign" style="color:green"></i>
                                            </base-button>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Remove Client"
                                            placement="top">
                                            <!-- <base-button
                                                       
                                                        class="remove btn-link"
                                                        type="danger"
                                                        size="sm"
                                                        icon
                                                        >
                                                    </base-button> -->
                                                      <span slot="reference">
                                                             <i  v-if="$global.settingMenuShow_delete"
                                                             @click="handleDelete(props.$index, props.row)"
                                                            class="fa-solid fa-circle-x"></i>
                                                      </span>
                                            </el-popover>
                                    </div>
                                </el-table-column>

                                

                            </el-table>
                        </div>
                    </div>

                    <template slot="footer">
                        <div class="tab-footer pull-right">
                            <div class="pt-3">
                                <p class="card-category">
                                    Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }}
                                    entries
                                </p>
                            </div>
                            <base-pagination class="pagination-no-border pt-4" v-model="pagination.currentPage"
                                :per-page="pagination.perPage" :total="pagination.total" @input="changePage">
                            </base-pagination>
                        </div>
                    </template>

                </card>
            </div>
        </div>
        <!-- Modal Video Guide -->
        <modal :show.sync="modals.helpguide" headerClasses="justify-content-center" modalContentClasses="customhead">
            <h4 slot="header" class="title title-up">What is on Dashboard Menu?</h4>
            <p class="text-center">
                Watch the video below if you still have question please <a href="#">Contact Us</a>
            </p>
            <div>
                <!--<iframe width="970" height="415" src="https://www.youtube.com/embed/SCSDyqRP7cY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
            </div>
            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="modals.helpguide = false">Ok I already understand</base-button>
                </div>
            </template>
        </modal>
        <!-- Modal Video Guide -->

        <!-- Modal Card Setup -->
        <modal id="modalSetCard" :show.sync="modals.cardsetup" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Credit Card Setup for <span
                    style="color:#d42e66">{{LeadspeekCompany}}</span></h4>
            <!-- IF HAVE FAILED PAYMENT -->
            <div class="col-sm-12 col-md-12 col-lg-12 text-center" v-if="clientPaymentFailed">
                <p>Your account has outstanding invoices for these campaigns:</p>
                <ul style="width:40%;text-align:left;margin:0 auto">
                    <li style="color:#000" v-for="(item, index) in failedCampaignNumber" :key="index">
                        Campaign #{{ item }} total amount : {{ displayMoney(failedInvoiceAmount[index]) }}
                    </li>
                    <li class="pt-2 pb-2" style="list-style:none;margin-left:-95px;color:#000">The total outstanding
                        amount is <strong>{{ failedInvoiceTotal() }}</strong></li>
                </ul>
                <p>Please update your credit card information or retry the charge with your existing card. Thank you.
                </p>
            </div>
            <!-- IF HAVE FAILED PAYMENT -->

            <div class="row justify-content-center client__management__card__credit">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <ValidationObserver ref="formCC">
                        <form>

                            <!--START ADD / UPDATE FOR CC -->
                            <div id="card-element" class="col-sm-12 col-md-12 col-lg-12 card-border">&nbsp;</div>
                            <div class="pt-2 pl-2" v-if="cardfailetoload" style="font-size:0.80143rem"><i
                                    class="fas fa-sync-alt pr-2" @click="refreshCCfield();"
                                    style="cursor:pointer"></i>Failed to load the Credit Card field. Please <a
                                    href="javascript:void(0);" @click="refreshCCfield();" style="font-weight:bold">click
                                    here</a> to refresh and try again.</div>
                            <div id="carderror" class="col-sm-12 col-md-12 col-lg-12 pt-2 hide" style="color:red">
                                <small>&nbsp;</small>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <ValidationProvider name="Card Holder Name" rules="required"
                                    v-slot="{ passed, failed, errors }">
                                    <base-input v-model="cardholdername" label="Card Holder Name" :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <ValidationProvider name="Billing Address" rules="required"
                                    v-slot="{ passed, failed, errors }">
                                    <base-input v-model="billingaddress" label="Billing Address" :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                                <div class="country-region-select-wrapper">
                                    <span style="color: #525f7f;font-size: 14px;" class="country-label">Country *</span>
                                    <country-select style="color: #525f7f;border-color: #cad1d7;"
                                        class="country-region-select" v-model="selects.country"
                                        :country="selects.country" topCountry="US" />
                                    <span v-if="showErrorMessage && !selects.country">Please select country</span>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                                <div v-if="selects.country" class="country-region-select-wrapper">
                                    <span style="color: #525f7f;font-size: 14px;"
                                        class="country-label">{{selects.country === "CA" ?"Province *": "State*"}}</span>
                                    <region-select style="color: #525f7f;border-color: #cad1d7;"
                                        class="country-region-select" v-model="selects.state" :country="selects.country"
                                        :region="selects.state" />
                                    <span v-if="showErrorMessage && !selects.state">Please select state</span>
                                </div>
                            </div>
                            <div class="row pt-2 mr-0 ml-0">
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <ValidationProvider name="City" rules="required"
                                        v-slot="{ passed, failed, errors }">
                                        <base-input v-model="city" label="City" :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                                <!-- <div class="col-sm-4 col-md-4 col-lg-4">
                                                    <label>State</label>
                                                    <base-input>
                                                        <el-select
                                                        v-model="selects.state"
                                                        class="select-primary "
                                                        name="state"
                                                        inline
                                                        size="large"
                                                        filterable
                                                        default-first-option
                                                        >
                                                        <el-option
                                                            v-for="option in selects.statelist"
                                                            class="select-primary"
                                                            :label="option.state"
                                                            :value="option.state_code"
                                                            :key="option.state_code"
                                                        ></el-option>
                                                        </el-select>
                                                    </base-input>
                                                </div> -->
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <ValidationProvider name="Zip" rules="required" v-slot="{ passed, failed, errors }">
                                        <base-input v-model="zipcode" label="Zip" :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <!--START ADD / UDPATE FOR CC -->
                            <div class="pt-3 pb-3">&nbsp;</div>

                            <div class="col-sm-12 col-md-12 col-lg-12 ">
                                <card>
                                    <div slot="header">
                                        <h4 class="card-title">Your Current Card Information</h4>
                                    </div>
                                </card>
                            </div>


                            <div class="col-sm-12 col-md-12 col-lg-12 mr-0 ml-0">
                                <p class="text-title-wrapping" v-if="currCardHolder != ''">{{currCardHolder}}</p>
                                <p v-if="currCardlastdigit != ''">Card Number :
                                    &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                                    {{currCardlastdigit}}</p>
                                <p v-if="currCardType != ''">Card Type : {{currCardType}}</p>
                            </div>

                            <div class="pt-3 pb-3">&nbsp;</div>

                            <div class="col-sm-12 col-md-12 col-lg-12 ">
                                <base-checkbox v-model="agreeTerm" class="pull-left"
                                    :class="{'has-danger': agreeTermStat}">I attest that the client and credit card owner has agreed to the <a
                                        :href="'/service-billing-agreement/?src=client&host=' + termhost"
                                        target="_blank" style="color:#919aa3"
                                        :style="[agreeTermStat?{'color':'#ec250d'}:'']">Billing
                                        Terms and Service Agreement</a></base-checkbox>
                            </div>

                            <div class="row pt-2" style="width:100%; display: flex; justify-content: flex-end; gap: 10px;" v-if="!clientPaymentFailed">
                                <base-button v-if="selectedClientPaymentStatus === 'failed'" @click="clearPaymentStatusHandler();" id="btnClearPaymentStatus" size="sm"
                                    style="height:40px">
                                    Reactivate card
                                </base-button>
                                <base-button @click="validateCC('');" id="btnupdcc" size="sm"
                                    style="height:40px">
                                    Update
                                </base-button>
                            </div>
                            <div class="row pt-2" style="width:100%" v-if="clientPaymentFailed">

                                <div class="col-sm-6 col-md-6 col-lg-6 pl-4">
                                    <base-button @click="validateCC('existcard');" id="btnRetryExistCard" size="sm"
                                        class="pull-right" style="height:50px">
                                        Retry charge with existing card
                                    </base-button>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6 pr-0">
                                    <base-button @click="validateCC('updatecharge');" id="btnUpdateAndCharge" size="sm"
                                        class="pull-right" style="height:50px">
                                        save and charge amount due
                                    </base-button>
                                </div>
                            </div>

                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </modal>
        <!-- Modal Card Setup -->

        <!-- Card Update Modal -->
        <modal :show.sync="modals.cardupdate" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Card Information</h4>
            <p>
                Thank you! Your Credit Card Information Has been updated.
            </p>
            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="closebtnupdatecard()">Ok</base-button>
                </div>
            </template>
        </modal>
        <!-- Card Update Modal -->

        <!-- Card retry charge Modal -->
        <modal :show.sync="modals.cardretrycharge" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">{{cardretrychargeTitle}}</h4>
            <p class="text-center" v-html="cardretrychargeTxt">

            </p>
            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="closebtnupdatecard()">Ok</base-button>
                </div>
            </template>
        </modal>

        <!-- Modal Setting Markup -->
        <modal id="modalSetPrice" :show.sync="modals.pricesetup" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up text-title-wrapping">Set Campaign pricing for <span
                    style="color:#d42e66">{{LeadspeekCompany}}</span></h4>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="row" style="padding-inline: 16px; margin-bottom: 24px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                        <div v-if="moduleAgency.local != undefined" @click="selectsAppModule.AppModuleSelect = 'LeadsPeek'" 
                        style="flex: 1; display: flex; justify-content: center;"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'LeadsPeek' ? 'active__menu__prices' : '']">
                        {{ this.$global.globalModulNameLink.local.name }}
                        </div>
                        <div v-if="moduleAgency.locator != undefined" @click="selectsAppModule.AppModuleSelect = 'locator'" 
                        style="flex: 1; display: flex; justify-content: center;"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'locator' ? 'active__menu__prices' : '']">
                            {{ this.$global.globalModulNameLink.locator.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.enhance.name != null && this.$global.globalModulNameLink.enhance.url != null && moduleAgency.enhance != undefined" 
                        @click="selectsAppModule.AppModuleSelect = 'enhance'" 
                        class="menu__prices"  
                        :class="[selectsAppModule.AppModuleSelect === 'enhance' ? 'active__menu__prices' : '']" 
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.enhance.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.b2b.name != null && this.$global.globalModulNameLink.b2b.url != null && moduleAgency.b2b != undefined && validateBetaFeature('b2b_module')" 
                        @click="selectsAppModule.AppModuleSelect = 'b2b'" 
                        class="menu__prices"  
                        :class="[selectsAppModule.AppModuleSelect === 'b2b' ? 'active__menu__prices' : '']" 
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.b2b.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.simplifi.name != null && this.$global.globalModulNameLink.simplifi.url != null && moduleAgency.simplifi != undefined && validateBetaFeature('simplifi_module') && this.$global.idsys == this.$global.masteridsys" 
                        @click="selectsAppModule.AppModuleSelect = 'simplifi'" 
                        class="menu__prices"  
                        :class="[selectsAppModule.AppModuleSelect === 'simplifi' ? 'active__menu__prices' : '']" 
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.simplifi.name }}
                        </div>
                        <div style="width: 100%; border: 1px solid gray; height: 1px; margin-top: 16px;"></div>
                    </div>
                    <div v-if="selectsAppModule.AppModuleSelect != 'simplifi'" class="d-flex flex-column" style="margin-bottom:16px;">
                        <span class="client-payment-modal-form-label" style="color:#222a42">Billing Frequency</span>
                        <el-select class="select-primary" size="small" placeholder="Select Modules"
                            v-model="selectsPaymentTerm.PaymentTermSelect" @change="paymentTermChange()">
                            <el-option v-for="option in selectsPaymentTerm.PaymentTerm" class="select-primary"
                                :value="option.value" :label="option.label" :key="option.label">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div v-if="selectsAppModule.AppModuleSelect == 'LeadsPeek' && moduleAgency.local != undefined">
                <div class="client-payment-setup-form-wrapper">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Setup Fee
                            </div>
                            <div>
                                <base-input key="leadspeek-setupfee-edit" label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LeadspeekPlatformFee"
                                    @keyup="set_fee('local','LeadspeekPlatformFee');"
                                    @blur="handleFormatCurrency('local','LeadspeekPlatformFee')"
                                    @keydown="restrictInput"  
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekPlatformFee }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Campaign Fee <span v-html="txtLeadService">per month</span>
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LeadspeekMinCostMonth"
                                    @keyup="set_fee('local','LeadspeekMinCostMonth');"
                                    @blur="handleFormatCurrency('local','LeadspeekMinCostMonth')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekMinCostMonth }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6" v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the monthly charge</span>? (Basic)
                                <sup>
                                    <el-popover
                                        trigger="hover"
                                        :content="helpContentMap[1].desc"
                                        placement="top"
                                        popper-class="tooltip-content"
                                    >
                                    <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                    </el-popover>
                                </sup>
                                <!-- <sup>
                                    <span style="cursor: pointer; font-size: 12px;"><i @click="openHelpModal(1)" class="fa fa-question-circle"></i></span>
                                </sup> -->
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LeadspeekCostperlead"
                                    @keyup="set_fee('local','LeadspeekCostperlead');"
                                    @blur="handleFormatCurrency('local','LeadspeekCostperlead')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekCostPerLead }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the monthly charge</span>? (Advanced)
                                <sup>
                                    <el-popover
                                        trigger="hover"
                                        :content="helpContentMap[2].desc"
                                        placement="top"
                                        popper-class="tooltip-content"
                                    >
                                    <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                    </el-popover>
                                </sup>
                                <!-- <sup>
                                    <span style="cursor: pointer; font-size: 12px;"><i @click="openHelpModal(2)" class="fa fa-question-circle"></i></span>
                                </sup> -->
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LeadspeekCostperleadAdvanced"
                                    @keyup="set_fee('local','LeadspeekCostperleadAdvanced');"
                                    @blur="handleFormatCurrency('local','LeadspeekCostperleadAdvanced')"
                                    @keydown="restrictInput"  
                                    @copy.prevent @cut.prevent @paste.prevent>
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your advanced price for cost per contact $<span>{{ m_LeadspeekCostPerLeadAdvanced }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                <el-checkbox v-model="LeadspeekEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('local')">Enable Minimum Contact Per Day</el-checkbox>
                            </div>
                            <div class="client-payment-modal-form-label">
                                How many contacts per day does the client want to receive?
                            </div>
                            <div>
                                <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                    class="campaign-cost-input" v-model="LeadspeekLeadsPerday"
                                    @keyup="set_fee('local','LeadspeekLeadsPerday');"
                                    @input="event => onInput(event, 'LeadspeekLeadsPerday')"
                                    @blur="handleFormatCurrency('local','LeadspeekLeadsPerday')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="selectsAppModule.AppModuleSelect == 'locator' && moduleAgency.locator != undefined">
                <div class="client-payment-setup-form-wrapper">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Setup Fee
                            </div>
                            <div>
                                <base-input key="locator-setupfee-edit" label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LocatorPlatformFee"
                                    @keyup="set_fee('locator','LocatorPlatformFee');"
                                    @blur="handleFormatCurrency('locator','LocatorPlatformFee')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekLocatorPlatformFee }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Campaign Fee <span v-html="txtLeadService">per month</span>
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LocatorMinCostMonth"
                                    @keyup="set_fee('locator','LocatorMinCostMonth');"
                                    @blur="handleFormatCurrency('locator','LocatorMinCostMonth')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekLocatorMinCostMonth }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6" v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                    monthly charge</span>?
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LocatorCostperlead"
                                    @keyup="set_fee('locator','LocatorCostperlead');"
                                    @blur="handleFormatCurrency('locator','LocatorCostperlead')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekLocatorCostPerLead }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                <el-checkbox v-model="LocatorEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('locator')">Enable Minimum Contact Per Day</el-checkbox>
                            </div>
                            <div class="client-payment-modal-form-label">
                                How many contacts per day does the client want to receive?
                            </div>
                            <div>
                                <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                    class="campaign-cost-input" v-model="LocatorLeadsPerday"
                                    @keyup="set_fee('locator','LocatorLeadsPerday');"
                                    @input="event => onInput(event, 'LocatorLeadsPerday')"
                                    @blur="handleFormatCurrency('locator','LocatorLeadsPerday')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div v-if="selectsAppModule.AppModuleSelect == 'enhance' && moduleAgency.enhance != undefined">
                <div class="client-payment-setup-form-wrapper">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Setup Fee
                            </div>
                            <div>
                                <base-input key="enhance-setupfee-edit" label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input"  v-model="EnhancePlatformFee"    
                                    @keyup="set_fee('enhance','EnhancePlatformFee');"
                                    @blur="handleFormatCurrency('enhance','EnhancePlatformFee')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekEnhancePlatformFee }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6"  >
                            <div class="client-payment-modal-form-label">
                                Campaign Fee <span v-html="txtLeadService">per month</span>
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="EnhanceMinCostMonth"
                                    @keyup="set_fee('enhance','EnhanceMinCostMonth');"
                                    @blur="handleFormatCurrency('enhance','EnhanceMinCostMonth')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekEnhanceMinCostMonth }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6" 
                            v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                    monthly charge</span>?
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="EnhanceCostperlead"
                                    @keyup="set_fee('enhance','EnhanceCostperlead');"
                                    @blur="handleFormatCurrency('enhance','EnhanceCostperlead')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekEnhanceCostPerLead }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                <el-checkbox v-model="EnhanceEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('enhance')">Enable Minimum Contact Per Day</el-checkbox>
                            </div>
                            <div class="client-payment-modal-form-label">
                                How many contacts per day does the client want to receive?
                            </div>
                            <div>
                                <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                    class="campaign-cost-input" v-model="EnhanceLeadsPerday"
                                    @keyup="set_fee('enhance','EnhanceLeadsPerday');"
                                    @input="event => onInput(event, 'EnhanceLeadsPerday')"
                                    @blur="handleFormatCurrency('enhance','EnhanceLeadsPerday')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                            </div>
                            <span v-if="errMinLeadDay" style="color:#942434; font-size:12px;font-weight: 400;line-height: 12px;margin-top: 4px;display: block;">*contacts Per Day Minimum {{ clientMinLeadDayEnhance }}</span>
                        </div>
                    </div>

                </div>

            </div>
            
            <div v-if="selectsAppModule.AppModuleSelect == 'b2b' && moduleAgency.b2b != undefined && validateBetaFeature('b2b_module')">
                <div class="client-payment-setup-form-wrapper">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Setup Fee
                            </div>
                            <div>
                                <base-input key="b2b-setupfee-edit" label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input"  v-model="B2bPlatformFee"    
                                    @keyup="set_fee('b2b','B2bPlatformFee');"
                                    @blur="handleFormatCurrency('b2b','B2bPlatformFee')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekB2BPlatformFee }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6"  >
                            <div class="client-payment-modal-form-label">
                                Campaign Fee <span v-html="txtLeadService">per month</span>
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="B2bMinCostMonth"
                                    @keyup="set_fee('b2b','B2bMinCostMonth');"
                                    @blur="handleFormatCurrency('b2b','B2bMinCostMonth')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekB2BMinCostMonth }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6" 
                            v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                    monthly charge</span>?
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="B2bCostperlead"
                                    @keyup="set_fee('b2b','B2bCostperlead');"
                                    @blur="handleFormatCurrency('b2b','B2bCostperlead')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekB2BCostPerLead }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                <el-checkbox v-model="B2bEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('b2b')">Enable Minimum Contact Per Day</el-checkbox>
                            </div>
                            <div class="client-payment-modal-form-label">
                                How many contacts per day does the client want to receive?
                            </div>
                            <div>
                                <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                    class="campaign-cost-input" v-model="B2bLeadsPerday"
                                    @keyup="set_fee('b2b','B2bLeadsPerday');"
                                    @input="event => onInput(event, 'B2bLeadsPerday')"
                                    @blur="handleFormatCurrency('b2b','B2bLeadsPerday')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                            </div>
                            <span v-if="errMinLeadDay" style="color:#942434; font-size:12px;font-weight: 400;line-height: 12px;margin-top: 4px;display: block;">*Leads Per Day Minimum {{ clientMinLeadDayEnhance }}</span>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="selectsAppModule.AppModuleSelect == 'simplifi' && moduleAgency.simplifi != undefined && validateBetaFeature('simplifi_module') && this.$global.idsys == this.$global.masteridsys">
                <div class="client-payment-setup-form-wrapper">
                    <div class="row">
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <div class="client-payment-modal-form-label">
                                Max Bid
                            </div>
                            <div>
                                <base-input 
                                    key="simplifi-maxbid-edit"
                                    label="" 
                                    type="text" 
                                    placeholder="0" 
                                    addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input"
                                    :class="{'error-input-price-simplifi': simplifiErrorInput.maxBid}" 
                                    v-model="SimplifiMaxBid"    
                                    @keyup="set_fee('simplifi','SimplifiMaxBid');"
                                    @blur="handleFormatCurrency('simplifi','SimplifiMaxBid')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent>
                                    <template #addonRight>
                                        <span class="input-group-text cpm-remove-border">CPM</span>
                                    </template>
                                </base-input>
                                <span v-if="simplifiErrorInput.maxBid" v-html="simplifiErrorInput.maxBid" class="error-message-price-simplifi"></span>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <div class="client-payment-modal-form-label">
                                Daily Budget
                            </div>
                            <div>
                                <base-input 
                                    label="" 
                                    type="text" 
                                    placeholder="0" 
                                    addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="SimplifiDailyBudget"
                                    :class="{'error-input-price-simplifi': simplifiErrorInput.dailyBudget}" 
                                    @keyup="set_fee('simplifi','SimplifiDailyBudget');"
                                    @blur="handleFormatCurrency('simplifi','SimplifiDailyBudget')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent>
                                </base-input>
                                <span v-if="simplifiErrorInput.dailyBudget" v-html="simplifiErrorInput.dailyBudget" class="error-message-price-simplifi"></span>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <div class="client-payment-modal-form-label">
                                Agency Profit Margin
                            </div>
                            <div>
                                <el-select class="select-primary" style="width: 100%;" size="large" placeholder="Select Modules" v-model="SimplifiAgencyMarkup" @change="set_fee('simplifi','SimplifiAgencyMarkup');">
                                    <el-option v-for="markup in agencyMarkup.list" :value="markup.value" :label="markup.text" :key="markup.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template slot="footer">
                <div class="d-flex justify-content-center w-100 pb-4">
                    <base-button :disabled="isLoadingClientFinancials" @click.native="save_default_price()">
                      Ok, Set It Up! <i v-if="isLoadingClientFinancials" class="fas fa-spinner fa-spin ml-1" style="font-size: 16px;"></i>
                   </base-button>
                </div>
            </template>
        </modal>
        <!-- Modal Setting Markup -->

        <!-- Modal integration settings -->
        <modal :show.sync="modals.integrations" id="addIntegrations"
            footerClasses="border-top">
            <h3 slot="header" class="title title-up text-title-wrapping">Integration Settings for {{ selectedRowData.company_name }}</h3>
            
            <div>
                <div v-if="integrationStatus.loading">
                    <i class="fas fa-spinner fa-spin" style="font-size: 24px;"></i>
                </div>
                <div v-else-if="integrationStatus.error" class="error-banner">Oops! Something went wrong. Please refresh the page and try again.</div>
                <div v-else-if="$global.hasVisibleIntegrations" class="integratios-list-wrapper d-flex align-items-center gap-4 flex-wrap">
                    <div v-for="item in integrations" :key="item.slug"
                        class="integrations__modal-item-wrapper d-flex align-items-center justify-content-center shadow-sm border"
                        :class="{ '--active bg-blue text-secondary': item.slug === selectedIntegration }"
                        @click="handleIntegrationItemClick(item)">
                        <div class="integrations__modal-item">
                            <span v-if="item.slug === 'gohighlevel' && enabledconntector.gohighlevel"class="check-icon">✔</span>
                            <span v-if="item.slug === 'sendgrid' && enabledconntector.sendgrid"class="check-icon">✔</span>
                            <span v-if="item.slug === 'mailboxpower' && enabledconntector.mailboxpower"class="check-icon">✔</span>
                            <span v-if="item.slug === 'zapier' && enabledconntector.zapier" class="check-icon">✔</span>
                            <span v-if="item.slug === 'kartra' && enabledconntector.kartra"class="check-icon">✔</span>
                            <span v-if="item.slug === 'sendjim' && enabledconntector.sendjim"class="check-icon">✔</span>
                            <span v-if="item.slug === 'agencyzoom' && enabledconntector.agencyzoom"class="check-icon">✔</span>
                            <span v-if="item.slug === 'clickfunnels' && enabledconntector.clickfunnels"class="check-icon">✔</span>
                            <img
                                v-if="item.custom_img"
                                class="logo-wrap-client-management"
                                :src="item.custom_img"
                                alt="brand-logo"
                            />
                            <i v-else :class="item.custom_icon || item.icon" style="font-size: 36px;"></i>
                            <span class="integrarion-brand-name" style="text-align: center;">{{ item.custom_name || item.name }}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="text-center p-4">
                    <p>No integrations available.</p>
                </div>
                <div class="mt-4">
                    <div v-if="isIntegrationItemsFetch" class="row" v-loading="true" id="loading"></div>
                    <div v-else>
                        <div v-if="selectedIntegration === 'gohighlevel'" class="''">
                            <el-checkbox v-model="enabledconntector.gohighlevel">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="d-flex" style="flex-direction: column; gap: 12px; margin-top: 25px" v-if="referralCodeActive != ''">
                               <span style="display: flex; align-items: center;gap: 8px">
                                <el-button
                                    size="medium"
                                    icon="el-icon-unlock"
                                    @click="redirectToLink(`https://www.gohighlevel.com/?fp_ref=${referralCodeActive}`)"
                                    circle
                                 
                                    ></el-button> <span>If you do not have a {{ nameActiveIntegration }} account, <a style="color: inherit !important;font-size: inherit;font-weight: bold;" :href="`https://www.gohighlevel.com/?fp_ref=${referralCodeActive}`" target="_blank">Click Here</a> to create one</span>
                                </span>
                            </div>
                            <div class="has-label" style="margin-top: 20px; margin-bottom: 35px;">
                                <el-tabs type="border-card" v-model="integrationVersion.gohighlevel">
                                    <el-tab-pane name="2">
                                        <span slot="label">Full Integration</span>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div style="margin-left: 4px;">
                                                    <p v-if="ghlV2Connected">You Have Connected Contact Sync For This Client</p>
                                                    <p v-else>You Have Not Yet Connected Contact Sync For This Client</p>
                                                </div>
                                                <div :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { marginTop: '10px' } : {}">
                                                    <base-button id="btnConnectDisconnectGhlv2" :disabled="isLoadingConnectDisconnectGhlv2" @click="connectDisconnectGhlv2">
                                                        {{ btnConnectDisconnectGhlv2Text }}
                                                        <i v-if="isLoadingConnectDisconnectGhlv2" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                                    </base-button>
                                                </div>
                                            </div>
                                            <div class="col-md-6 divider-ghl2" v-if="ghlV2AgencyConnected && this.$global.idsys == this.$global.masteridsys">
                                                <div style="margin-left: 4px;">
                                                    <p v-if="ghlV2CreatedIframe">You Have Created a Single Sign On Link For This Client</p>
                                                    <p v-else>You Have Not Yet Created a Single Sign On Link For This Client</p>
                                                </div>
                                                <div style="display: flex; justify-content: space-between; align-items: center; gap: 16px;">
                                                    <div :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { width: '100%' } : {}">
                                                        <base-button :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { width: '100%' } : {}" id="btnCreateDeleteIframeGhlv2Text" @click="createDeleteIframeGhlv2" :disabled="isLoadingCreateDeleteIframeGhlV2">
                                                            {{ btnCreateDeleteIframeGhlv2Text }}
                                                            <i v-if="isLoadingCreateDeleteIframeGhlV2" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                                        </base-button>
                                                    </div>
                                                    <div style="width: 100%;" class="form-group has-label" v-if="!ghlV2CreatedIframe && ghlV2AgencyConnected && this.$global.idsys == this.$global.masteridsys">
                                                        <el-select
                                                            style="width: 100%; margin-top: 10px;"
                                                            class="select-primary"
                                                            size="large"
                                                            placeholder="Select Client"
                                                            filterable
                                                            default-first-option
                                                            v-model="selects.ghlv2SubAccount"
                                                            @visible-change="visible => onSelectGhlV2SubAccountVisible(visible, 'edit')"
                                                            ref="selectGhlV2SubAccountEdit">
                                                            <el-option
                                                                v-for="item in ghlV2ListSubAccounts"
                                                                class="select-primary"
                                                                :value="item.id"
                                                                :label="item.name"
                                                                :key="item.id">
                                                            </el-option>
                                                            <el-option v-if="paginationGhlV2SubAccount.isFetch && !paginationGhlV2SubAccount.isComplete" value="loading" label="Loading...." disabled>
                                                            </el-option>
                                                        </el-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane name="1">
                                        <span slot="label">API Only</span>
                                        <label class="mb-0">Enter your API Key</label>
                                        <el-input type="text" clearable label="Enter your API Key" placeholder="AssAW02A02ksjsklah"
                                            class="flex-grow-1 mb-0" v-model="userApiKey.gohighlevel" aria-controls="datatables">
                                        </el-input>                    
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <template>
                                <CheckboxCustomFields
                                    :slug="'Gohighlevel'"
                                    :isLoadingCustomFieldsBySlug="isLoadingCustomFieldsBySlug"
                                    :isErrorCustomFieldsBySlug="isErrorCustomFieldsBySlug"
                                    :handleDefaultCustomFields="handleDefaultCustomFields"
                                    :customFieldsBySlug="customFieldsBySlug['gohighlevel']"
                                    :listValueFieldsIntegration="listValueFieldsIntegrationGohighlevel"
                                    :listValueFieldsIntegrationB2b="listValueFieldsIntegrationGohighlevelb2b"
                                    :listValueFieldsIntegrationAdvance="listValueFieldsIntegrationGohighleveladvance"
                                    :handleCheckItemCustomFields="handleCheckItemCustomFields"
                                    :isHideB2b="isHideB2b"
                                    :isHideAdvance="isHideAdvance"
                                    :handleCheckAllCustomFields="handleCheckAllCustomFields"
                                    :isCheckAllIntegrationGeneral="isCheckAllIntegrationGeneral"
                                    :isCheckAllIntegrationB2b="isCheckAllIntegrationB2b"
                                    :isCheckAllIntegrationAdvance="isCheckAllIntegrationAdvance"
                                />
                            </template>
                            <!-- <el-divider content-position="left">Custom Fields</el-divider>
                            <div class="checkbox-field-integration">
                                <div v-for="(item, index) in customFieldsBySlug['gohighlevel']" :key="index">
                                    <el-checkbox :label="item" v-model="listValueFieldsIntegrationGohighlevel">{{item}}</el-checkbox>
                                </div>
                            </div> -->
                        </div>
                        <div v-if="selectedIntegration === 'sendgrid'" class="''">
                            <el-checkbox v-model="enabledconntector.sendgrid">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mt-1">Enter your API Key</label>
                                <el-input type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
                                    class="flex-grow-1 mb-0" v-model="userApiKey.sendgrid" aria-controls="datatables">
                                </el-input>
    
                            </div>
    
    
                        </div>
                        <div v-if="selectedIntegration === 'kartra'" class="''">
                            <el-checkbox v-model="enabledconntector.kartra">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mt-1">Enter your API Key</label>
                                <el-input type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
                                    class="flex-grow-1 mb-0" v-model="userApiKey.kartra" aria-controls="datatables">
                                </el-input>
    
                            </div>
                            <div class="has-label">
                                <label class="mb-0">Enter your API Password</label>
                                <el-input type="text" clearable label="Enter your API Password"
                                    placeholder="GJYEzzse345673htj" class="flex-grow-1 mb-0" v-model="kartraApiPassword"
                                    aria-controls="datatables">
                                </el-input>
    
                            </div>
                            <!-- <div class="has-label">
                                <label class="mb-0">Enter your App ID</label>
                                <el-input type="text" clearable label="Enter your App ID"
                                     placeholder="GJYEzzse345673htj" class="flex-grow-1 mb-0" v-model="kartraAppId" aria-controls="datatables">
                                </el-input>
    
                            </div> -->
    
    
                            <p class="mt-4 d-block"><strong>Note:</strong> When you click Save, this app will create the
                                below custom fields in your Kartra account. These fields are Required for this connection to
                                work properly.
                                As per Kartra's policy, once a custom field is deleted, it cannot be recreated. Therefore,
                                <span class="text-underline">Do NOT</span> delete or rename the below custom fields in your
                                Kartra account. <strong style="cursor: pointer;" v-if="!showKartraCustomFields"
                                    @click="showKartraCustomFields = !showKartraCustomFields">show more</strong>
                            </p>
    
                            <ul v-show="showKartraCustomFields" class="text-dark">
                                <li class="text-dark">secondphone</li>
                                <li class="text-dark">secondemail</li>
                                <li class="text-dark">keyword</li>
                                <li class="text-dark">secondaddress</li>
                            </ul>
                        </div>
                        <div v-if="selectedIntegration === 'zapier'" class="''">
                            <div class="webhook-section">
                                <div class="webhook-section__header">
                                    <div>
                                        <h5 class="webhook-section__title">Zapier Webhooks</h5>
                                        <p class="webhook-section__subtitle">
                                            Connect one or more Zapier webhook URLs to receive lead data in real time.
                                        </p>
                                    </div>
                                    <el-checkbox v-model="enabledconntector.zapier">Enable {{ nameActiveIntegration }}</el-checkbox>
                                </div>

                                    <div class="webhook-section__body">
                                        <label class="webhook-section__label">Webhook URLs</label>
                                        <p class="webhook-section__helper">
                                            You can add multiple webhook URLs. Each URL will receive the same payload.
                                        </p>

                                        <div class="webhook-list">
                                            <div
                                                v-for="(url, index) in userApiKey.zapier"
                                                :key="index"
                                                class="webhook-item"
                                            >
                                                <div class="webhook-item__main">
                                                    <span class="webhook-item__badge">
                                                        {{ index + 1 }}
                                                    </span>
                                                    <div class="webhook-item__fields">
                                                        <el-input
                                                            type="text"
                                                            clearable
                                                            label="Enter your Webhook URL"
                                                            placeholder="https://hooks.app.com/hooks/catch/....."
                                                            class="webhook-item__input"
                                                            v-model="userApiKey.zapier[index]"
                                                            aria-controls="datatables"
                                                            @keyup.native="addWebhookUrlKeyupEnter($event, 'zapier')"
                                                            :ref="'webhookInput-' + index"
                                                        >
                                                        </el-input>
                                                        <el-input
                                                            type="text"
                                                            clearable
                                                            placeholder="Webhook Label (optional)"
                                                            class="webhook-item__label-input"
                                                            v-model="zapierWebhookLabels[index]"
                                                        >
                                                        </el-input>
                                                    </div>
                                                </div>
                                            <div class="webhook-item__actions">
                                                <el-button
                                                    v-if="index !== 0 || userApiKey.zapier.length > 1"
                                                    type="text"
                                                    size="mini"
                                                    @click="removeWebhookUrl(index, 'zapier')"
                                                >
                                                    <i class="fa-solid fa-minus mr-1"></i> Remove
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="webhook-section__footer">
                                        <el-button
                                            type="primary"
                                            size="mini"
                                            icon="el-icon-plus"
                                            @click="addWebhookUrl('zapier')"
                                        >
                                            Add Webhook URL
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex mt-4">
                                <el-checkbox  v-model="enabledconntector.sendTestZapier" class="mt-2 mr-3">Send Test Data</el-checkbox>
                                   <div class="d-flex align-items-center">
                                    <el-button
                                        class="mr-2 mb-1"
                                        :icon="'el-icon-view'"
                                        @click="onViewExampleData"
                                        style="width: 10px; height: 10px; padding: 0; background-color: transparent; color: var(--text-primary-color); border: none;"></el-button>
                                        <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                                    </div>
                            </div>
                            <p class="m-0"><small>* check and click save to send dummy data to your webhook</small></p>
                            <p class="m-0 pl-2"><strong>Need help setting up your webhook?</strong> Check out the documentation:</p>
                            <p class="m-0 pl-2"><a href="https://api.slack.com/messaging/webhooks" target="_blank">Slack</a> | <a href="https://developers.make.com/custom-apps-documentation/app-structure/modules/instant-trigger" target="_blank">Make</a> | <a href="https://help.zapier.com/hc/en-us/articles/8496083355661-How-to-get-started-with-Webhooks-by-Zapier" target="_blank">Zapier</a> | <a href="https://www.pabbly.com/beginners-guide-to-webhook-integration-with-pabbly-connect/" target="_blank">Pabbly</a> | <a href="https://www.zoho.com/developer/help/extensions/automation/webhooks.html" target="_blank">ZoHo</a> | <a href="https://developers.hubspot.com/docs/guides/api/app-management/webhooks" target="_blank">HubSpot</a></p>
                        </div>
                        <div v-if="selectedIntegration === 'mailboxpower'" class="''">
                            <el-checkbox v-model="enabledconntector.mailboxpower">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mt-1">Enter your API Key</label>
                                <el-input type="text" clearable label="Enter your API Key" placeholder="AssAW02A02ksjsklah"
                                    class="flex-grow-1 mb-0" v-model="userApiKey.mailboxpower" aria-controls="datatables">
                                </el-input>
    
                            </div>
                            <div class="d-flex" style="flex-direction: column; gap: 12px; margin-top: 25px" v-if="referralCodeActive != ''">
                               <span style="display: flex; align-items: center;gap: 8px">
                                <el-button
                                    size="medium"
                                    icon="el-icon-unlock"
                                    @click="redirectToLink(`https://app.mailboxpower.com/join/agency?invite=${referralCodeActive}`)"
                                    circle
                                 
                                    ></el-button> <span>If you do not have a {{ nameActiveIntegration }} account, <a style="color: inherit !important;font-size: inherit;font-weight: bold;" :href="`https://app.mailboxpower.com/join/agency?invite=${referralCodeActive}`" target="_blank">Click Here</a> to create one</span>
                                </span>
                                <span style="display: flex; align-items: center;gap: 8px">
                                <el-button
                                    size="medium"
                                    icon="el-icon-s-promotion"
                                    @click="redirectToLink(`https://app.mailboxpower.com/demo/${referralCodeActive}`)"
                                    circle
                                    ></el-button> 
                                <a style="color: inherit !important;font-size: inherit;font-weight: inherit" class="d-block" :href="`https://app.mailboxpower.com/demo/${referralCodeActive}`" target="_blank">Learn More about the Integration</a>
                            </span>
                            </div>
                            
    
    
                        </div>
                        <div v-if="selectedIntegration === 'clickfunnels'" style="display: flex; flex-direction: column; gap: 8px;">
                            <el-checkbox v-model="enabledconntector.clickfunnels">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mb-0">Enter your API Key</label>
                                <el-input type="text" clearable label="Enter your API Key" placeholder="Xg7Pq-K9vTzJ_OLmAB3cYRDx5WNF24sMEUhCo6J0VaI"
                                class="flex-grow-1 mb-0" v-model="userApiKey.clickfunnels" aria-controls="datatables">
                            </el-input>
                            </div>
                            <div class="has-label">
                                <label class="mb-0">Subdomain</label>
                                <el-input v-model="clickfunnels.subdomain" type="text" clearable label="Enter your subdomain"
                                    placeholder="richstone" class="flex-grow-1 mb-0"
                                    aria-controls="datatables">
                                    <template :slot="windowWidth > 576 && 'prepend'">https://</template>
                                    <template :slot="windowWidth > 576 && 'append'">.myclickfunnels.com</template>
                                </el-input>
                                <small v-if="windowWidth < 576" class="wrap-text">Example: https://{{ clickfunnels.subdomain ? clickfunnels.subdomain : 'yoursubdomain' }}.myclickfunnels.com</small>
                            </div>
                            <div class="has-label">
                                <label class="mb-0">Workspace ID</label>
                                <el-input v-model="clickfunnels.workspaceId" type="text" clearable label="Enter your workspaces"
                                    placeholder="jWMWXZ" class="flex-grow-1 mb-0"
                                    aria-controls="datatables">
                                    <template :slot="windowWidth > 768 && 'prepend'">https://{{ clickfunnels.subdomain }}.myclickfunnels.com/account/workspaces/</template>
                                </el-input>
                                <small v-if="windowWidth < 768" class="wrap-text">Example: https://{{ clickfunnels.subdomain ? clickfunnels.subdomain : 'yoursubdomain' }}.myclickfunnels.com/account/workspaces/workspaceid</small>
                            </div>
    
                            <template>
                                <CheckboxCustomFields
                                    :slug="'Clickfunnels'"
                                    :isLoadingCustomFieldsBySlug="isLoadingCustomFieldsBySlug"
                                    :isErrorCustomFieldsBySlug="isErrorCustomFieldsBySlug"
                                    :handleDefaultCustomFields="handleDefaultCustomFields"
                                    :customFieldsBySlug="customFieldsBySlug['clickfunnels']"
                                    :listValueFieldsIntegration="listValueFieldsIntegrationClickfunnels"
                                    :listValueFieldsIntegrationB2b="listValueFieldsIntegrationClickfunnelsb2b"
                                    :handleCheckItemCustomFields="handleCheckItemCustomFields"
                                    :isHideB2b="isHideB2b"
                                    :isHideAdvance="isHideAdvance"
                                    :handleCheckAllCustomFields="handleCheckAllCustomFields"
                                    :isCheckAllIntegrationGeneral="isCheckAllIntegrationGeneral"
                                    :isCheckAllIntegrationB2b="isCheckAllIntegrationB2b"
                                    :isCheckAllIntegrationAdvance="isCheckAllIntegrationAdvance"
                                />
                            </template>
                        </div>
                        <div v-if="selectedIntegration === 'agencyzoom'" class="''">
                            <div class="webhook-section">
                                <div class="webhook-section__header">
                                    <div>
                                        <h5 class="webhook-section__title">AgencyZoom Webhooks</h5>
                                        <p class="webhook-section__subtitle">
                                            Enter one or more AgencyZoom webhook URLs to push leads into your AgencyZoom account.
                                        </p>
                                    </div>
                                    <el-checkbox v-model="enabledconntector.agencyzoom">Enable {{ nameActiveIntegration }}</el-checkbox>
                                </div>

                                <div class="webhook-section__body">
                                    <label class="webhook-section__label">Webhook URLs</label>
                                    <p class="webhook-section__helper">
                                        You can add multiple webhook URLs if needed.
                                    </p>

                                    <div class="webhook-list">
                                        <div
                                            v-for="(url, index) in userApiKey.agencyzoom"
                                            :key="index"
                                            class="webhook-item"
                                        >
                                            <div class="webhook-item__main">
                                                <span class="webhook-item__badge">
                                                    {{ index + 1 }}
                                                </span>
                                                <el-input
                                                    type="text"
                                                    clearable
                                                    label="Enter your Webhook URL"
                                                    placeholder="https://app.agencyzoom.com/v1/api/lead/webhook/....."
                                                    class="webhook-item__input"
                                                    v-model="userApiKey.agencyzoom[index]"
                                                    aria-controls="datatables"
                                                    @keyup.native="addWebhookUrlKeyupEnter($event, 'agencyzoom')"
                                                    :ref="'zoomAgencywebhookInput-' + index"
                                                >
                                                </el-input>
                                            </div>
                                            <div class="webhook-item__actions">
                                                <el-button
                                                    v-if="index !== 0 || userApiKey.agencyzoom.length > 1"
                                                    type="text"
                                                    size="mini"
                                                    @click="removeWebhookUrl(index, 'agencyzoom')"
                                                >
                                                    <i class="fa-solid fa-minus mr-1"></i> Remove
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="webhook-section__footer">
                                        <el-button
                                            type="primary"
                                            size="mini"
                                            icon="el-icon-plus"
                                            @click="addWebhookUrl('agencyzoom')"
                                        >
                                            Add Webhook URL
                                        </el-button>
                                    </div>
                                </div>

                                <div class="webhook-section__extras">
                                    <el-checkbox v-model="enabledconntector.sendTestAgencyZoom" class="mt-2">Send Test Data</el-checkbox>
                                    <p class="m-0"><small>* check and click save to send dummy data to your webhook</small></p>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedIntegration === 'sendjim'" class="''">
                            <el-checkbox v-model="enabledconntector.sendjim">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label" style="margin-top: 10px; margin-bottom: 20px;">
                                <p v-if="sendjimConnected">You have connected SendJim for this client.</p>
                                <p v-else>You have not yet connected SendJim for this client.</p>
                            </div>
                            <div>
                                <base-button id="btnConnectDisconnectSendjim" :disabled="isLoadingConnectDisconnectSendjim" @click="connectDisconnectSendjim">
                                    {{ btnConnectDisconnectSendjimText }}
                                    <i v-if="isLoadingConnectDisconnectSendjim" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                </base-button>
                            </div>
                            <el-divider content-position="left">Connect using OAuth2</el-divider>
                            <div class="has-label" style="margin-bottom: 16px;">
                                <label class="mb-0">OAuth Redirect URL</label>
                                <el-input :value="sendjimCallbackUrl" readonly class="flex-grow-1 mb-0">
                                    <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard(sendjimCallbackUrl)"></el-button>
                                </el-input>
                                <small>Use the URL above as your OAuth callback/redirect URL in SendJim.</small>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="has-label">
                                        <label class="mb-0">Client ID <span style="color: var(--danger);">*</span></label>
                                        <el-input v-model="userApiKey.sendjim" type="text" clearable placeholder="Enter your SendJim Client ID" class="flex-grow-1 mb-0" aria-controls="datatables"></el-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="has-label">
                                        <label class="mb-0">Client Secret <span style="color: var(--danger);">*</span></label>
                                        <el-input v-model="sendjim.clientSecret" type="password" show-password clearable placeholder="Enter your SendJim Client Secret" class="flex-grow-1 mb-0" aria-controls="datatables"></el-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template slot="footer">
                <div style="display: flex;justify-content: space-between;" class="integrations-modal-footer-wrapper">
                    <div style="width: 600px;font-size: 12px;">
                            Note: Some of the links on this site are affiliate links, meaning we may earn a commission if you sign up or make a purchase through them. This helps support our work at no additional cost to you.
                        </div>
                    <div class="d-flex align-items-center justify-content-end">
                        <base-button @click.native="modals.integrations = false">Cancel</base-button>
                        <base-button id="btnSaveIntegration"
                            @click.native="saveIntegrationSettingslocal">Save</base-button>
                    </div>
                </div>
            </template>
        </modal>

        <!-- Modal integration settings -->
        <!-- WhiteList DB upload -->
        <modal :show.sync="modals.whitelist" id="clientWhitelist" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Client Wide Exclusion List</h4>
            <div>
                <!--UPLOAD-->
                <form enctype="multipart/form-data">
                    <!--<h5>Drag & Drop your suppression List (file type should be .csv). Download <a href="#">example file</a></h5>-->
                    <div class="dropbox">
                        <input type="file" :name="uploadFieldName" :disabled="isSaving"
                            @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                            accept=".csv" class="input-file">
                        <p v-if="isInitial">
                            Drag your file here to upload<br />or click to browse<br />
                            <!--<base-button type="info" round icon  @click="show_helpguide('suppression')">
                                <i class="fas fa-question"></i>
                            </base-button>-->
                        </p>
                        <p v-if="isSaving">
                            Please Wait, your file being upload ...
                        </p>
                        <p v-if="isSuccess">
                            Your Suppression file has been Submitted, Thank you!
                        </p>
                        <p v-if="isFailed">
                            Whoops that did not work, please check your file for errors and try again
                        </p>
                    </div>
                </form>
            </div>
            <div v-if="supressionProgress.length > 0">
                <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                    <div v-for="(value) in supressionProgress" :key="value.id">
                        <div style="display: flex; width: 100%; gap: 8px;">
                            <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                            <div style="width: 100%;">
                                <p style="color: #000000; font-weight: 600; margin-bottom: 0px;">{{ value.filename }}</p>
                                <el-progress :percentage="value.percentage == null ? 0 : value.percentage"></el-progress>
                                <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                            </div>
                        </div>
                        <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                    </div>
            </div>
            <div class="pt-2 mt-3">
                You have the ability to restrict your current database from being identified as a new contact. 
                                You can Exclude them by uploading a list of MD5 encrypted email addresses, 
                                or by uploading a list of email addresses and we will encrypt them for you. 
                                Do not include any other information in the file aside from the email address. 
                                You may upload lists of up to 10,000 records at a time. <a
                                 href='https://app.exactmatchmarketing.com/samplefile/suppressionlist.csv' target='_blank'>Click here</a> to download a Sample File
                <div class="text-center" v-if="optoutfileexist">Your current exclusion list: <a
                        :href="optoutpath + '/tools%2Foptout%2Fclientoptoutlist_' + whiteListClientID + '.csv'"
                        target="_blank">download here</a></div>
            </div>
            <div v-if="supressionDone.length > 0">
                <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                <div v-for="(value) in supressionDone" :key="value.id">
                    <div style="display: flex; width: 100%; gap: 8px;">
                        <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                        <div style="width: 100%;">
                            <p style="color: #000000; font-weight: 600; margin-bottom: 0px;">{{ value.filename }}</p>
                            <el-progress :percentage="value.percentage" status="success"></el-progress>
                            <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                        </div>
                    </div>
                    <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                </div>
            </div>
            <a class="mt-2 d-inline-block" @click="purgeSuppressionList('client')" style="cursor: pointer;"><i
                    class="fas fa-trash"></i> Purge Existing Records</a>
            <template slot="footer">
                <div class="pb-4 d-flex justify-content-center w-100">
                    <base-button @click.native="modals.whitelist = false">Cancel</base-button>
                </div>
            </template>
        </modal>
        <!-- WhiteList DB upload -->

        <!-- help modal start -->
        <modal :show.sync="modals.help" headerClasses="">
            <div slot="header" class="d-flex flex-column gap-4">
                <h4  class="title title-up">{{activeHelpItem.title}}</h4> 
            </div>
            <div v-if="modals.help" v-html="activeHelpItem.embedVideoCode"></div>
            <p v-if="activeHelpIndex == 0" class="text-dark mt-4" style="font-size: 14px;">
                In this section you have full management of your clients.
                <br>The first thing you'll notice is the ability to add a client.
                <br>When you add a client it will send an invite to them so they may continue onboarding themselves, agree to the terms and conditions and add their credit card. When adding a client you have the ability to activate the products that are visible to them, if any, as well as disable their ability to add campaigns, or disable all system emails to the client. We do not recommend you ever disable all system emails to the client unless you get the terms of service electronically signed separately to their onboarding.
                <br>The terms of service can be found for each client by clicking on the credit card icon for that client and scrolling to the bottom and clicking on the link for the terms of service. 
                <strong 
                    v-if="!showMoreHelp"
                    style="cursor: pointer;" 
                    @click="showMoreHelp = !showMoreHelp">
                    show more
                </strong>
                <span v-if="showMoreHelp">
                    <br>Our attorneys have provided privacy policies, terms of service, and a service contract that protects both the agency and the platform.
                    <br>You will also see that you can filter your clients to see if their credit card is set up or failed and if they have active or inactive campaigns.
                    <br>When looking at the client's dashboard you will see their basic information first as well as the date they were created. The gray credit card shows that it has never been set up. Green means that they have completed their onboarding and red means that their card has failed and it needs to be updated. If a payment fails all of their campaigns will be paused and when they log into their dashboard it will redirect them to the credit card settings so they can update their card. As the agency, you could also click on the card and update it from the dashboard side on behalf of the client.
                    <br>Next you'll see a green bubble that will give the count for how many active campaigns and a gray bubble that will give the count for paused or stopped campaigns.
                    <br>Next you will see an icon that looks like a power plug. This is to manage the integrations and plugins for this client. Here you will set up the specific API keys or web hooks for the clients specific integrations. The integration or plugin will not display for the client's campaigns unless it is first enabled here at the client level. The client also can enable their own plugins and integrations in their own dashboard settings. The next button is a simple edit button where you can edit the clients permission levels, manually update their password if needed, or click the resend invitation button to have the system automatically create a randomized password and send it to them to login.
                    <br>The next button is the client level exclusion list. Here you can upload up to 10,000 records at a time and this will exclude them from ever being captured in any of the campaigns. This is especially important for large clients who already have databases with existing and past customers. You can upload a list of email addresses already encrypted into an MD5 hash, or upload a list of raw email addresses and we will encrypt it on our side.
                    <br>The next button is where you can customize the pricing for that individual client. If you make adjustments here it will adjust any newly created campaigns, but it will not adjust any campaigns that were already created for that client.
                    <br>The final button is for you to remove a client from your dashboard. 
                    <strong 
                        v-if="showMoreHelp"
                        style="cursor: pointer;" 
                        @click="showMoreHelp = !showMoreHelp"> 
                        show less
                    </strong>
                </span>
            </p>
            <p v-else class="text-dark mt-4" style="font-size: 14px;" v-html="activeHelpItem.desc"></p>
        </modal>
          <!-- Help modal end -->
           <!-- create client Model -->
           <modal :show.sync="modals.create" id="addCampaign"  bodyClasses='create-campaign-modal-body' :showClose="false"
            footerClasses="border-top p-2" @close="resetAddClientModal" :closeOnOutsideClick="false">
            <h3 slot="header" class="title title-up">New Client{{ (createdClientData && createdClientData.company_name) ? ' - ' + createdClientData.company_name : (ClientCompanyName ? ' - ' + ClientCompanyName : '') }}</h3>
            <step-indicator :steps="filteredCreateCampaignSteps" :activeStep="getAdjustedActiveStep" ></step-indicator>
            <div v-if="campaignCreateActiveStep === 0" class="row mt-4">
                <ValidationObserver ref="frmAddDownline"  v-slot="{ handleSubmit }" class="col-12">
                        <form autocomplete="off" >
                            <input autocomplete="false" name="hidden" type="text" style="display:none;">
                            <div class="row">
                                 <div class="col-6 form-group has-label">
                                    <ValidationProvider
                                    name="Client's Business Name"
                                    rules="required|max:255"
                                    v-slot="{ passed, failed, errors }">
                                        <base-input label="Client's Business Name" type="text" placeholder="Input Client's Business Name"
                                            v-model="ClientCompanyName"
                                            :error="errors[0]"
                                            maxlength="255"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                                 <div class="col-6">
                                    <ValidationProvider
                                    name="Client's Personal Name"
                                    rules="required|max:255"
                                    v-slot="{ passed, failed, errors }">
                                        <base-input label="Client's Personal Name" type="text" placeholder="Input Client's Personal Name"
                                            v-model="ClientFullName"
                                            :error="errors[0]"
                                            maxlength="255"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="row">
                         

                                <div class="col-sm-6 col-md-6 col-lg-6 form-group">
                                    <label>Phone Number</label>

                                    <VuePhoneNumberInput :defaultCountryCode="clientPhoneNumber.countryCode"
                                        v-model="clientPhoneNumber.number" @update="onPhoneUpdate" />
                                    <small v-if="phoneError" class="text-danger d-block mt-1" style="color:#942434 !important;">{{ phoneError }}</small>
                                </div>
                                       <div class="col-6">
                                    <ValidationProvider
                                     name="email" 
                                     rules="required|email"
                                     v-slot="{ passed, failed, errors }">
                                        <base-input label="Email" type="email" placeholder="Input Email"
                                            v-model="ClientEmail" :lowercase="true"
                                            :error="errors[0]"
                                            max="70"
                                            :maxLength="70"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <!-- CRM Import Section (if available) -->
                            <div class="row mt-4" v-if="ghlV2AgencyConnected && $global.idsys == $global.masteridsys">
                                <div class="col-sm-6 col-md-6 col-lg-6 form-group has-label">
                                    <label class="pr-2">
                                        Import Client From Your CRM
                                        <i @click="clearSelectSubAccount" class="fa-solid fa-circle-x ml-2" style="cursor: pointer;"></i>
                                    </label>
                                    <el-select
                                        class="select-primary"
                                        size="large"
                                        placeholder="Select Client"
                                        filterable
                                        default-first-option
                                        v-model="selects.ghlv2SubAccount"
                                        @visible-change="visible => onSelectGhlV2SubAccountVisible(visible, 'add')"
                                        ref="selectGhlV2SubAccountAdd">
                                        <el-option
                                            v-for="item in ghlV2ListSubAccounts"
                                            class="select-primary"
                                            :value="item.id"
                                            :label="item.name"
                                            :key="item.id">
                                        </el-option>
                                        <el-option v-if="paginationGhlV2SubAccount.isFetch && !paginationGhlV2SubAccount.isComplete" value="loading" label="Loading...." disabled>
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <!-- Checkboxes Section -->
                            <div class="row mt-4">
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <base-checkbox value="T" v-model="disabledaddcampaign" class="pull-left">Disable
                                        clients ability to add campaigns</base-checkbox>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <base-checkbox value="T" v-model="seteditor" class="pull-left">
                                        Set as Editor Google Spreadsheet
                                    </base-checkbox>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-check form-check-inline pull-left">
                                        <label class="form-check-label">
                                            <input
                                                :key="'phone-add-' + checkboxes.phoneenabled"
                                                class="form-check-input"
                                                type="checkbox"
                                                :checked="checkboxes.phoneenabled"
                                                @click.prevent="handlePhoneCheckboxClick('checkboxes')"
                                            />
                                            <span class="form-check-sign"></span>
                                            Enable Phone Number when Create Campaign
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <base-checkbox value="T" v-model="disabledreceiveemail" class="pull-left">Disable
                                        all system emails to this client</base-checkbox>
                                </div>
                            </div>
                            <div class="row mt-4">
                                    <div class="col-12">
                                        <span class="" style="font-size: 0.80143rem;">Product(s) <span style="color: var(--danger);">*</span> :</span>
                                        <small class="text-danger d-block mt-1" v-if="modals.create && campaignCreateActiveStep === 0 && !hasAtLeastOneProductSelected">
                                            Please select at least one product
                                        </small>
                                    </div>
                                    <div class="col-6" v-for="(sidebar, key) in customsidebarleadmenu"
                                            :key="sidebar.url">
                                        <base-checkbox
                                            class="mr-3"
                                            v-model="selectedModulesCreate[key]"
                                            v-show="validateBetaFeature(key) && (sidebar.url != 'simplifiid' || $global.idsys == $global.masteridsys)"
                                        >
                                        {{ sidebar.name }}
                                        </base-checkbox>
                                    </div>
                            </div>
                        </form>
                    </ValidationObserver>
            </div>
            <div v-if="campaignCreateActiveStep === 1 && !shouldSkipCCStep" class="row mt-4">
                  <ValidationObserver ref="formCCWizard" class="col-12">
                        <form id="modalSetCard">
                            <!--START ADD / UPDATE FOR CC -->

                            <div id="card-element-create" class="col-sm-12 col-md-12 col-lg-12 card-border" style="width: 97% !important;">&nbsp;</div>
                            <div class="pt-2 pl-2" v-if="cardfailetoload" style="font-size:0.80143rem"><i
                                    class="fas fa-sync-alt pr-2" @click="refreshCCfield();"
                                    style="cursor:pointer"></i>Failed to load the Credit Card field. Please <a
                                    href="javascript:void(0);" @click="refreshCCfield();" style="font-weight:bold">click
                                    here</a> to refresh and try again.</div>
                            <div id="carderror" class="col-sm-12 col-md-12 col-lg-12 pt-2 hide" style="color:red">
                                <small>&nbsp;</small>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <ValidationProvider name="Card Holder Name" rules="required"
                                    v-slot="{ passed, failed, errors }">
                                    <base-input v-model="cardholdername" label="Card Holder Name" :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <ValidationProvider name="Billing Address" rules="required"
                                    v-slot="{ passed, failed, errors }">
                                    <base-input v-model="billingaddress" label="Billing Address" :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                                <div class="country-region-select-wrapper">
                                    <span style="color: #525f7f;font-size: 14px;" class="country-label">Country *</span>
                                    <country-select style="color: #525f7f;border-color: #cad1d7;"
                                        class="country-region-select" v-model="selects.country"
                                        :country="selects.country" topCountry="US" />
                                    <span v-if="showErrorMessage && !selects.country">Please select country</span>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                                <div v-if="selects.country" class="country-region-select-wrapper">
                                    <span style="color: #525f7f;font-size: 14px;"
                                        class="country-label">{{selects.country === "CA" ?"Province *": "State*"}}</span>
                                    <region-select style="color: #525f7f;border-color: #cad1d7;"
                                        class="country-region-select" v-model="selects.state" :country="selects.country"
                                        :region="selects.state" />
                                    <span v-if="showErrorMessage && !selects.state">Please select state</span>
                                </div>
                            </div>
                            <div class="row pt-2 mr-0 ml-0">
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <ValidationProvider name="City" rules="required"
                                        v-slot="{ passed, failed, errors }">
                                        <base-input v-model="city" label="City" :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <ValidationProvider name="Zip" rules="required" v-slot="{ passed, failed, errors }">
                                        <base-input v-model="zipcode" label="Zip" :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <!--START ADD / UDPATE FOR CC -->
                            <div class="pt-3 pb-3">&nbsp;</div>

                            <!-- 
                            <div class="col-sm-12 col-md-12 col-lg-12 ">
                                <card>
                                    <div slot="header">
                                        <h4 class="card-title">Your Current Card Information</h4>
                                    </div>
                                </card>
                            </div>
                            -->


                            <div class="col-sm-12 col-md-12 col-lg-12 mr-0 ml-0">
                                <p class="text-title-wrapping" v-if="currCardHolder != ''">{{currCardHolder}}</p>
                                <p v-if="currCardlastdigit != ''">Card Number :
                                    &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                                    {{currCardlastdigit}}</p>
                                <p v-if="currCardType != ''">Card Type : {{currCardType}}</p>
                            </div>

                            <div class="pt-3 pb-3">&nbsp;</div>

                            <div class="col-sm-12 col-md-12 col-lg-12 ">
                                <base-checkbox v-model="agreeTerm" class="pull-left"
                                    :class="{'has-danger': agreeTermStat}">I attest that the client and credit card owner has agreed to the <a
                                        :href="'/service-billing-agreement/?src=client&host=' + termhost"
                                        target="_blank" style="color:#919aa3"
                                        :style="[agreeTermStat?{'color':'#ec250d'}:'']">Billing
                                        Terms and Service Agreement</a></base-checkbox>
                            </div>

                            <!-- <div class="col-sm-12 col-md-12 col-lg-12" v-if="!clientPaymentFailed">
                                <base-button @click="validateCC('');" id="btnupdcc" size="sm" class="pull-right"
                                    style="height:40px">
                                    Update
                                </base-button>
                            </div> -->
                            <div class="row pt-2" style="width:100%" v-if="clientPaymentFailed">

                                <div class="col-sm-6 col-md-6 col-lg-6 pl-4">
                                    <base-button @click="validateCC('existcard');" id="btnRetryExistCard" size="sm"
                                        class="pull-right" style="height:50px">
                                        Retry charge with existing card
                                    </base-button>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6 pr-0">
                                    <base-button @click="validateCC('updatecharge');" id="btnUpdateAndCharge" size="sm"
                                        class="pull-right" style="height:50px">
                                        save and charge amount due
                                    </base-button>
                                </div>
                            </div>

                        </form>
                    </ValidationObserver>
            </div>
            <div v-if="campaignCreateActiveStep === 2" class="row mt-4">
                <div class="col-12">
                    <div v-if="modals.create && campaignCreateActiveStep === 2" class="d-flex align-items-center" style="margin-bottom: 20px; padding: 12px; background-color: #f8f9fa; border-radius: 8px;">
                        <el-checkbox v-model="useDefaultPricing" @change="handleUseDefaultPricingChange">
                            Use Default Pricing
                        </el-checkbox>
                        <span style="margin-left: 8px; color: #606266; font-size: 14px;">
                            When enabled, all pricing fields will use default pricing and cannot be modified.
                        </span>
                    </div>
                    <div class="row" style="padding-inline: 16px; margin-bottom: 24px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                        <div v-if="moduleAgency.local != undefined" @click="selectsAppModule.AppModuleSelect = 'LeadsPeek'"
                        style="flex: 1; display: flex; justify-content: center;"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'LeadsPeek' ? 'active__menu__prices' : '']">
                        {{ this.$global.globalModulNameLink.local.name }}
                        </div>
                        <div v-if="moduleAgency.locator != undefined" @click="selectsAppModule.AppModuleSelect = 'locator'"
                        style="flex: 1; display: flex; justify-content: center;"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'locator' ? 'active__menu__prices' : '']">
                            {{ this.$global.globalModulNameLink.locator.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.enhance.name != null && this.$global.globalModulNameLink.enhance.url != null && moduleAgency.enhance != undefined"
                        @click="selectsAppModule.AppModuleSelect = 'enhance'"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'enhance' ? 'active__menu__prices' : '']"
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.enhance.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.b2b.name != null && this.$global.globalModulNameLink.b2b.url != null && moduleAgency.b2b != undefined && validateBetaFeature('b2b_module')"
                        @click="selectsAppModule.AppModuleSelect = 'b2b'"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'b2b' ? 'active__menu__prices' : '']"
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.b2b.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.simplifi.name != null && this.$global.globalModulNameLink.simplifi.url != null && moduleAgency.simplifi != undefined && validateBetaFeature('simplifi_module') && this.$global.idsys == this.$global.masteridsys"
                        @click="selectsAppModule.AppModuleSelect = 'simplifi'"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'simplifi' ? 'active__menu__prices' : '']"
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.simplifi.name }}
                        </div>
                        <div style="width: 100%; border: 1px solid gray; height: 1px; margin-top: 16px;"></div>
                    </div>
                    <div v-if="selectsAppModule.AppModuleSelect != 'simplifi'" class="d-flex flex-column" style="margin-bottom:16px;">
                        <span class="client-payment-modal-form-label" style="color:#222a42">Billing Frequency</span>
                        <el-select class="select__form__client" size="large" placeholder="Select Modules"
                            v-model="selectsPaymentTerm.PaymentTermSelect" 
                            :disabled="isPricingFieldsDisabled"
                            @change="paymentTermChange()">
                            <el-option v-for="option in selectsPaymentTerm.PaymentTerm" class="select-primary"
                                :value="option.value" :label="option.label" :key="option.label">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="col-12" v-if="selectsAppModule.AppModuleSelect == 'LeadsPeek' && moduleAgency.local != undefined">
                    <div class="client-payment-setup-form-wrapper">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="client-payment-modal-form-label">
                                    Setup Fee
                                </div>
                                <div>
                                    <base-input key="leadspeek-setupfee-add" label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="LeadspeekPlatformFee"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('local','LeadspeekPlatformFee');"
                                        @blur="handleFormatCurrency('local','LeadspeekPlatformFee')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekPlatformFee }}</span></span></div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="client-payment-modal-form-label">
                                    Campaign Fee <span v-html="txtLeadService">per month</span>
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="LeadspeekMinCostMonth"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('local','LeadspeekMinCostMonth');"
                                        @blur="handleFormatCurrency('local','LeadspeekMinCostMonth')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekMinCostMonth }}</span></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6" v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                                <div class="client-payment-modal-form-label">
                                    Cost per contact<span v-html="txtLeadOver" v-if="false">from the monthly charge</span>? (Basic)
                                    <sup>
                                        <el-popover
                                            trigger="hover"
                                            :content="helpContentMap[1].desc"
                                            placement="top"
                                            popper-class="tooltip-content"
                                        >
                                        <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                        </el-popover>
                                    </sup>
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="LeadspeekCostperlead"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('local','LeadspeekCostperlead');"
                                        @blur="handleFormatCurrency('local','LeadspeekCostperlead')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekCostPerLead }}</span></span></div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="client-payment-modal-form-label">
                                    Cost per contact<span v-html="txtLeadOver" v-if="false">from the monthly charge</span>? (Advanced)
                                    <sup>
                                        <el-popover
                                            trigger="hover"
                                            :content="helpContentMap[2].desc"
                                            placement="top"
                                            popper-class="tooltip-content"
                                        >
                                        <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                        </el-popover>
                                    </sup>
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="LeadspeekCostperleadAdvanced"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('local','LeadspeekCostperleadAdvanced');"
                                        @blur="handleFormatCurrency('local','LeadspeekCostperleadAdvanced')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent>
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your advanced price for cost per contact $<span>{{ m_LeadspeekCostPerLeadAdvanced }}</span></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                    <el-checkbox v-model="LeadspeekEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('local')">Enable Minimum Contact Per Day</el-checkbox>
                                </div>
                                <div class="client-payment-modal-form-label">
                                    How many contacts per day does the client want to receive?
                                </div>
                                <div>
                                    <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                        class="campaign-cost-input" v-model="LeadspeekLeadsPerday"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('local','LeadspeekLeadsPerday');"
                                        @input="event => onInput(event, 'LeadspeekLeadsPerday')"
                                        @blur="handleFormatCurrency('local','LeadspeekLeadsPerday')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12" v-if="selectsAppModule.AppModuleSelect == 'locator' && moduleAgency.locator != undefined">
                    <div class="client-payment-setup-form-wrapper">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="client-payment-modal-form-label">
                                    Setup Fee
                                </div>
                                <div>
                                    <base-input key="locator-setupfee-add" label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="LocatorPlatformFee"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('locator','LocatorPlatformFee');"
                                        @blur="handleFormatCurrency('locator','LocatorPlatformFee')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekLocatorPlatformFee }}</span></span></div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="client-payment-modal-form-label">
                                    Campaign Fee <span v-html="txtLeadService">per month</span>
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="LocatorMinCostMonth"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('locator','LocatorMinCostMonth');"
                                        @blur="handleFormatCurrency('locator','LocatorMinCostMonth')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekLocatorMinCostMonth }}</span></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6" v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                                <div class="client-payment-modal-form-label">
                                    Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                        monthly charge</span>?
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="LocatorCostperlead"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('locator','LocatorCostperlead');"
                                        @blur="handleFormatCurrency('locator','LocatorCostperlead')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekLocatorCostPerLead }}</span></span></div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                    <el-checkbox v-model="LocatorEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('locator')">Enable Minimum Contact Per Day</el-checkbox>
                                </div>
                                <div class="client-payment-modal-form-label">
                                    How many contacts per day does the client want to receive?
                                </div>
                                <div>
                                    <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                        class="campaign-cost-input" v-model="LocatorLeadsPerday"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('locator','LocatorLeadsPerday');"
                                        @input="event => onInput(event, 'LocatorLeadsPerday')"
                                        @blur="handleFormatCurrency('locator','LocatorLeadsPerday')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12" v-if="selectsAppModule.AppModuleSelect == 'enhance' && moduleAgency.enhance != undefined">
                    <div class="client-payment-setup-form-wrapper">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="client-payment-modal-form-label">
                                    Setup Fee
                                </div>
                                <div>
                                    <base-input key="enhance-setupfee-add" label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input"  v-model="EnhancePlatformFee"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('enhance','EnhancePlatformFee');"
                                        @blur="handleFormatCurrency('enhance','EnhancePlatformFee')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekEnhancePlatformFee }}</span></span></div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6"  >
                                <div class="client-payment-modal-form-label">
                                    Campaign Fee <span v-html="txtLeadService">per month</span>
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="EnhanceMinCostMonth"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('enhance','EnhanceMinCostMonth');"
                                        @blur="handleFormatCurrency('enhance','EnhanceMinCostMonth')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekEnhanceMinCostMonth }}</span></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6"
                                v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                                <div class="client-payment-modal-form-label">
                                    Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                        monthly charge</span>?
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="EnhanceCostperlead"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('enhance','EnhanceCostperlead');"
                                        @blur="handleFormatCurrency('enhance','EnhanceCostperlead')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekEnhanceCostPerLead }}</span></span></div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                    <el-checkbox v-model="EnhanceEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('enhance')">Enable Minimum Contact Per Day</el-checkbox>
                                </div>
                                <div class="client-payment-modal-form-label">
                                    How many contacts per day does the client want to receive?
                                </div>
                                <div>
                                    <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                        class="campaign-cost-input" v-model="EnhanceLeadsPerday"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('enhance','EnhanceLeadsPerday');"
                                        @input="event => onInput(event, 'EnhanceLeadsPerday')"
                                        @blur="handleFormatCurrency('enhance','EnhanceLeadsPerday')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                </div>
                                <span v-if="errMinLeadDay" style="color:#942434; font-size:12px;font-weight: 400;line-height: 12px;margin-top: 4px;display: block;">*contacts Per Day Minimum {{ clientMinLeadDayEnhance }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12" v-if="selectsAppModule.AppModuleSelect == 'b2b' && moduleAgency.b2b != undefined && validateBetaFeature('b2b_module')">
                    <div class="client-payment-setup-form-wrapper">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="client-payment-modal-form-label">
                                    Setup Fee
                                </div>
                                <div>
                                    <base-input key="b2b-setupfee-add" label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input"  v-model="B2bPlatformFee"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('b2b','B2bPlatformFee');"
                                        @blur="handleFormatCurrency('b2b','B2bPlatformFee')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekB2BPlatformFee }}</span></span></div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6"  >
                                <div class="client-payment-modal-form-label">
                                    Campaign Fee <span v-html="txtLeadService">per month</span>
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="B2bMinCostMonth"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('b2b','B2bMinCostMonth');"
                                        @blur="handleFormatCurrency('b2b','B2bMinCostMonth')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekB2BMinCostMonth }}</span></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6"
                                v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                                <div class="client-payment-modal-form-label">
                                    Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                        monthly charge</span>?
                                </div>
                                <div>
                                    <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="B2bCostperlead"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('b2b','B2bCostperlead');"
                                        @blur="handleFormatCurrency('b2b','B2bCostperlead')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                    <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekB2BCostPerLead }}</span></span></div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                    <el-checkbox v-model="B2bEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('b2b')">Enable Minimum Contact Per Day</el-checkbox>
                                </div>
                                <div class="client-payment-modal-form-label">
                                    How many contacts per day does the client want to receive?
                                </div>
                                <div>
                                    <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                        class="campaign-cost-input" v-model="B2bLeadsPerday"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('b2b','B2bLeadsPerday');"
                                        @input="event => onInput(event, 'B2bLeadsPerday')"
                                        @blur="handleFormatCurrency('b2b','B2bLeadsPerday')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent
                                        >
                                    </base-input>
                                </div>
                                <span v-if="errMinLeadDay" style="color:#942434; font-size:12px;font-weight: 400;line-height: 12px;margin-top: 4px;display: block;">*Leads Per Day Minimum {{ clientMinLeadDayEnhance }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12" v-if="selectsAppModule.AppModuleSelect == 'simplifi' && moduleAgency.simplifi != undefined && validateBetaFeature('simplifi_module') && this.$global.idsys == this.$global.masteridsys">
                    <div class="client-payment-setup-form-wrapper">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <div class="client-payment-modal-form-label">
                                    Max Bid
                                </div>
                                <div>
                                    <base-input
                                        key="simplifi-maxbid-add"
                                        label=""
                                        type="text"
                                        placeholder="0"
                                        addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input"
                                        :class="{'error-input-price-simplifi': simplifiErrorInput.maxBid}"
                                        v-model="SimplifiMaxBid"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('simplifi','SimplifiMaxBid');"
                                        @blur="handleFormatCurrency('simplifi','SimplifiMaxBid')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent>
                                        <template #addonRight>
                                            <span class="input-group-text cpm-remove-border">CPM</span>
                                        </template>
                                    </base-input>
                                    <span v-if="simplifiErrorInput.maxBid" v-html="simplifiErrorInput.maxBid" class="error-message-price-simplifi"></span>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <div class="client-payment-modal-form-label">
                                    Daily Budget
                                </div>
                                <div>
                                    <base-input
                                        label=""
                                        type="text"
                                        placeholder="0"
                                        addon-left-icon="fas fa-dollar-sign"
                                        class="campaign-cost-input" v-model="SimplifiDailyBudget"
                                        :class="{'error-input-price-simplifi': simplifiErrorInput.dailyBudget}"
                                        :disabled="isPricingFieldsDisabled"
                                        @keyup="set_fee('simplifi','SimplifiDailyBudget');"
                                        @blur="handleFormatCurrency('simplifi','SimplifiDailyBudget')"
                                        @keydown="restrictInput"
                                        @copy.prevent @cut.prevent @paste.prevent>
                                    </base-input>
                                    <span v-if="simplifiErrorInput.dailyBudget" v-html="simplifiErrorInput.dailyBudget" class="error-message-price-simplifi"></span>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <div class="client-payment-modal-form-label">
                                    Agency Profit Margin
                                </div>
                                <div>
                                    <el-select class="select__form__client" style="width: 100%;" size="large" placeholder="Select Modules" v-model="SimplifiAgencyMarkup" :disabled="isPricingFieldsDisabled" @change="set_fee('simplifi','SimplifiAgencyMarkup');">
                                        <el-option v-for="markup in agencyMarkup.list" :value="markup.value" :label="markup.text" :key="markup.value"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="campaignCreateActiveStep === 3" class="row mt-4">
                <div class="col-12">
                    <div v-if="integrationStatus.loading" style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
                        <i class="fas fa-spinner fa-spin" style="font-size: 40px;"></i>
                    </div>
                    <div v-else-if="integrationStatus.error" class="error-banner">
                        Oops! Something went wrong. Please refresh the page and try again.
                    </div>
                    <div v-else>
                        <div class="integratios-list-wrapper d-flex align-items-center gap-4 flex-wrap" style="margin-bottom: 24px;">
                            <div v-for="item in integrations" :key="item.slug"
                                class="integrations__modal-item-wrapper d-flex align-items-center justify-content-center shadow-sm border"
                                :class="{ '--active bg-blue text-secondary': item.slug === selectedIntegration }"
                                @click="handleIntegrationItemClick(item)">
                                <div class="integrations__modal-item">
                                    <img
                                        v-if="item.custom_img"
                                        class="logo-wrap-client-management"
                                        :src="item.custom_img"
                                        alt="brand-logo"
                                    />
                                    <i v-else :class="item.custom_icon || item.icon" style="font-size: 36px;"></i>
                                    <span class="integrarion-brand-name" style="text-align: center;">{{ item.custom_name || item.name }}</span>
                                </div>
                                <span v-if="isIntegrationEnabled(item.slug)" class="check-icon">✔</span>
                            </div>
                        </div>
                        <div v-if="isIntegrationItemsFetch" class="row" v-loading="true" id="loading"></div>
                        <div v-else>
                            <div v-if="selectedIntegration === 'gohighlevel'" class="''">
                                <el-checkbox v-model="enabledconntector.gohighlevel">Enable {{ nameActiveIntegration }}</el-checkbox>
                                <div class="d-flex" style="flex-direction: column; gap: 12px; margin-top: 25px" v-if="referralCodeActive != ''">
                                   <span style="display: flex; align-items: center;gap: 8px">
                                    <el-button
                                        size="medium"
                                        icon="el-icon-unlock"
                                        @click="redirectToLink(`https://www.gohighlevel.com/?fp_ref=${referralCodeActive}`)"
                                        circle

                                        ></el-button> <span>If you do not have a {{ nameActiveIntegration }} account, <a style="color: inherit !important;font-size: inherit;font-weight: bold;" :href="`https://www.gohighlevel.com/?fp_ref=${referralCodeActive}`" target="_blank">Click Here</a> to create one</span>
                                    </span>
                                </div>
                                <div class="has-label" style="margin-top: 20px; margin-bottom: 35px;">
                                    <el-tabs type="border-card" v-model="integrationVersion.gohighlevel">
                                        <el-tab-pane name="2">
                                            <span slot="label">Full Integration</span>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div style="margin-left: 4px;">
                                                        <p v-if="ghlV2Connected">You Have Connected Contact Sync For This Client</p>
                                                        <p v-else>You Have Not Yet Connected Contact Sync For This Client</p>
                                                    </div>
                                                    <div :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { marginTop: '10px' } : {}">
                                                        <base-button id="btnConnectDisconnectGhlv2" :disabled="isLoadingConnectDisconnectGhlv2" @click="connectDisconnectGhlv2">
                                                            {{ btnConnectDisconnectGhlv2Text }}
                                                            <i v-if="isLoadingConnectDisconnectGhlv2" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                                        </base-button>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 divider-ghl2" v-if="ghlV2AgencyConnected && this.$global.idsys == this.$global.masteridsys">
                                                    <div style="margin-left: 4px;">
                                                        <p v-if="ghlV2CreatedIframe">You Have Created a Single Sign On Link For This Client</p>
                                                        <p v-else>You Have Not Yet Created a Single Sign On Link For This Client</p>
                                                    </div>
                                                    <div style="display: flex; justify-content: space-between; align-items: center; gap: 16px;">
                                                        <div :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { width: '100%' } : {}">
                                                            <base-button :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { width: '100%' } : {}" id="btnCreateDeleteIframeGhlv2Text" @click="createDeleteIframeGhlv2" :disabled="isLoadingCreateDeleteIframeGhlV2">
                                                                {{ btnCreateDeleteIframeGhlv2Text }}
                                                                <i v-if="isLoadingCreateDeleteIframeGhlV2" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                                            </base-button>
                                                        </div>
                                                        <div style="width: 100%;" class="form-group has-label" v-if="!ghlV2CreatedIframe && ghlV2AgencyConnected && this.$global.idsys == this.$global.masteridsys">
                                                            <el-select
                                                                style="width: 100%; margin-top: 10px;"
                                                                class="select-primary"
                                                                size="large"
                                                                placeholder="Select Client"
                                                                filterable
                                                                default-first-option
                                                                v-model="selects.ghlv2SubAccount"
                                                                @visible-change="visible => onSelectGhlV2SubAccountVisible(visible, 'edit')"
                                                                ref="selectGhlV2SubAccountEdit">
                                                                <el-option
                                                                    v-for="item in ghlV2ListSubAccounts"
                                                                    class="select-primary"
                                                                    :value="item.id"
                                                                    :label="item.name"
                                                                    :key="item.id">
                                                                </el-option>
                                                                <el-option v-if="paginationGhlV2SubAccount.isFetch && !paginationGhlV2SubAccount.isComplete" value="loading" label="Loading...." disabled>
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-tab-pane>
                                        <el-tab-pane name="1">
                                            <span slot="label">API Only</span>
                                            <label class="mb-0">Enter your API Key</label>
                                            <el-input type="text" clearable label="Enter your API Key" placeholder="AssAW02A02ksjsklah"
                                                class="flex-grow-1 mb-0" v-model="userApiKey.gohighlevel" aria-controls="datatables">
                                            </el-input>
                                        </el-tab-pane>
                                    </el-tabs>
                                </div>
                                <template>
                                    <CheckboxCustomFields
                                        :slug="'Gohighlevel'"
                                        :isLoadingCustomFieldsBySlug="isLoadingCustomFieldsBySlug"
                                        :isErrorCustomFieldsBySlug="isErrorCustomFieldsBySlug"
                                        :handleDefaultCustomFields="handleDefaultCustomFields"
                                        :customFieldsBySlug="customFieldsBySlug['gohighlevel']"
                                        :listValueFieldsIntegration="listValueFieldsIntegrationGohighlevel"
                                        :listValueFieldsIntegrationB2b="listValueFieldsIntegrationGohighlevelb2b"
                                        :listValueFieldsIntegrationAdvance="listValueFieldsIntegrationGohighleveladvance"
                                        :handleCheckItemCustomFields="handleCheckItemCustomFields"
                                        :isHideB2b="isHideB2b"
                                        :isHideAdvance="isHideAdvance"
                                        :handleCheckAllCustomFields="handleCheckAllCustomFields"
                                        :isCheckAllIntegrationGeneral="isCheckAllIntegrationGeneral"
                                        :isCheckAllIntegrationB2b="isCheckAllIntegrationB2b"
                                        :isCheckAllIntegrationAdvance="isCheckAllIntegrationAdvance"
                                    />
                                </template>
                            </div>
                            <div v-if="selectedIntegration === 'sendgrid'" class="''">
                                <el-checkbox v-model="enabledconntector.sendgrid">Enable {{ nameActiveIntegration }}</el-checkbox>
                                <div class="has-label">
                                    <label class="mt-1">Enter your API Key</label>
                                    <el-input type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
                                        class="flex-grow-1 mb-0" v-model="userApiKey.sendgrid" aria-controls="datatables">
                                    </el-input>
                                </div>
                            </div>
                            <div v-if="selectedIntegration === 'kartra'" class="''">
                                <el-checkbox v-model="enabledconntector.kartra">Enable {{ nameActiveIntegration }}</el-checkbox>
                                <div class="has-label">
                                    <label class="mt-1">Enter your API Key</label>
                                    <el-input type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
                                        class="flex-grow-1 mb-0" v-model="userApiKey.kartra" aria-controls="datatables">
                                    </el-input>
                                </div>
                                <div class="has-label">
                                    <label class="mb-0">Enter your API Password</label>
                                    <el-input type="text" clearable label="Enter your API Password"
                                        placeholder="GJYEzzse345673htj" class="flex-grow-1 mb-0" v-model="kartraApiPassword"
                                        aria-controls="datatables">
                                    </el-input>
                                </div>
                                <p class="mt-4 d-block"><strong>Note:</strong> When you click Save, this app will create the
                                    below custom fields in your Kartra account. These fields are Required for this connection to
                                    work properly.
                                    As per Kartra's policy, once a custom field is deleted, it cannot be recreated. Therefore,
                                    <span class="text-underline">Do NOT</span> delete or rename the below custom fields in your
                                    Kartra account. <strong style="cursor: pointer;" v-if="!showKartraCustomFields"
                                        @click="showKartraCustomFields = !showKartraCustomFields">show more</strong>
                                </p>
                                <ul v-show="showKartraCustomFields" class="text-dark">
                                    <li class="text-dark">secondphone</li>
                                    <li class="text-dark">secondemail</li>
                                    <li class="text-dark">keyword</li>
                                    <li class="text-dark">secondaddress</li>
                                </ul>
                            </div>
                            <div v-if="selectedIntegration === 'zapier'" class="''">
                                <el-checkbox v-model="enabledconntector.zapier">Enable {{ nameActiveIntegration }}</el-checkbox>
                                
                                <div class="webhook-section mt-3">
                                    <div class="webhook-section__header">
                                        <div>
                                            <h5 class="webhook-section__title">Zapier Webhooks</h5>
                                            <p class="webhook-section__subtitle">
                                                Connect one or more Zapier webhook URLs to receive lead data in real time.
                                            </p>
                                        </div>
                                    </div>

                                    <div class="webhook-section__body">
                                        <label class="webhook-section__label">Webhook URLs</label>
                                        <p class="webhook-section__helper">
                                            You can add multiple webhook URLs. Each URL will receive the same payload.
                                        </p>

                                        <div class="webhook-list">
                                            <div
                                                v-for="(url, index) in userApiKey.zapier"
                                                :key="index"
                                                class="webhook-item"
                                            >
                                                <div class="webhook-item__main">
                                                    <span class="webhook-item__badge">
                                                        {{ index + 1 }}
                                                    </span>
                                                    <div class="webhook-item__fields">
                                                        <el-input
                                                            type="text"
                                                            clearable
                                                            label="Enter your Webhook URL"
                                                            placeholder="https://hooks.app.com/hooks/catch/....."
                                                            class="webhook-item__input"
                                                            v-model="userApiKey.zapier[index]"
                                                            aria-controls="datatables"
                                                            @keyup.native="addWebhookUrlKeyupEnter($event, 'zapier')"
                                                            :ref="'webhookInput-' + index"
                                                        >
                                                        </el-input>
                                                        <el-input
                                                            type="text"
                                                            clearable
                                                            placeholder="Webhook Label (optional)"
                                                            class="webhook-item__label-input"
                                                            v-model="zapierWebhookLabels[index]"
                                                        >
                                                        </el-input>
                                                    </div>
                                                </div>
                                                <div class="webhook-item__actions">
                                                    <el-button
                                                        v-if="index !== 0 || userApiKey.zapier.length > 1"
                                                        type="text"
                                                        size="mini"
                                                        @click="removeWebhookUrl(index, 'zapier')"
                                                    >
                                                        <i class="fa-solid fa-minus mr-1"></i> Remove
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="webhook-section__footer">
                                            <el-button
                                                type="primary"
                                                size="mini"
                                                icon="el-icon-plus"
                                                @click="addWebhookUrl('zapier')"
                                            >
                                                Add Webhook URL
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="d-flex mt-4">
                                    <el-checkbox  v-model="enabledconntector.sendTestZapier" class="mt-2 mr-3">Send Test Data</el-checkbox>
                                       <div class="d-flex align-items-center">
                                        <el-button
                                            class="mr-2 mb-1"
                                            :icon="'el-icon-view'"
                                            @click="onViewExampleData"
                                            style="width: 10px; height: 10px; padding: 0; background-color: transparent; color: var(--text-primary-color); border: none;"></el-button>
                                            <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                                        </div>
                                </div>
                                <p class="m-0"><small>* check and click save to send dummy data to your webhook</small></p>
                                <p class="m-0 pl-2"><strong>Need help setting up your webhook?</strong> Check out the documentation:</p>
                                <p class="m-0 pl-2"><a href="https://api.slack.com/messaging/webhooks" target="_blank">Slack</a> | <a href="https://developers.make.com/custom-apps-documentation/app-structure/modules/instant-trigger" target="_blank">Make</a> | <a href="https://help.zapier.com/hc/en-us/articles/8496083355661-How-to-get-started-with-Webhooks-by-Zapier" target="_blank">Zapier</a> | <a href="https://www.pabbly.com/beginners-guide-to-webhook-integration-with-pabbly-connect/" target="_blank">Pabbly</a> | <a href="https://www.zoho.com/developer/help/extensions/automation/webhooks.html" target="_blank">ZoHo</a> | <a href="https://developers.hubspot.com/docs/guides/api/app-management/webhooks" target="_blank">HubSpot</a></p>
                            </div>
                            <div v-if="selectedIntegration === 'mailboxpower'" class="''">
                                <el-checkbox v-model="enabledconntector.mailboxpower">Enable {{ nameActiveIntegration }}</el-checkbox>
                                <div class="has-label">
                                    <label class="mt-1">Enter your API Key</label>
                                    <el-input type="text" clearable label="Enter your API Key" placeholder="AssAW02A02ksjsklah"
                                        class="flex-grow-1 mb-0" v-model="userApiKey.mailboxpower" aria-controls="datatables">
                                    </el-input>
                                </div>
                                <div class="d-flex" style="flex-direction: column; gap: 12px; margin-top: 25px" v-if="referralCodeActive != ''">
                                   <span style="display: flex; align-items: center;gap: 8px">
                                    <el-button
                                        size="medium"
                                        icon="el-icon-unlock"
                                        @click="redirectToLink(`https://app.mailboxpower.com/join/agency?invite=${referralCodeActive}`)"
                                        circle

                                        ></el-button> <span>If you do not have a {{ nameActiveIntegration }} account, <a style="color: inherit !important;font-size: inherit;font-weight: bold;" :href="`https://app.mailboxpower.com/join/agency?invite=${referralCodeActive}`" target="_blank">Click Here</a> to create one</span>
                                    </span>
                                    <span style="display: flex; align-items: center;gap: 8px">
                                    <el-button
                                        size="medium"
                                        icon="el-icon-s-promotion"
                                        @click="redirectToLink(`https://app.mailboxpower.com/demo/${referralCodeActive}`)"
                                        circle
                                        ></el-button>
                                    <a style="color: inherit !important;font-size: inherit;font-weight: inherit" class="d-block" :href="`https://app.mailboxpower.com/demo/${referralCodeActive}`" target="_blank">Learn More about the Integration</a>
                                </span>
                                </div>
                            </div>
                            <div v-if="selectedIntegration === 'clickfunnels'" style="display: flex; flex-direction: column; gap: 8px;">
                                <el-checkbox v-model="enabledconntector.clickfunnels">Enable {{ nameActiveIntegration }}</el-checkbox>
                                <div class="has-label">
                                    <label class="mb-0">Enter your API Key</label>
                                    <el-input type="text" clearable label="Enter your API Key" placeholder="Xg7Pq-K9vTzJ_OLmAB3cYRDx5WNF24sMEUhCo6J0VaI"
                                    class="flex-grow-1 mb-0" v-model="userApiKey.clickfunnels" aria-controls="datatables">
                                </el-input>
                                </div>
                                <div class="has-label">
                                    <label class="mb-0">Subdomain</label>
                                    <el-input v-model="clickfunnels.subdomain" type="text" clearable label="Enter your subdomain"
                                        placeholder="richstone" class="flex-grow-1 mb-0"
                                        aria-controls="datatables">
                                        <template :slot="windowWidth > 576 && 'prepend'">https://</template>
                                        <template :slot="windowWidth > 576 && 'append'">.myclickfunnels.com</template>
                                    </el-input>
                                    <small v-if="windowWidth < 576" class="wrap-text">Example: https://{{ clickfunnels.subdomain ? clickfunnels.subdomain : 'yoursubdomain' }}.myclickfunnels.com</small>
                                </div>
                                <div class="has-label">
                                    <label class="mb-0">Workspace ID</label>
                                    <el-input v-model="clickfunnels.workspaceId" type="text" clearable label="Enter your workspaces"
                                        placeholder="jWMWXZ" class="flex-grow-1 mb-0"
                                        aria-controls="datatables">
                                        <template :slot="windowWidth > 768 && 'prepend'">https://{{ clickfunnels.subdomain }}.myclickfunnels.com/account/workspaces/</template>
                                    </el-input>
                                    <small v-if="windowWidth < 768" class="wrap-text">Example: https://{{ clickfunnels.subdomain ? clickfunnels.subdomain : 'yoursubdomain' }}.myclickfunnels.com/account/workspaces/workspaceid</small>
                                </div>
                                <template>
                                    <CheckboxCustomFields
                                        :slug="'Clickfunnels'"
                                        :isLoadingCustomFieldsBySlug="isLoadingCustomFieldsBySlug"
                                        :isErrorCustomFieldsBySlug="isErrorCustomFieldsBySlug"
                                        :handleDefaultCustomFields="handleDefaultCustomFields"
                                        :customFieldsBySlug="customFieldsBySlug['clickfunnels']"
                                        :listValueFieldsIntegration="listValueFieldsIntegrationClickfunnels"
                                        :listValueFieldsIntegrationB2b="listValueFieldsIntegrationClickfunnelsb2b"
                                        :handleCheckItemCustomFields="handleCheckItemCustomFields"
                                        :isHideB2b="isHideB2b"
                                        :isHideAdvance="isHideAdvance"
                                        :handleCheckAllCustomFields="handleCheckAllCustomFields"
                                        :isCheckAllIntegrationGeneral="isCheckAllIntegrationGeneral"
                                        :isCheckAllIntegrationB2b="isCheckAllIntegrationB2b"
                                        :isCheckAllIntegrationAdvance="isCheckAllIntegrationAdvance"
                                    />
                                </template>
                            </div>
                            <div v-if="selectedIntegration === 'agencyzoom'" class="''">
                                <el-checkbox v-model="enabledconntector.agencyzoom">Enable {{ nameActiveIntegration }}</el-checkbox>
                                
                                <div class="webhook-section mt-3">
                                    <div class="webhook-section__header">
                                        <div>
                                            <h5 class="webhook-section__title">AgencyZoom Webhooks</h5>
                                            <p class="webhook-section__subtitle">
                                                Connect one or more AgencyZoom webhook URLs to receive lead data in real time.
                                            </p>
                                        </div>
                                    </div>

                                    <div class="webhook-section__body">
                                        <label class="webhook-section__label">Webhook URLs</label>
                                        <p class="webhook-section__helper">
                                            You can add multiple webhook URLs. Each URL will receive the same payload.
                                        </p>

                                        <div class="webhook-list">
                                            <div
                                                v-for="(url, index) in userApiKey.agencyzoom"
                                                :key="index"
                                                class="webhook-item"
                                            >
                                                <div class="webhook-item__main">
                                                    <span class="webhook-item__badge">
                                                        {{ index + 1 }}
                                                    </span>
                                                    <el-input
                                                        type="text"
                                                        clearable
                                                        label="Enter your Webhook URL"
                                                        placeholder="https://app.agencyzoom.com/v1/api/lead/webhook/....."
                                                        class="webhook-item__input"
                                                        v-model="userApiKey.agencyzoom[index]"
                                                        aria-controls="datatables"
                                                        @keyup.native="addWebhookUrlKeyupEnter($event, 'agencyzoom')"
                                                        :ref="'zoomAgencywebhookInput-' + index"
                                                    >
                                                    </el-input>
                                                </div>
                                                <div class="webhook-item__actions">
                                                    <el-button
                                                        v-if="index !== 0 || userApiKey.agencyzoom.length > 1"
                                                        type="text"
                                                        size="mini"
                                                        @click="removeWebhookUrl(index, 'agencyzoom')"
                                                    >
                                                        <i class="fa-solid fa-minus mr-1"></i> Remove
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="webhook-section__footer">
                                            <el-button
                                                type="primary"
                                                size="mini"
                                                icon="el-icon-plus"
                                                @click="addWebhookUrl('agencyzoom')"
                                            >
                                                Add Webhook URL
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                                
                                <el-checkbox v-model="enabledconntector.sendTestAgencyZoom" class="mt-2">Send Test Data</el-checkbox>
                                <p class="m-0"><small>* check and click save to send dummy data to your webhook</small></p>
                            </div>
                            <div v-if="selectedIntegration === 'sendjim'" class="''">
                                <el-checkbox v-model="enabledconntector.sendjim" @change="handleSendjimCheckboxChange">Enable {{ nameActiveIntegration }}</el-checkbox>
                                
                                <!-- Wizard mode: Show disabled message for OAuth -->
                                <div v-if="modals.create && campaignCreateActiveStep === 3" class="wizard-sendjim-oauth-disabled" style="margin-top: 20px;">
                                    <div style="padding: 20px; background-color: #f8f9fa; border-radius: 8px; border-left: 4px solid #909399;">
                                        <div style="display: flex; align-items: center; margin-bottom: 12px;">
                                            <i class="fas fa-lock" style="font-size: 20px; color: #909399; margin-right: 10px;"></i>
                                            <h5 style="margin: 0; color: #606266;">OAuth Connection Not Available</h5>
                                        </div>
                                        <p style="color: #909399; font-size: 14px; line-height: 1.6; margin-bottom: 0;">
                                            OAuth connection for SendJim is not available during client setup. You can configure OAuth connection after completing the client creation wizard by going to the client's Integration Settings.
                                        </p>
                                        <div style="margin-top: 16px; padding: 12px; background-color: #f0f9ff; border-radius: 6px; border-left: 3px solid #3b82f6;">
                                            <p style="margin: 0; color: #1e40af; font-size: 13px;">
                                                <i class="fas fa-info-circle" style="margin-right: 8px;"></i>
                                                <strong>Note:</strong> You can still save your Client ID and Client Secret below. OAuth connection can be set up later.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Standalone mode: Show OAuth connection options -->
                                <div v-else>
                                    <div class="has-label" style="margin-top: 10px; margin-bottom: 20px;">
                                        <p v-if="sendjimConnected">You have connected SendJim for this client.</p>
                                        <p v-else>You have not yet connected SendJim for this client.</p>
                                    </div>
                                    <div>
                                        <base-button id="btnConnectDisconnectSendjim" :disabled="isLoadingConnectDisconnectSendjim" @click="connectDisconnectSendjim">
                                            {{ btnConnectDisconnectSendjimText }}
                                            <i v-if="isLoadingConnectDisconnectSendjim" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                        </base-button>
                                    </div>
                                    <el-divider content-position="left">Connect using OAuth2</el-divider>
                                    <div class="has-label" style="margin-bottom: 16px;">
                                        <label class="mb-0">OAuth Redirect URL</label>
                                        <el-input :value="sendjimCallbackUrl" readonly class="flex-grow-1 mb-0">
                                            <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard(sendjimCallbackUrl)"></el-button>
                                        </el-input>
                                        <small>Use the URL above as your OAuth callback/redirect URL in SendJim.</small>
                                    </div>
                                </div>
                                
                                <!-- Client ID and Client Secret inputs (available in both modes) -->
                                <div class="row" style="margin-top: 20px;">
                                    <div class="col-md-12">
                                        <div class="has-label">
                                            <label class="mb-0">Client ID <span style="color: var(--danger);">*</span></label>
                                            <el-input v-model="userApiKey.sendjim" type="text" clearable placeholder="Enter your SendJim Client ID" class="flex-grow-1 mb-0" aria-controls="datatables"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="has-label">
                                            <label class="mb-0">Client Secret <span style="color: var(--danger);">*</span></label>
                                            <el-input v-model="sendjim.clientSecret" type="password" show-password clearable placeholder="Enter your SendJim Client Secret" class="flex-grow-1 mb-0" aria-controls="datatables"></el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <base-button size="sm" class="pull-right" id="btnSave" style="height:40px"
                        @click="updateCreateCampaignStep"
                        :disabled="saveNextButtonState.disabled">
                       {{saveNextButtonState.loading ? 'Saving...' : saveNextButtonState.text}}
                    </base-button>
                    <base-button v-if="campaignCreateActiveStep > 0" simple size="sm" class="pull-right mr-2" style="height:40px"
                        @click="skipCreateCampaignStep"
                        :disabled="saveNextButtonState.loading || saveNextButtonState.disabled">
                       Skip
                    </base-button>
                    <base-button simple size="sm" class="pull-right mr-4" style="height:40px"
                        @click="CancelAddEditClient('')"
                        :disabled="saveNextButtonState.loading || saveNextButtonState.disabled">
                       {{'Cancel'  }}
                    </base-button>
                </div>
            </template>
           </modal>
           <!-- create client Model -->

           <!-- Edit Client Modal -->
           <modal :show.sync="modals.edit"
                  bodyClasses='create-campaign-modal-body'
            footerClasses="border-top p-2">
            <h3 slot="header" class="title title-up">Edit Client {{editClientData ? editClientData.company_name : ''}}</h3>
            <div class="row mt-4" v-if="editClientData">
                <ValidationObserver ref="frmEditClient" v-slot="{ handleSubmit }" class="col-12">
                    <form autocomplete="off">
                        <input autocomplete="false" name="hidden2" type="text" style="display:none;">
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4 form-group has-label">
                                <ValidationProvider name="Client's Business Name" rules="required|max:255" v-slot="{ passed, failed, errors }">
                                    <base-input label="Client's Business Name" type="text"
                                        placeholder="Input Client's Business Name"
                                        maxlength="255"
                                        v-model="editClientData.company_name" :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-4 col-md-4 col-lg-4">
                                <ValidationProvider name="Client's Personal Name" rules="required|max:255" v-slot="{ passed, failed, errors }">
                                    <base-input label="Client's Personal Name" type="text"
                                        placeholder="Input Client's Personal Name"
                                        maxlength="255"
                                        v-model="editClientData.name" :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-4 col-md-4 col-lg-4">
                                <ValidationProvider name="email" rules="required|email" v-slot="{ passed, failed, errors }">
                                    <base-input label="Email" type="email"
                                        placeholder="Input Email"
                                        max="70"
                                        :maxLength="70"
                                     
                                        v-model="editClientData.email" :lowercase="true"
                                        :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>

                            <div class="col-sm-6 col-md-6 col-lg-6 form-group">
                                <label>Phone Number</label>
                                <VuePhoneNumberInput
                                    :defaultCountryCode="clientRowPhoneNumber.countryCode"
                                    v-model="clientRowPhoneNumber.number"
                                    @update="onRowPhoneUpdate" />
                                <small v-if="phoneRowError" class="text-danger d-block mt-1" style="color:#942434 !important;">{{ phoneRowError }}</small>
                            </div>

                            <div class="col-sm-6 col-md-6 col-lg-6 form-group has-label password-icon-container">
                                <base-input label="Update Password:" :type="showPassword ? 'text' : 'password'"
                                    placeholder="Type your new password"
                              
                                    v-model="editClientData.newpassword">
                                </base-input>
                                <button
                                    type="button"
                                    class="icon-password"
                                    @click="togglePassword">
                                    <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                </button>
                            </div>
                            <div class="mt-2">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <base-checkbox
                                        v-model="editClientData.disabled_receive_email"
                                        inline>Disable all system emails to this client</base-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                    <base-checkbox
                                        v-model="editClientData.disable_client_add_campaign"
                                        inline>Disable clients ability to add campaigns</base-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                    <base-checkbox
                                        v-model="editClientData.editor_spreadsheet"
                                        inline>Set as Editor Google Spreadsheet</base-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input
                                                :key="'phone-edit-' + rowCheckboxes.phoneenabled"
                                                class="form-check-input"
                                                type="checkbox"
                                                :checked="rowCheckboxes.phoneenabled"
                                                @click.prevent="handlePhoneCheckboxClick('rowCheckboxes')"
                                            />
                                            <span class="form-check-sign"></span>
                                            Enable Phone Number when Create Campaign
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-2">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <span v-if="hasProducts" class="" style="font-size: 0.80143rem;">Product(s) :</span>
                                    <base-checkbox
                                        v-for="(sidebar, key) in customsidebarleadmenu"
                                        :key="sidebar.url"
                                        class="mr-3"
                                        v-model="selectedModules[key]"
                                        v-show="validateBetaFeature(key) && (sidebar.url != 'simplifiid' || $global.idsys == $global.masteridsys)">
                                        {{ sidebar.name }}
                                    </base-checkbox>
                                </div>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
            <template slot="footer">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <base-button v-if="$global.settingMenuShow_update"
                        :id="'btnSaveEdit'" size="sm" class="pull-right"
                        style="height:40px" @click="saveEditClient">
                        Save
                    </base-button>
                    <base-button size="sm" class="pull-right mr-4"
                        style="height:40px" @click="cancelEditClient">
                        Cancel
                    </base-button>
                    <base-button size="sm" class="pull-right mr-4"
                        :id="'btnResendEdit'" style="height:40px"
                        @click="resendInvitationEdit">
                        Resend Invitation
                    </base-button>
                </div>
            </template>
           </modal>
           <!-- Edit Client Modal -->
    </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email} from "vee-validate/dist/rules";
import { DatePicker, Table, TableColumn, Select, Option,Checkbox, Dropdown, DropdownMenu, DropdownItem,CollapseItem,Collapse,Button, Progress, Divider, MessageBox, Loading, Tabs, TabPane, Timeline, TimelineItem, Notification } from 'element-ui';
import { BasePagination,Modal, SkeletonCheckbox } from 'src/components';
import Fuse from 'fuse.js';
import swal from 'sweetalert2';
import moment from 'moment';
import { mapActions } from "vuex";
import VuePhoneNumberInput from '@/components/VuePhoneNumberInput';
import axios from 'axios';
import { formatCurrencyUSD } from '@/util/formatCurrencyUSD'
import { downloadFileInBackground, downloadFileInBackgroundPdf } from '../../../../helpers/downloadFile'
import { emailPattern } from '../../../../util/validation'
import { decryptData } from '../../../../helpers/crypto'
import CheckboxCustomFields from '../../../../components/CheckboxCustomFields.vue'
import { DOCUMENTS } from "../../../../shared/constants";
import StepIndicator from '../../../../components/StepIndicator.vue';
const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

extend("email", email);
extend("required", required);
extend("max", {
  validate(value, { length }) {
    return value.length <= length;
  },
  params: ['length'],
  message: 'The {_field_} field may not be greater than {length} characters'
});

var _elements;
var _cardElement;
var _stripe;
var _CardValidate;
var _tokenid = '';
var _sppubkey = '';
var _this;

export default {
    components: {
        Modal,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Checkbox.name]: Checkbox,
        BasePagination,
        VuePhoneNumberInput,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Progress.name]: Progress,
        [Divider.name]: Divider,
        SkeletonCheckbox,
        CheckboxCustomFields,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Timeline.name]: Timeline,
        [TimelineItem.name]: TimelineItem,
        StepIndicator,
    },
    data() {
        return {
            showPassword : false ,
            showMoreHelp:false,
            dropdownVisible: false,
            clientMinLeadDayEnhance: '',
            errMinLeadDay: false, 
            basicExampleDataUrl: 'https://sitesettings-api-docs.vercel.app/agency/informations/send-test',
            filters:{
                cardStatus:{
                    show:false,
                    active:false,
                    failed:false,
                    inactive:false
                },
                campaignStatus:{
                    show:false,
                    active:false,
                    inactive:false,
                }
            },
            termhost:'',
            showKartraCustomFields:'',
            integrations: [
                {
                    name: 'Twilio SendGrid',
                    description: 'Deliver Exceptional Email Experiences with SendGrid',
                    icon: 'fa-solid fa-cloud-arrow-up',
                    active: '3',
                    slug: 'sendgrid',
                    refcode: ''
                },
                {
                    name: 'Lead Connector',
                    description: 'Get Better Clicks & Engagement - Enhance Your Email Campaigns.',
                    icon: 'fa-light fa-cube',
                    active: '4',
                    slug: 'gohighlevel',
                    refcode: ''
                },
                {
                    name: 'Kartra',
                    description: 'This is Kartra intergration .',
                    icon: 'fa-solid fa-k',
                    active: '5',
                    slug: 'kartra',
                    refcode: ''
                },
                {
                    name: 'Zapier/Webhooks',
                    description: 'This is Zapier intergration .',
                    icon: 'fa-solid fa-link',
                    active: '6',
                    slug: 'zapier',
                    refcode: ''
                },
                {
                    name: 'MailBoxPower',
                    description: 'Get Better Clicks & Engagement - Enhance Your Email Campaigns.',
                    icon: 'fa-regular fa-envelope-open',
                    active: '7',
                    slug: 'mailboxpower',
                    refcode: 'C8GWKU'
                },
                {
                    name: 'ClickFunnels',
                    description: 'Build High-Converting Sales Funnels - Turn Visitors into Customers Easily.',
                    icon: 'fas fa-mouse-pointer',
                    active: '8',
                    slug: 'clickfunnels',
                    refcode: ''
                },
                {
                    name: 'Zoom Agency',
                    description: 'This is Zoom Integration intergration .',
                    icon: 'fa-solid fa-diagram-project',
                    active: '9',
                    slug: 'agencyzoom',
                    refcode: ''
                },
                {
                    name: 'SendJim',
                    description: 'Direct Mail Marketing.',
                    icon: 'fa-solid fa-diagram-project',
                    active: '10',
                    slug: 'sendjim',
                    refcode: ''
                },
                // {
                //     name: 'Webhook',
                //     description: 'Webhook Integration.',
                //     img: 'fa-solid fa-link',
                //     active: '7',
                //     slug: 'webhook'
                // },
            ],
            nameActiveIntegration: 'Sendgrid',
            referralCodeActive: '',
            /** FOR SUPRESSION UPLOAD FILE */
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null,
            uploadFieldName: 'clientoptoutfile',
            /** FOR SUPRESSION UPLOAD FILE */
            selectedIntegration: 'sendgrid',
            selectedModule: 'LeadsPeek',
             tableDataOri:[],
             tableData: [],
             fuseSearch: null,
             searchedData: [],
             searchQuery: '',
             pagination: {
                perPage: 10,
                currentPage: 1,
                //perPageOptions: [5, 10, 25, 50],
                total: 0,
                from: 0,
                to: 0,
            },

            currCardHolder: '',
            currCardlastdigit: '',
            currCardType: '',

            cardholdername: '',
            billingaddress: '',
            city: '',
            zipcode: '',
            selects: {
                state: '',
                country: '',
                statelist: [],
                ghlv2SubAccount: ''
            },
            paginationGhlV2SubAccount: {
                currentPage: 1,
                isComplete: false,
                isFetch: false,
            },
            agreeTerm:false,
            showErrorMessage:false,
            cardfailetoload:false,
            agreeTermStat:false,
            btncardupdate: false,

            modals: {
                helpguide: false,
                pricesetup: false,
                cardsetup: false,
                cardupdate: false,
                integrations: false,
                whitelist: false,
                cardretrycharge: false,
                help:false,
                create: false,
                edit: false
            },
            
            cardretrychargeTitle: '',
            cardretrychargeTxt: '',
            helpContentMap: [
                {   
                    title:'Clients',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/1oTshTuYqnQg-LYUNYrpcU0UNiEI1S_5g/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:'In this section you can add and edit your system administrators. We do not charge for administrators so you may add as many as you need for your business.<br>Make sure that every administrator and client has a unique email address, as email addresses are used for access permissions.<br>If you set someone as a default admin, they will receive new campaign creation notices as well as have this email address added as an editor by default to all the Google sheets that are created. You may have unlimited default admins.<br>The customer care selection is singular. You can only have one customer care admin in the system as this is used as a token in the email templates.<br>The third checkbox is if an admin wants to receive notifications of failed billing.<br>An admin can be set as one two or three check boxes. They are not exclusive.'
                },
                { 
                    title: 'Site ID Basic Information',
                    desc: "Site ID campaigns can use either Basic information or Advanced information, similar to Enhance ID. You must set the retail price for each of these data options independently of each other.",
                    embedVideoCode: '<iframe src="https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/basicdata.jpeg" width="100%" height=180></iframe>'
                },
                {
                    title: 'Site ID Advanced Information',
                    desc: "Site ID campaigns can use either Basic information or Advanced information, similar to Enhance ID. You must set the retail price for each of these data options independently of each other.",
                    embedVideoCode: '<iframe src="https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/advancedata.jpeg" width="100%" height=230></iframe>'
                }
            ],
            activeHelpItem:  { 
                title:'Clients',
                embedVideoCode:'<iframe src="https://drive.google.com/file/d/1oTshTuYqnQg-LYUNYrpcU0UNiEI1S_5g/preview" width="100%" height="480" allow="autoplay"></iframe>',
                desc:'In this section you can add and edit your system administrators. We do not charge for administrators so you may add as many as you need for your business.<br>Make sure that every administrator and client has a unique email address, as email addresses are used for access permissions.<br>If you set someone as a default admin, they will receive new campaign creation notices as well as have this email address added as an editor by default to all the Google sheets that are created. You may have unlimited default admins.<br>The customer care selection is singular. You can only have one customer care admin in the system as this is used as a token in the email templates.<br>The third checkbox is if an admin wants to receive notifications of failed billing.<br>An admin can be set as one two or three check boxes. They are not exclusive.'
            },
            activeHelpIndex: 0,
            companyID:'',
            selectedRowIndex: 0,
            selectedRowData: {},
            ClientCompanyName: '',
            ClientFullName: '',
            ClientEmail: '',
            clientPhoneNumber:{
                number:'',
                countryCode:'US',
                countryCallingCode:'+1',
                isValid: false
            },
            clientRowPhoneNumber:{
                number:'',
                countryCode:'US',
                countryCallingCode:'+1',
                isValid: false
            },
            phoneError: '',
            phoneRowError: '',
            ClientPhone: '',
            ClientActiveID: '',
            selectedClientPaymentStatus: '',
            ClientDomain:'',
            LeadspeekCompany: '',

            LeadspeekPlatformFee: '0',
            LeadspeekCostperlead: '0',
            LeadspeekCostperleadAdvanced: '0',
            LeadspeekMinCostMonth: '0',
            LeadspeekLeadsPerday: '10',
            LeadspeekEnableMinimumLeadsPerDay: false,

            LocatorPlatformFee: '0',
            LocatorCostperlead: '0',
            LocatorMinCostMonth: '0',
            LocatorLeadsPerday: '10',
            LocatorEnableMinimumLeadsPerDay: false,

            EnhancePlatformFee: '0',
            EnhanceCostperlead: '0',
            EnhanceMinCostMonth: '0',
            EnhanceLeadsPerday: '10',
            EnhanceEnableMinimumLeadsPerDay: false,
            
            B2bPlatformFee: '0',
            B2bCostperlead: '0',
            B2bMinCostMonth: '0',
            B2bLeadsPerday: '10',
            B2bEnableMinimumLeadsPerDay: false,

            SimplifiMaxBid: '0',
            SimplifiDailyBudget: '0',
            SimplifiAgencyMarkup: '0',
            simplifiPriceRule: {
                maxBid: {
                    default: 12,
                    minimum: 8
                },
                dailyBudget: {
                    minimum: 5
                },
            },
            simplifiErrorInput: {
                maxBid: "",
                dailyBudget: ""
            },
            agencyMarkup: {
                list : [
                    {
                        value : 0,
                        text : '0%',
                    },
                    {
                        value : 5,
                        text : '5%',
                    },
                    {
                        value : 10,
                        text : '10%',
                    },
                    {
                        value : 15,
                        text : '15%',
                    },
                    {
                        value : 20,
                        text : '20%',
                    },
                    {
                        value : 25,
                        text : '25%',
                    },
                    {
                        value : 30,
                        text : '30%',
                    },
                    {
                        value : 40,
                        text : '40%',
                    },
                    {
                        value : 50,
                        text : '50%',
                    },
                ]
            },


            LeadspeekInputReadOnly: false,
            prevDefaultRetailPrice: null,
            activeClientID: '',

            userData: '',
            m_LeadspeekCostPerLead:0,
            m_LeadspeekCostPerLeadAdvanced:0,
            m_LeadspeekLocatorCostPerLead:0,
            m_LeadspeekEnhanceCostPerLead:0,
            m_LeadspeekB2BCostPerLead:0,
            m_LeadspeekPlatformFee: 0,
            m_LeadspeekMinCostMonth: 0,
            m_LeadspeekLocatorPlatformFee: 0,
            m_LeadspeekLocatorMinCostMonth: 0,
            m_LeadspeekEnhancePlatformFee: 0,
            m_LeadspeekEnhanceMinCostMonth: 0,
            m_LeadspeekB2BPlatformFee: 0,
            m_LeadspeekB2BMinCostMonth: 0,
            rootCostAgency : {
                local : {
                    'Weekly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'Monthly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'OneTime' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    }
                },

                locator : {
                    'Weekly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'Monthly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'OneTime' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    }
                },

                enhance : {
                    'Weekly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'Monthly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'OneTime' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    }
                },

                b2b : {
                    'Weekly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'Monthly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'OneTime' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    }
                },

                locatorlead: {
                    FirstName_LastName: '0',
                    FirstName_LastName_MailingAddress: '0',
                    FirstName_LastName_MailingAddress_Phone: '0',
                }
            },

            lead_FirstName_LastName : '0',
            lead_FirstName_LastName_MailingAddress: '0',
            lead_FirstName_LastName_MailingAddress_Phone: '0',

            costagency : {
                local : {
                    'Weekly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'Monthly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'OneTime' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '50',
                    }
                },

                locator : {
                    'Weekly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    },
                    'Monthly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    },
                    'OneTime' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    }
                },

                enhance : {
                    'Weekly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    },
                    'Monthly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    },
                    'OneTime' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    }
                },

                b2b : {
                    'Weekly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                        B2bLeadsPerday: '10',
                    },
                    'Monthly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                        B2bLeadsPerday: '10',
                    },
                    'OneTime' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                        B2bLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                        B2bLeadsPerday: '10',
                    }
                },

                locatorlead: {
                    FirstName_LastName: '0',
                    FirstName_LastName_MailingAddress: '0',
                    FirstName_LastName_MailingAddress_Phone: '0',
                }
            },

            activeClientCompanyID: '',
            activeClientCompanyIndex: '',

            txtLeadService: 'per week',
            txtLeadIncluded: 'in that weekly charge',
            txtLeadOver: 'from the weekly charge',

            selectsPaymentTerm: {
                PaymentTermSelect: 'Weekly',
                PaymentTerm: [
                    // { value: 'One Time', label: 'One Time'},
                    // { value: 'Weekly', label: 'Weekly'},
                    // { value: 'Monthly', label: 'Monthly'},
                ],
            },
            selectsAppModule: {
                AppModuleSelect: 'LeadsPeek',
                AppModule: [
                    { value: 'LeadsPeek', label: 'LeadsPeek' },
                ],
                LeadsLimitSelect: 'Day',
                LeadsLimit: [
                    { value: 'Day', label: 'Day'},
                ],
            },

            selectsPTAds: {
                    PTAdsSelect: 'By Fix Amount',
                    PTAds: [
                        { value: 'By Fix Amount', label: 'By Fix Amount' },
                        { value: 'By Percentage', label: 'By Percentage' },
                        
                    ],
            },

            disabledreceiveemail: false,
            openFiletrs: false,
            disabledaddcampaign:false,
            seteditor:false,
            enablephonenumber:false,
            checkboxes: {
                phoneenabled: false,
            },
            rowCheckboxes: {
                phoneenabled: false,
            },
            integrationDetails:{},
            userApiKey: {
                sendgrid: '',
                gohighlevel: '',
                kartra: '',
                zapier:[''],
                mailboxpower: '',
                clickfunnels: '',
                agencyzoom: [''],
                sendjim: '',
            },
            zapierWebhookLabels: [''],

            ghlV2Connected: false,
            btnConnectDisconnectGhlv2Text: 'Activate Contact Sync',
            isLoadingConnectDisconnectGhlv2: false,

            ghlV2ListSubAccounts: [],
            ghlV2AgencyConnected: false,
            ghlV2CreatedIframe: false,
            btnCreateDeleteIframeGhlv2Text: 'Create SSO Link',
            isLoadingCreateDeleteIframeGhlV2: false,

            kartraApiPassword:'',
            kartraAppId:'',
            integrationVersion: {
                gohighlevel: "1",
                sendjim: "4",
            },
            // SendJim OAuth-only state
            sendjimConnected: false,
            btnConnectDisconnectSendjimText: 'Connect SendJim',
            isLoadingConnectDisconnectSendjim: false,
            sendjimAuthType: 'oauth2',
            enabledconntector: {
                sendgrid: false,
                gohighlevel: false,
                kartra: false,
                zapier:false,
                sendTestZapier: false,
                mailboxpower: false,
                clickfunnels: false,
                agencyzoom: false,
                sendTestAgencyZoom: false,
                sendjim: false,
            },
            sendjim: {
                clientSecret: '',
            },
            clickfunnels: {
                subdomain: '',
                workspaceId: '',
            },
            currentRowIndex:0,
            whiteListClientID: '',
            optoutfileexist: false,
            optoutpath: process.env.VUE_APP_CDN,
            clientPaymentFailed: false,
            currSortBy: '',
            currOrderBy: '',
            failedCampaignNumber: [],
            failedInvoiceAmount: [],
            failedTotalOutstanding:0,

            supressionProgress: [],
            supressionDone: [],
            supressionInterval: '',
            windowWidth: window.innerWidth,
            customsidebarleadmenu:[],
            selectedModules:{},
            selectedModulesCreate:{},
            expandedRow: null,
            isProcessingExpandRow: false,
            moduleAgency: {},
            prevSelectedModules: [],
            localActiveCampaignId: [],
            locatorActiveCampaignId: [],
            enhanceActiveCampaignId: [],
            b2bActiveCampaignId: [],
            simplifiActiveCampaignId: [],
            customFieldsBySlug: {},
            isLoadingCustomFieldsBySlug: false,
            isErrorCustomFieldsBySlug: false,
            isLoadingClientFinancials : false,
            isHideB2b: false,
            isHideAdvance: false,
            listValueFieldsIntegrationClickfunnels: [],
            listValueFieldsIntegrationClickfunnelsb2b: [],
            // listValueFieldsIntegrationGohighlevel: [],
            prevListValueFieldsIntegrationClickfunnels: [],
            prevListValueFieldsIntegrationClickfunnelsb2b: [],
            listValueFieldsIntegrationGohighlevel: [],
            listValueFieldsIntegrationGohighlevelb2b: [],
            listValueFieldsIntegrationGohighleveladvance: [],
            prevListValueFieldsIntegrationGohighlevel: [],
            prevListValueFieldsIntegrationGohighlevelb2b: [],
            prevListValueFieldsIntegrationGohighleveladvance: [],
            // SendJim custom fields selections
            listValueFieldsIntegrationSendjim: [],
            listValueFieldsIntegrationSendjimb2b: [],
            listValueFieldsIntegrationSendjimadvance: [],
            prevListValueFieldsIntegrationSendjim: [],
            prevListValueFieldsIntegrationSendjimb2b: [],
            prevListValueFieldsIntegrationSendjimadvance: [],
            isIntegrationItemsFetch: false,
            integrationStatus: {
                loading: false,
                error: false,
            },
            isCheckAllIntegrationGeneral: false,
            isCheckAllIntegrationB2b: false,
            isCheckAllIntegrationAdvance: false,
            downloadingAgreements: {}, // Track downloading state per row by row.id
            isProductEmptyClient : false,
            campaignCreateActiveStep:0,
            createCampaignSteps: [
                { name: 'Basic Information' },
                { name: 'Card Information' },
                { name: 'Financial Setup' },
                { name: 'Integration Setup' }
            ],
            wizardIntegrationValues: {}, // Temporary storage for integration values in wizard mode
            createdClientData: null,
            useDefaultPricing: true, // Use default pricing checkbox (enabled by default for new clients)
            saveNextButtonState: {
                disabled: false,
                loading: false,
                text: 'Save & Next'
            },
            editClientData: null, // Store client data being edited
        }
    },

    computed: {
        sendjimCallbackUrl() {
            return `${process.env.VUE_APP_DATASERVER_URL}/sendjim/oauth/callback/view`;
        },
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        isPricingFieldsDisabled() {
            // Disable pricing fields in wizard step 2 if useDefaultPricing is enabled
            return this.modals.create && this.campaignCreateActiveStep === 2 && this.useDefaultPricing;
        },
        shouldSkipCCStep() {
            // Step CC hanya muncul jika manual_bill === 'F'
            const userData = this.$store.getters.userData;
            return userData.manual_bill !== 'F';
        },
        filteredCreateCampaignSteps() {
            // Filter out CC step if shouldSkipCCStep is true
            if (this.shouldSkipCCStep) {
                return this.createCampaignSteps.filter((step, index) => index !== 1);
            }
            return this.createCampaignSteps;
        },
        getAdjustedActiveStep() {
            // Adjust active step number if CC step is skipped
            if (this.shouldSkipCCStep) {
                // Step 0 (Basic Information) -> step 0
                // Step 1 (CC) -> should be skipped, but if somehow reached, show as step 1
                // Step 2 (Financial Setup) -> step 1 (because CC step is hidden)
                // Step 3 (Integration Setup) -> step 2 (because CC step is hidden)
                if (this.campaignCreateActiveStep === 0) return 0;
                if (this.campaignCreateActiveStep === 1) return 0; // CC step is skipped, show as step 0
                if (this.campaignCreateActiveStep === 2) return 1; // Financial Setup becomes step 1
                if (this.campaignCreateActiveStep === 3) return 2; // Integration Setup becomes step 2
            }
            return this.campaignCreateActiveStep;
        },
        hasAtLeastOneProductSelected() {
            // Check if at least one visible product is selected (for create client wizard)
            if (!this.customsidebarleadmenu || Object.keys(this.customsidebarleadmenu).length === 0) {
                return false;
            }
            
            // Loop through customsidebarleadmenu (visible products only)
            for (let key in this.customsidebarleadmenu) {
                // Check if this product is selected
                if (this.selectedModulesCreate[key] === true) {
                    // Check if this product passes validateBetaFeature and simplifi check
                    if (this.validateBetaFeature(key) && (this.customsidebarleadmenu[key].url != 'simplifiid' || this.$global.idsys == this.$global.masteridsys)) {
                        return true;
                    }
                }
            }
            return false;
        },
        queriedData() {
        let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice().sort((a, b) => {
                // Move items with payment_status == 'failed' to the top
                if (a.payment_status === 'failed' && b.payment_status !== 'failed') {
                  return -1;
                } else if (a.payment_status !== 'failed' && b.payment_status === 'failed') {
                  return 1;
                }
            
                // Move items with customer_payment_id == '' or customer_card_id == '' next
                if ((a.customer_payment_id === '' || a.customer_card_id === '') && (b.customer_payment_id !== '' && b.customer_card_id !== '')) {
                  return -1;
                } else if ((a.customer_payment_id !== '' && a.customer_card_id !== '') && (b.customer_payment_id === '' || b.customer_card_id === '')) {
                  return 1;
                }
            
                // Keep the rest of the items in their original order
                return 0;
            });
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        },      
        initializeSelectedModules() {
            const initialselectedModulesCreate = {};
            const DefaultModules = this.$global.agencyDefaultModules ? this.$global.agencyDefaultModules: '';
            if (DefaultModules != '') {     
                DefaultModules.forEach(module => { 
                    if (module.type) {
                        initialselectedModulesCreate[module.type] = this.$global.agencyDefaultModules ? module.status : true;
                    }
                });
            }
            return initialselectedModulesCreate;
        },
        hasProducts() {
        const modules = this.$global.agencyfilteredmodules;
        return modules && Object.keys(modules).length > 0;
     }
    },

    methods: {
        handleSendjimCheckboxChange(value) {
            // Ensure checkbox state is saved immediately when changed in wizard mode
            if(this.modals.create && this.campaignCreateActiveStep === 3 && this.selectedIntegration === 'sendjim'){
                // Save immediately when checkbox is toggled
                this.$nextTick(() => {
                    this.saveWizardIntegrationValues('sendjim');
                });
            }
        },
        updateSaveNextButtonState(state) {
            // Method to update Save & Next button state
            // state can include: { disabled: boolean, loading: boolean, text: string }
            if (state.disabled !== undefined) {
                this.saveNextButtonState.disabled = state.disabled;
            }
            if (state.loading !== undefined) {
                this.saveNextButtonState.loading = state.loading;
            }
            if (state.text !== undefined) {
                this.saveNextButtonState.text = state.text;
            }
        },
        async handleFeedbackConnectGhlV2(event) {
            if(event.data.ghl_status === "connected"){
                const companyId = event.data.company_id;
                const clientEmail = event.data.email;
                
                // Check if we're in wizard mode (we can't rely on from_wizard flag due to cross-origin)
                const isFromWizard = this.modals.create && this.campaignCreateActiveStep === 3;
                
                // If from wizard mode, just refresh the integration status
                if(isFromWizard) {
                    // Refresh integration status for current client in wizard
                    if(this.selectedRowData && this.selectedRowData.company_id === companyId) {
                        await this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                        this.isLoadingConnectDisconnectGhlv2 = false;
                        this.$notify({
                            type: 'success',
                            message: 'Contact Sync Activated Successfully! You can continue configuring other integrations.',
                            icon: 'fas fa-save'
                        });
                    }
                    return;
                }
                
                // Original logic for non-wizard mode
                let selectedRowData = this.tableData.find(item => item.company_id === companyId);
                let selectedRowIndex = this.tableData.findIndex(item => item.company_id === companyId);
                if(!selectedRowData){
                    // jika tidak ada coba get sekali lagi
                    this.searchQuery = clientEmail;
                    this.pagination.currentPage = 1;
                    await this.GetClientList(this.currSortBy,this.currOrderBy);

                    // cari client nya apakah ada atau tidak
                    selectedRowData = this.tableData.find(item => item.company_id === companyId);
                    selectedRowIndex = this.tableData.findIndex(item => item.company_id === companyId);
                    
                    // jika tidak ada
                    if(!selectedRowData){
                        return this.$notify({type: 'success', message: 'Contact Sync Activated Successfully', icon: 'fas fa-save'});
                    }
                }

                // cari integrations yang type nya adalah gohighlevel
                const ghlIntegration = this.integrations.find(item => item.slug === "gohighlevel");
                if(!ghlIntegration){
                    return this.$notify({type: 'success', message: 'Contact Sync Activated Successfully', icon: 'fas fa-save'});
                }

                // tutup modal jika sudah terbuka namun bukan untuk client ini
                if(this.modals.integrations && this.selectedRowData && this.selectedRowData.company_id !== companyId){
                    this.modals.integrations = false;
                }

                // buka modal dan arahkan ke bagian gohighlevel
                this.selectedRowData = selectedRowData;
                this.selectedRowIndex = selectedRowIndex;
                await this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                await this.handleIntegrationItemClick(ghlIntegration);

                // notifikasi
                this.$notify({type: 'success', message: 'Contact Sync Activated Successfully', icon: 'fas fa-save'});
            }
        },
        isInIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                // Tidak boleh akses window.top → berarti sedang dalam iframe
                return true;
            }
        },
        async handleSwitchUser(row) {
            // swal confirm dialog
            const result = await swal.fire({
                title: 'Switch as this user.',
                text: `Are you sure want to switch to this user?`,
                icon: '',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-fill mr-3',
                    cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Yes, switch user',
                buttonsStyling: false
            });
            if (!result.value) return;
            // swal confirm dialog

            // hit api for switchUser
            try {
                const response = await this.$store.dispatch('switchUserData', { usrID: row.id });
                // console.log(response);
                if (response == 'success') {
                    if (row.profile_setup_completed == 'T' && row.status_acc == '' && row.user_type == 'client') {
                        const usrData = this.$store.getters.userData; 
                        if (usrData.leadlocalurl && usrData.leadlocalurl != '') {
                            window.document.location = `/${usrData.leadlocalurl}/dashboard`;
                        } else if (usrData.leadlocatorurl && usrData.leadlocatorurl != '') {
                            window.document.location = `/${usrData.leadlocatorurl}/dashboard`;
                        } else if (usrData.leadenhanceurl && usrData.leadenhanceurl != '') {
                            window.document.location = `/${usrData.leadenhanceurl}/dashboard`;
                        } else if (usrData.leadb2burl && usrData.leadb2burl != '') {
                            window.document.location = `/${usrData.leadb2burl}/dashboard`;
                        } else if (usrData.leadsimplifiurl && usrData.leadsimplifiurl != '') {
                            window.document.location = `/${usrData.leadsimplifiurl}/dashboard`;
                        } else {
                            window.document.location = "/user/profile-setup";
                        } 
                    } else {
                        window.document.location = "/user/profile-setup";
                    }
                }
            } catch (error) {
                console.error(error);
                    }
            // hit api for switchUser
        },
        // A more robust copy-to-clipboard method with a fallback
        copyToClipboard(text) {
            // Modern async API
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text)
                    .then(() => {
                        this.$notify({
                            type: 'success',
                            message: 'Copied to clipboard',
                            icon: 'far fa-copy'
                        });
                    })
                    .catch(err => {
                        console.error('Failed to copy with modern API:', err);
                        this.$notify({
                            type: 'danger',
                            message: 'Copy failed',
                            icon: 'fas fa-bug'
                        });
                    });
            } else {
                // Fallback for older browsers or insecure contexts
                const textArea = document.createElement("textarea");
                textArea.value = text;

                // Make the textarea out of sight
                textArea.style.position = "fixed";
                textArea.style.top = "0";
                textArea.style.left = "0";
                textArea.style.opacity = "0";

                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    const successful = document.execCommand('copy');
                    if (successful) {
                        this.$notify({
                            type: 'success',
                            message: 'Copied to clipboard',
                            icon: 'far fa-copy'
                        });
                    } else {
                        this.$notify({
                            type: 'danger',
                            message: 'Copy failed',
                            icon: 'fas fa-bug'
                        });
                    }
                } catch (err) {
                    console.error('Fallback copy failed:', err);
                    this.$notify({
                        type: 'danger',
                        message: 'Copy failed',
                        icon: 'fas fa-bug'
                    });
                }

                document.body.removeChild(textArea);
            }
        },
          async updateCreateCampaignStep(){
            // console.log(this.campaignCreateActiveStep , typeof this.campaignCreateActiveStep)
            // if(true){
            //     this.updateCreateClientStep()
            //     return
            // }
              switch (this.campaignCreateActiveStep) {
                    case 0:
                        // this.updateCreateClientStep()
                        await this.ProcessAddEditClient('')
                        break;
                    case 1:
                        // Skip CC step if shouldSkipCCStep is true
                        if (this.shouldSkipCCStep) {
                            // Skip directly to step 2 (Financial Setup)
                            this.campaignCreateActiveStep = 2;
                            this.save_default_price_wizard();
                        } else {
                            // Validate and update card information
                            // validateCC will call updateCreateClientStep() after successful save
                            this.validateCC('');
                        }
                        break;
                    case 2:
                        // Save financial setup and move to next step
                        this.save_default_price_wizard()
                        break;
                    case 3:
                        // Save integrations settings for new client and close wizard
                        await this.saveIntegrationSettingsWizard()
                        break;
                    default:
                }


        },
        skipCreateCampaignStep(){
            // Skip current step and move to next
            // For step 3 (integrations), skip means finish without saving integrations
            if(this.campaignCreateActiveStep === 3){
                // Skip integrations step - close wizard without saving integrations
                this.modals.create = false;
                this.campaignCreateActiveStep = 0;
                this.createdClientData = null;
                this.wizardIntegrationValues = {};
                this.GetClientList(this.currSortBy, this.currOrderBy);

                this.$notify({
                    type: 'success',
                    message: 'Client created successfully!',
                    icon: 'fas fa-check'
                });
            } else {
                // For other steps, just move to next step
                this.updateCreateClientStep();
            }
        },
        async updateCreateClientStep(){
            if(this.campaignCreateActiveStep <=4 ){
                this.campaignCreateActiveStep++

                // Skip CC step (step 1) if shouldSkipCCStep is true
                if (this.shouldSkipCCStep && this.campaignCreateActiveStep === 1) {
                    this.campaignCreateActiveStep = 2; // Skip directly to step 2 (Financial Setup)
                }

                // Reset loading state and update button text based on the new step
                if(this.campaignCreateActiveStep === 3) {
                    this.updateSaveNextButtonState({ text: 'Finish', disabled: false, loading: false });
                } else {
                    this.updateSaveNextButtonState({ text: 'Save & Next', disabled: false, loading: false });
                }

                if(this.campaignCreateActiveStep === 1){
                    // Populate client data for card setup
                    if(this.createdClientData) {
                        this.ClientActiveID = this.createdClientData.id;
                        this.LeadspeekCompany = this.createdClientData.company_name;
                        this.termhost = this.createdClientData.company_id;
                        this.clientPaymentFailed = false;

                        // Get existing card info if available
                        this.getCardInfo(this.createdClientData.id);
                    }

                    // Wait for DOM to be updated, then initialize card element
                    this.$nextTick(() => {
                        // Clean the card form first (wizard mode, use formCCWizard)
                        if(this.$refs.formCCWizard) {
                            this.cardholdername = '';
                            this.billingaddress = '';
                            this.city = '';
                            this.selects.state = '';
                            this.zipcode = '';
                            this.agreeTerm = false;
                        }

                        // Initialize Stripe card element with additional delay to ensure DOM is ready
                         initcreditcard();
                    });
                }
                if(this.campaignCreateActiveStep === 2){
                    // Initialize financial setup for the created client
                    if(this.createdClientData) {
                        this.initial_default_price();
                        this.activeClientCompanyID = this.createdClientData.company_id;
                        this.activeClientID = this.createdClientData.id;
                        this.LeadspeekCompany = this.createdClientData.company_name;
                        this.resetClientCost();
                        this.useDefaultPricing = true; // Reset to default for new client

                        // For new clients in wizard, load default pricing (agencydefaultprice or rootagencydefaultprice)
                        this.loadDefaultPricingForNewClient();
                    }
                }
                if(this.campaignCreateActiveStep === 3){
                    // Initialize integrations setup for the created client
                    if(this.createdClientData) {
                        this.selectedRowIndex = 0;
                        this.selectedRowData = this.createdClientData;

                        // Default to API Only for wizard mode, but allow Full Integration
                        this.integrationVersion.gohighlevel = "1";

                        // Load integrations list
                        this.getCustomIntegrations();

                        // Load integration details for the client
                        await this.handleIntegrationClick(0, this.createdClientData);
                    }
                }
            }
        },
        loadPricingForPaymentTerm() {
            const term = this.selectsPaymentTerm.PaymentTermSelect;
            if (term == 'Weekly') {
                this.LeadspeekPlatformFee = this.costagency.local.Weekly.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.Weekly.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.Weekly.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.Weekly.LeadspeekLeadsPerday;

                this.LocatorPlatformFee = this.costagency.locator.Weekly.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.Weekly.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.Weekly.LocatorMinCostMonth;
                this.LocatorLeadsPerday = this.costagency.locator.Weekly.LocatorLeadsPerday;

                this.EnhancePlatformFee = this.costagency.enhance.Weekly.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.Weekly.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.Weekly.EnhanceMinCostMonth;
                this.EnhanceLeadsPerday = this.costagency.enhance.Weekly.EnhanceLeadsPerday;

                this.B2bPlatformFee = this.costagency.b2b.Weekly.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.Weekly.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.Weekly.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.Weekly.B2bLeadsPerday;
            } else if (term == 'Monthly') {
                this.LeadspeekPlatformFee = this.costagency.local.Monthly.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.Monthly.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.Monthly.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.Monthly.LeadspeekLeadsPerday;

                this.LocatorPlatformFee = this.costagency.locator.Monthly.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.Monthly.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.Monthly.LocatorMinCostMonth;
                this.LocatorLeadsPerday = this.costagency.locator.Monthly.LocatorLeadsPerday;

                this.EnhancePlatformFee = this.costagency.enhance.Monthly.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.Monthly.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.Monthly.EnhanceMinCostMonth;
                this.EnhanceLeadsPerday = this.costagency.enhance.Monthly.EnhanceLeadsPerday;

                this.B2bPlatformFee = this.costagency.b2b.Monthly.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.Monthly.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.Monthly.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.Monthly.B2bLeadsPerday;
            } else if (term == 'One Time') {
                this.LeadspeekPlatformFee = this.costagency.local.OneTime.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.OneTime.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.OneTime.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.OneTime.LeadspeekLeadsPerday;

                this.LocatorPlatformFee = this.costagency.locator.OneTime.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.OneTime.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.OneTime.LocatorMinCostMonth;
                this.LocatorLeadsPerday = this.costagency.locator.OneTime.LocatorLeadsPerday;

                this.EnhancePlatformFee = this.costagency.enhance.OneTime.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.OneTime.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.OneTime.EnhanceMinCostMonth;
                this.EnhanceLeadsPerday = this.costagency.enhance.OneTime.EnhanceLeadsPerday;

                this.B2bPlatformFee = this.costagency.b2b.OneTime.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.OneTime.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.OneTime.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.OneTime.B2bLeadsPerday;
            } else if (term == 'Prepaid') {
                this.LeadspeekPlatformFee = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekPlatformFee:0;
                this.LeadspeekCostperlead = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekCostperlead:0;
                this.LeadspeekCostperleadAdvanced = (typeof(this.costagency.local.Prepaid) != 'undefined')?this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced:0;
                this.LeadspeekMinCostMonth = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekMinCostMonth:0;
                this.LeadspeekLeadsPerday = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekLeadsPerday:10;

                this.LocatorPlatformFee = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorPlatformFee:0;
                this.LocatorCostperlead = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorCostperlead:0;
                this.LocatorMinCostMonth = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorMinCostMonth:0;
                this.LocatorLeadsPerday = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorLeadsPerday:10;

                this.EnhancePlatformFee = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhancePlatformFee:0;
                this.EnhanceCostperlead = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceCostperlead:0;
                this.EnhanceMinCostMonth = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceMinCostMonth:0;
                this.EnhanceLeadsPerday = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceLeadsPerday:10;

                this.B2bPlatformFee = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bPlatformFee:0;
                this.B2bCostperlead = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bCostperlead:0;
                this.B2bMinCostMonth = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bMinCostMonth:0;
                this.B2bLeadsPerday = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bLeadsPerday:10;
            }

            // for Simplifi Settings
            const prepaidSimplifi = (this.costagency && this.costagency.simplifi && this.costagency.simplifi.Prepaid);
            this.SimplifiMaxBid = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiMaxBid) != 'undefined')?prepaidSimplifi.SimplifiMaxBid:0;
            this.SimplifiDailyBudget = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiDailyBudget) != 'undefined')?prepaidSimplifi.SimplifiDailyBudget:0;
            this.SimplifiAgencyMarkup = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiAgencyMarkup) != 'undefined')?prepaidSimplifi.SimplifiAgencyMarkup:0;
        },
        onViewExampleData() {
            window.open(this.basicExampleDataUrl, "_blank");
        },
        togglePassword() {
            this.showPassword = !this.showPassword
        },
        ...mapActions(["saveIntegrationSettings", "getUserIntegrationDetails", 'userLogSaved']),
        getMinimumValueSimplifi() {
            this
            .$store
            .dispatch('getMinimumValueSimplifi', {
                idsys: this.$global.idsys
            })
            .then(response => {
                // console.log('getMinimumValuesSimplifi', { response });
                this.simplifiPriceRule.maxBid.minimum = response.data.maxBid.minimum;
                this.simplifiPriceRule.dailyBudget.minimum = response.data.dailyBudget.minimum;
            })
            .catch(error => {
                this.$notify({ type: 'danger', message: 'Something Went Wrong At Get Minimum Values Simplifi', icon: 'fas fa-bug' });
            })
        },
        handleScrollGhlV2SubAccount(event) {
            const dropdown = event.target;
            const tolerant = 2;
            const isFetch = this.paginationGhlV2SubAccount.isFetch;
            const isComplete = this.paginationGhlV2SubAccount.isComplete;
            const totalSubAccounts = this.ghlV2ListSubAccounts.length;
            // console.log({
            //     'function': 'handleScrollGhlV2SubAccount',
            //     'dropdown.scrollTop': dropdown.scrollTop,
            //     'dropdown.clientHeight': dropdown.clientHeight,
            //     'dropdown.scrollTop + dropdown.clientHeight' : dropdown.scrollTop + dropdown.clientHeight,
            //     'dropdown.scrollHeight': dropdown.scrollHeight,
            //     'tolerant': tolerant,
            //     'this.paginationGhlV2SubAccount.isFetch': this.paginationGhlV2SubAccount.isFetch,
            //     'this.paginationGhlV2SubAccount.isComplete': this.paginationGhlV2SubAccount.isComplete
            // })

            if (
                (Math.ceil(dropdown.scrollTop + dropdown.clientHeight) >= dropdown.scrollHeight - tolerant) && // jika scroll sampai bawah
                (!isFetch) && // kondisi harus dalam keadaan tidak fetch list sub account
                (!isComplete) && // pastikan belum semua list sub account diambil
                (totalSubAccounts > 0) // pastikan sebelumnya ada list sub account nya
            ) {
                // console.log('before function ghlv2GetListSubAccounts');
                this.ghlv2GetListSubAccounts();
            }
        },
        onSelectGhlV2SubAccountVisible(visible, type) {
            if (visible) {
                this.$nextTick(() => {
                    let dropdown = "";
                    if(type == 'add') {
                        dropdown = this.$refs.selectGhlV2SubAccountAdd.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                    } else {
                        dropdown = this.$refs.selectGhlV2SubAccountEdit.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                    }

                    if (dropdown) {
                        dropdown.addEventListener('scroll', this.handleScrollGhlV2SubAccount);
                    } else {
                        console.error('Dropdown not found');
                    }
                });
            }
        },
        clearSelectSubAccount() {
            this.selects.ghlv2SubAccount = '';
        },
        async handleDownloadAgreementFile(row){
            this.$set(this.downloadingAgreements, row.id, true);
            if (row.company_agreement_file === 'download') {
                const payload = {
                    user_id: row.id,
                    document_type: DOCUMENTS.DEFAULT_CLIENT,
                }
                await this.$store.dispatch('downloadAgreementFile', payload)
                .then(response => {
                    if (response.file_uuid) {
                        const url = process.env.VUE_APP_DATASERVER_URL  + '/download-agreement?agreement_id=' + response.file_uuid
                        downloadFileInBackgroundPdf(url)
                        this.GetClientList(this.currSortBy, this.currOrderBy)
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'danger',
                        message: 'Failed to download agreement file. Please try again later.',
                        icon: 'fas fa-exclamation-triangle'
                    });
                });
            }else {
                downloadFileInBackgroundPdf(row.company_agreement_file)
            }
            this.$set(this.downloadingAgreements, row.id, false);
        },
        ghlv2ResetListSubAccounts() {
            this.paginationGhlV2SubAccount.currentPage = 1;
            this.paginationGhlV2SubAccount.isComplete = false;
            this.paginationGhlV2SubAccount.isFetch = false;
            this.ghlV2ListSubAccounts = [];
        },
        ghlv2GetListSubAccounts() {
            if(this.$global.idsys != this.$global.masteridsys) {
                return;
            }

            this.paginationGhlV2SubAccount.isFetch = true;
            this.selects.ghlv2SubAccount = '';
            this
            .$store
            .dispatch('ghlv2GetListSubAccounts', {
                company_id: this.$store.getters.userData.company_id, // company_id agency
                page: this.paginationGhlV2SubAccount.currentPage, // page sekarang 
            })
            .then(response => {
                // console.log(response);
                this.ghlV2AgencyConnected = response.ghlV2AgencyConnected;
                this.paginationGhlV2SubAccount.isFetch = false;
                this.paginationGhlV2SubAccount.isComplete = (response.listSubAccounts.length == 0);

                if(response.listSubAccounts.length > 0) {
                    this.ghlV2ListSubAccounts = [ ...this.ghlV2ListSubAccounts, ...response.listSubAccounts ]
                    this.paginationGhlV2SubAccount.currentPage = Number(response.page) + 1;
                }
                
                // console.log({
                //     'this.ghlV2AgencyConnected': this.ghlV2AgencyConnected,
                //     'this.ghlV2ListSubAccounts': this.ghlV2ListSubAccounts,
                // })
            })
            .catch(error => {
                console.log(error);
                
                this.paginationGhlV2SubAccount.isFetch = false;
                
                const message = typeof(error.response.data.message) ? error.response.data.message : 'Something Went Wrong';
                this.$notify({
                    type: 'danger',
                    icon: 'fas fa-bug',
                    message: message
                });
            })
        },
        createDeleteIframeGhlv2() {
            if(!this.ghlV2CreatedIframe) { // create iframe
                this.createIframeGhlv2Client();
            } else { // delete iframe
                this.deleteIframeGhlv2Client();
            }
        },
        createIframeGhlv2Client() {
            if(!this.selects.ghlv2SubAccount) {
                this.$notify({
                    type: 'danger',
                    message: 'Please select sub accounts',
                    icon: 'fas fa-bug'
                });
                return;
            }

            MessageBox.prompt('Enter the text that you want to display as your single sign on custom menu link. (30 Characters Max)', 'Enter Your Custom Menu Link Text.', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputPattern: /^$|^[a-zA-Z0-9\s]{1,30}$/,
                inputErrorMessage: 'Only letters, numbers, and spaces, max 30 characters',
                inputPlaceholder: '[Client-Name]',
                inputValue: this.selectedRowData.company_name,
                customClass: 'message-general-ghl'
            })
            .then(({ value }) => {
                this.isLoadingCreateDeleteIframeGhlV2 = true;
                this
                .$store
                .dispatch('createIframeGhlv2Client', {
                    company_id: this.selectedRowData.company_id,
                    company_parent: this.$store.getters.userData.company_id,
                    custom_menu_name: value,
                    user_ip: this.$store.getters.userData.ip_login,
                    location_id: this.selects.ghlv2SubAccount,
                })
                .then(response => {
                    // console.log(response);
                    this.isLoadingCreateDeleteIframeGhlV2 = false;
                    this.btnCreateDeleteIframeGhlv2Text = 'Remove SSO Link';
                    this.ghlV2CreatedIframe = true;
                    // this.modals.integrations = false;

                    this.ghlv2ResetListSubAccounts();
                    this.ghlv2GetListSubAccounts();
                    
                    this.$notify({
                        type: 'success',
                        icon: 'fas fa-save',
                        message: 'create sso link successfully'
                    });
                })
                .catch(error => {
                    console.error(error);
                    this.isLoadingCreateDeleteIframeGhlV2 = false;
                    const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Wrong';
                    this.$notify({
                        type: 'danger',
                        icon: 'fas fa-bug',
                        message: message
                    });
                })
            });

        },
        deleteIframeGhlv2Client() {
            MessageBox.confirm('Are you sure you want to remove SSO link?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                type: 'warning',
            })
            .then(result => {
                this.isLoadingCreateDeleteIframeGhlV2 = true;
                this
                .$store
                .dispatch('deleteIframeGhlv2Client', {
                    company_id: this.selectedRowData.company_id,
                    company_parent: this.$store.getters.userData.company_id,
                    user_ip: this.$store.getters.userData.ip_login,
                })
                .then(response => {
                    this.isLoadingCreateDeleteIframeGhlV2 = false;
                    this.btnCreateDeleteIframeGhlv2Text = 'Create SSO Link';
                    this.ghlV2CreatedIframe = false;
                    // this.modals.integrations = false;

                    this.ghlv2ResetListSubAccounts();
                    this.ghlv2GetListSubAccounts();

                    this.$notify({
                        type: 'success',
                        icon: 'fas fa-save',
                        message: 'Custom Menu Link Successfully Removed '
                    });
                })
                .catch(error => {
                    this.isLoadingCreateDeleteIframeGhlV2 = false;
                    const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Wrong';
                    this.$notify({
                        type: 'danger',
                        icon: 'fas fa-bug',
                        message: message
                    });
                });
            })
        },
        openHelpModal(index) {
            this.activeHelpIndex = index;
            this.activeHelpItem = this.helpContentMap[index]
            this.modals.help = true;
        },
        changeEnableMinimumLeadsPerDay(type) {
            if(type == 'local')
                this.costagency.local.EnableMinimumLeadsPerday = this.LeadspeekEnableMinimumLeadsPerDay;
            else if(type == 'locator')
                this.costagency.locator.EnableMinimumLeadsPerday = this.LocatorEnableMinimumLeadsPerDay;
            else if(type == 'enhance')
                this.costagency.enhance.EnableMinimumLeadsPerday = this.EnhanceEnableMinimumLeadsPerDay;
            else if(type == 'b2b')
                this.costagency.b2b.EnableMinimumLeadsPerday = this.B2bEnableMinimumLeadsPerDay;
        },
        connectDisconnectGhlv2() {
            if(!this.ghlV2Connected) { // connect
                this.generateGHLv2AuthUrl();
            } else { // disconnect
                MessageBox.confirm('Are You Sure Deactivate Contact Sync For This Client', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                })
                .then(() => {
                    this.disconnectGhlv2();
                })
                .catch(() => {
                    return;
                });
            }
        },
                // SendJim OAuth-only logic
        connectDisconnectSendjim() {
            if(!this.sendjimConnected) { // connect
                this.generateSendJimAuthUrl();
            } else { // disconnect
                MessageBox.confirm('Are you sure you want to disconnect SendJim?', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                })
                .then(() => {
                    this.disconnectSendJim();
                })
                .catch(() => {
                    return;
                });
            }
        },

        disconnectSendJim() {
            this.btnConnectDisconnectSendjimText = "Disconnecting...";
            $('#btnConnectDisconnectSendjim').attr('disabled',true);
            this.$store
                .dispatch('disconnectSendJim', {
                    company_id: this.selectedRowData.company_id,
                    user_ip: this.$store.getters.userData.ip_login,
                })
                .then(response => {
                    this.sendjimConnected = false;
                    this.btnConnectDisconnectSendjimText = "Connect SendJim";
                    $('#btnConnectDisconnectSendjim').attr('disabled',false);
                    this.$notify({ type: "success", message: "Disconnect SendJim Successfully", icon: "fas fa-save" });
                })
                .catch(error => {
                    $('#btnConnectDisconnectSendjim').attr('disabled',false);
                    this.$notify({ type: "primary", message: error.response.data.message, icon: "fas fa-bug" });
                });
        },
        disconnectGhlv2() {
            this.btnConnectDisconnectGhlv2Text = "Deactivate Contact Sync...";
            $('#btnConnectDisconnectGhlv2').attr('disabled',true);   
            
            this.$store
                .dispatch('disconnectGhlv2', {
                    company_id: this.selectedRowData.company_id,
                    user_ip: this.$store.getters.userData.ip_login,
                })
                .then(response => {
                    this.ghlV2Connected = false;
                    this.btnConnectDisconnectGhlv2Text = "Activate Contact Sync"
                    $('#btnConnectDisconnectGhlv2').attr('disabled',false);

                    this.$notify({
                        type: "success",
                        message: "Deactivate Contact Sync Successfully",
                        icon: "fas fa-save"
                    });
                    // this.modals.integrations = false;

                    // fetch ulang data nya setiap pindah integration agar selalu uptodate
                    if(this.selectedRowData){
                        this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                    }
                    // fetch ulang data nya setiap pindah integration agar selalu uptodate
                })
                .catch(error => {
                    $('#btnConnectDisconnectGhlv2').attr('disabled',false);

                    this.$notify({
                        type: "primary",
                        message: error.response.data.message,
                        icon: "fas fa-bug"
                    });
                    // this.modals.integrations = false;
                });
        },
        generateGHLv2AuthUrl() {
            MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                type: 'warning',
            })
            .then(() => {
                const isInIframe = this.isInIframe();
                const slug = this.selectedIntegration;
                const { filteredListGeneral, filteredListB2b, filteredListAdvance } = this.handleFilterListCustomFields('Gohighlevel');
                const isWizardMode = this.modals.create && this.campaignCreateActiveStep === 3;

                this.isLoadingConnectDisconnectGhlv2 = true;
                this.$store
                    .dispatch('generateGHLv2AuthUrl', {
                        company_id: this.selectedRowData.company_id,
                        enable_sendgrid: this.enabledconntector[slug] ? 1 : 0,
                        subdomain_url: window.location.href,
                        custom_fields_general: filteredListGeneral,
                        custom_fields_b2b: filteredListB2b,
                        custom_fields_advance: filteredListAdvance,
                        user_ip: this.$store.getters.userData.ip_login,
                        is_in_iframe: isInIframe || isWizardMode // Treat wizard mode as iframe-like for popup
                    })
                    .then(response => {
                        const result = typeof(response.result) != 'undefined' ? response.result : '';
                        const url = typeof(response.url) != 'undefined' ? response.url : '';
                        // console.log({result, url});
                        
                        if(result == 'success' && url != ''){
                            if(isInIframe || isWizardMode){
                                // Use popup window for iframe or wizard mode
                                const popup = window.open(url, 'ghl_oauth', 'width=600,height=700,scrollbars=yes,resizable=yes');
                                
                                // Listen for popup to close or postMessage
                                const checkPopupClosed = setInterval(() => {
                                    if(popup.closed) {
                                        clearInterval(checkPopupClosed);
                                        this.isLoadingConnectDisconnectGhlv2 = false;
                                        // Refresh integration status if in wizard mode
                                        if(isWizardMode && this.selectedRowData) {
                                            this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                                        }
                                    }
                                }, 500);
                                
                                // If popup is blocked, fallback to full redirect
                                if(!popup || popup.closed || typeof popup.closed == 'undefined') {
                                    clearInterval(checkPopupClosed);
                                    if(isWizardMode) {
                                        // In wizard mode, we can't do full redirect, show error
                                        this.isLoadingConnectDisconnectGhlv2 = false;
                                        this.$notify({
                                            type: 'warning',
                                            message: 'Popup was blocked. Please allow popups for this site and try again.',
                                            icon: 'fas fa-exclamation-triangle'
                                        });
                                    } else {
                                        // Fallback to full redirect for iframe mode
                                        window.location.href = url;
                                    }
                                }
                            }else{
                                window.location.href = url;
                            }
                        }
                    })
                    .catch(error => {
                        this.isLoadingConnectDisconnectGhlv2 = false;
                        console.log(error);
                    })
            })
            .catch(() => {
                return;
            });
        },
        generateSendJimAuthUrl() {
            if(!this.userApiKey.sendjim || this.userApiKey.sendjim.trim() === '') {
                this.$notify({
                    type: 'danger',
                    message: 'Please enter your SendJim Client ID first',
                    icon: 'fas fa-bug'
                });
                return;
            }
            if(!this.sendjim.clientSecret || this.sendjim.clientSecret.trim() === '') {
                this.$notify({
                    type: 'danger',
                    message: 'Please enter your SendJim Client Secret first',
                    icon: 'fas fa-bug'
                });
                return;
            }
            // Save credentials first to ensure backend has Client Secret
            // this.saveIntegrationSettingslocal();
            this.isLoadingConnectDisconnectSendjim = true;
            this.$store
                .dispatch('generateSendJimAuthUrl', {
                    company_id: this.selectedRowData.company_id,
                    subdomain_url: window.location.href,
                    user_ip: this.$store.getters.userData.ip_login,
                    client_id: this.userApiKey.sendjim,
                })
                .then(response => {
                    const result = typeof(response.result) != 'undefined' ? response.result : '';
                    const url = typeof(response.url) != 'undefined' ? response.url : '';
                    if(result == 'success' && url != '') {
                        // console.log({result, url});
                        window.location.href = url;
                    }
                    this.isLoadingConnectDisconnectSendjim = false;
                })
                .catch(error => {
                    this.isLoadingConnectDisconnectSendjim = false;
                    console.log(error);
                })
        },
        validateBetaFeature(type) {
            if(['b2b','b2b_module'].includes(type)) {
                if(!this.$global.betaFeature.b2b_module.is_beta || this.$global.betaFeature.b2b_module.apply_to_all_agency || this.$global.isBeta) {
                    return true;
                } else {
                    return false;
                }
            } else if(['simplifi','simplifi_module'].includes(type)) {
                if(!this.$global.betaFeature.simplifi_module.is_beta || this.$global.betaFeature.simplifi_module.apply_to_all_agency || this.$global.isBeta) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        },
        redirectToLink(link){
            window.open(link, '_blank')
        },
        validateMinLead(field) {
            if(this.clientMinLeadDayEnhance != '') {
                /* ENHANCE */
                if (field == 'EnhanceLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Weekly' && (Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.Weekly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'EnhanceLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Monthly' && (Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.Monthly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'EnhanceLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'One Time' && (Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.OneTime.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'EnhanceLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && (Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.Prepaid.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                }
                /* ENHANCE */

                /* B2B */
                if (field == 'B2bLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Weekly' && (Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.b2b.Weekly.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'B2bLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Monthly' && (Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.b2b.Monthly.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'B2bLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'One Time' && (Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.b2b.OneTime.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'B2bLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && (Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.b2b.Prepaid.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                }
                /* B2B */
            }
        },
        handleVisibleChange(visible) {            
            this.dropdownVisible = visible;
        },
        addWebhookUrl(type) {
            if (type == 'zapier') {
                this.userApiKey.zapier.push('');
                this.zapierWebhookLabels.push('');
            } else if (type == 'agencyzoom') {
                this.userApiKey.agencyzoom.push('');
            }
        },
        addWebhookUrlKeyupEnter(event, type){
            if (event.key === "Enter") {
                this.addWebhookUrl(type);
            }
        },
        removeWebhookUrl(index, type) {
            if (type == 'zapier') {
                if (this.userApiKey.zapier.length > 1) {
                    this.userApiKey.zapier.splice(index, 1);
                    this.zapierWebhookLabels.splice(index, 1);
                }
            } else if (type == 'agencyzoom') {
                if (this.userApiKey.agencyzoom.length > 1) {
                    this.userApiKey.agencyzoom.splice(index, 1);
                }
            }
        },
        applyFilters(event){
            event.stopPropagation(); // Prevent click propagation
            this.GetClientList(this.currSortBy, this.currOrderBy)
            this.dropdownVisible = false;
        },
        checkStatusFileUpload() {

            clearInterval(this.supressionInterval);

            /** START CHECK IF THERE IS ANYTHING NOT DONE */

            this.$store.dispatch('jobProgress', {
                companyId: this.whiteListClientID,
                campaignType: 'client',
            })
            .then(response => {
                this.supressionProgress = response.data.jobProgress;
                this.supressionDone = response.data.jobDone;
                
                if(this.supressionProgress.length > 0) {
                    this.supressionTimeout = setTimeout(() => {
                        this.supressionInterval = setInterval(() => {
                            this.$store.dispatch('jobProgress', {
                                companyId: this.whiteListClientID,
                                campaignType: 'client',
                            })
                            .then(response => {
                                this.supressionProgress = response.data.jobProgress;
                                this.supressionDone = response.data.jobDone;
                                
                                if(this.supressionProgress.length == 0) {
                                    clearTimeout(this.supressionTimeout);
                                    clearInterval(this.supressionInterval);
                                }
                            })
                            .catch(error => {
                                console.error(error);
                            })
                        }, 2000);
                    }, 2000);
                } else {
                    clearTimeout(this.supressionTimeout);
                    clearInterval(this.supressionInterval); 
                }
            })
            .catch(error => {
                console.error(error);
            })
            /** START CHECK IF THERE IS ANYTHING NOT DONE */
        },
        changePage(event){
            //console.log(this.pagination,event)
            this.GetClientList(this.currSortBy,this.currOrderBy)
        },
        refreshCCfield() {
            if (this.$global.sppubkey != "") {
                _sppubkey = this.$global.sppubkey;
                this.initstripelib();
                //this.cardfailetoload = false;
            }else{
                this.$store.dispatch('getGeneralSetting', {
                    companyID: this.user.company_root_id,
                    settingname: 'rootstripe',
                }).then(response => {
                    _sppubkey = response.data;
                    this.initstripelib();
                    //this.cardfailetoload = false;
                },error => {
                    this.$notify({
                    type: 'primary',
                    message: 'Please try to refresh the page',
                    icon: 'fas fa-bug'
                    })
                    this.cardfailetoload = true;    

                });
            }
        },
        onPhoneUpdate(payload){
           this.clientPhoneNumber.countryCode = payload.countryCode
           this.clientPhoneNumber.countryCallingCode = payload.countryCallingCode
           this.clientPhoneNumber.isValid = payload.isValid

           // Validate phone number
           if (payload.phoneNumber && payload.phoneNumber.length > 20) {
               this.phoneError = 'Phone number cannot be more than 20 characters';
               this.clientPhoneNumber.isValid = false;
           } else if (payload.phoneNumber && !payload.isValid) {
               this.phoneError = 'Please enter a valid phone number';
           } else {
               this.phoneError = '';
           }
        },
        onRowPhoneUpdate(payload){
           this.clientRowPhoneNumber.countryCode = payload.countryCode
           this.clientRowPhoneNumber.countryCallingCode = payload.countryCallingCode
           this.clientRowPhoneNumber.isValid = payload.isValid

           // Validate phone number
           if (payload.phoneNumber && payload.phoneNumber.length > 20) {
               this.phoneRowError = 'Phone number cannot be more than 20 characters';
               this.clientRowPhoneNumber.isValid = false;
           } else if (payload.phoneNumber && !payload.isValid) {
               this.phoneRowError = 'Please enter a valid phone number';
           } else {
               this.phoneRowError = '';
           }
        },
        async handleIntegrationClick(index, row) {
            this.selectedRowIndex = index;
            this.selectedRowData = row;

            try {
                this.integrationDetails = await this.getUserIntegrationDetails({ companyID: this.selectedRowData.company_id, slug: 'all' })
                var _integrationDetails = this.integrationDetails;
                
                this.userApiKey.gohighlevel = "";
                this.userApiKey.sendgrid = "";
                this.userApiKey.kartra = "";
                this.userApiKey.zapier = [''];
                this.userApiKey.mailboxpower = "";
                this.userApiKey.clickfunnels = "";
                this.userApiKey.agencyzoom = [''];
                this.userApiKey.sendjim = "";
                this.kartraAppId = "";
                this.kartraApiPassword = "";
                this.enabledconntector.sendgrid = false;
                this.enabledconntector.gohighlevel = false;
                this.enabledconntector.kartra = false;
                this.enabledconntector.zapier = false;
                this.enabledconntector.sendTestZapier = false;
                this.enabledconntector.mailboxpower = false;
                this.enabledconntector.clickfunnels = false;
                this.enabledconntector.sendTestAgencyZoom = false;
                this.enabledconntector.agencyzoom = false;
                this.enabledconntector.sendjim = false;
                this.clickfunnels.subdomain = "";
                this.clickfunnels.workspaceId = "";
                this.integrationVersion.gohighlevel = "2";

                this.ghlV2Connected = false;
                this.btnConnectDisconnectGhlv2Text = 'Activate Contact Sync';

                this.ghlV2CreatedIframe = false;
                this.btnCreateDeleteIframeGhlv2Text = 'Create SSO Link';
                if(typeof(_integrationDetails.ghlV2CreatedIframe) != 'undefined') {
                    this.ghlV2CreatedIframe = _integrationDetails.ghlV2CreatedIframe;
                    if(this.ghlV2CreatedIframe === true) {
                        this.btnCreateDeleteIframeGhlv2Text = 'Remove SSO Link';
                    } else {
                        this.btnCreateDeleteIframeGhlv2Text = 'Create SSO Link';
                    }
                }

                // reset SendJim state
                this.sendjimConnected = false;
                this.btnConnectDisconnectSendjimText = 'Connect SendJim';

                // if (_integrationDetails.refcode && Array.isArray(_integrationDetails.refcode)) {
                //     _integrationDetails.refcode.forEach(item => {
                //         const matchSlug = this.integrations.find(itemFind => itemFind.slug === item.slug);
                //         if (matchSlug) {
                //             let parsedData = JSON.parse(`[${item.referralcode}]`);
                //             if (Array.isArray(parsedData)) {
                //                 parsedData.forEach(item => {
                //                     if (item.rootid == this.$global.idsys) {
                //                         console.log(item.refcode);
                //                         matchSlug.refcode = item.refcode;
                //                     }
                                    
                //                 });
                //             }
                //         }
                        
                //     });
                // }

                if (_integrationDetails.data && Array.isArray(_integrationDetails.data)) {
                    _integrationDetails.data.forEach(item => {
                        var _slug = item.integration_slug;
                        this.enabledconntector[_slug] = item.enable_sendgrid === 1;
                        this.userApiKey[_slug] = item.api_key ? item.api_key : '';
                        if(item.integration_slug === 'kartra'){
                            this.kartraApiPassword = item.password
                            // this.kartraAppId = item.app_id
                        }
                        if(item.integration_slug === 'sendjim'){
                            this.sendjim.clientSecret = item.password || '';
                        }

                        if(item.integration_slug === 'clickfunnels'){
                            this.clickfunnels.subdomain = item.subdomain;
                            this.clickfunnels.workspaceId = item.workspace_id;
                        }

                        if(item.integration_slug == 'gohighlevel') {
                            if(typeof(item.version) != 'undefined' && (item.version == "1" || item.version == "2")) {
                                this.integrationVersion.gohighlevel = item.version;
                            }
                            if(typeof(item.ghlV2Connected) != 'undefined') {
                                this.ghlV2Connected = item.ghlV2Connected;
                                if(this.ghlV2Connected === true) {
                                    this.btnConnectDisconnectGhlv2Text = 'Deactivate Contact Sync';
                                } else {
                                    this.btnConnectDisconnectGhlv2Text = 'Activate Contact Sync';
                                }
                            }
                        }
                        if(item.integration_slug == 'zapier') {
                            this.userApiKey.zapier = item.api_key ? (Array.isArray(item.api_key) ? item.api_key : [item.api_key]) : [''];
                            if (item.webhook_labels && Array.isArray(item.webhook_labels)) {
                                this.zapierWebhookLabels = item.webhook_labels.slice(0, this.userApiKey.zapier.length);
                                while (this.zapierWebhookLabels.length < this.userApiKey.zapier.length) {
                                    this.zapierWebhookLabels.push('');
                                }
                            } else {
                                this.zapierWebhookLabels = new Array(this.userApiKey.zapier.length).fill('');
                            }
                        }
                        if(item.integration_slug == 'sendjim') {
                            // Set enabled state from enable_sendgrid field (same field used for all integrations)
                            this.enabledconntector.sendjim = item.enable_sendgrid === 1;
                            
                            // connected from backend flag or fallback to tokens presence
                            const connectedFlag = (typeof(item.connected) != 'undefined') ? item.connected : null;
                            const tokens = (typeof(item.tokens) != 'undefined' && item.tokens) ? item.tokens : '';
                            const apiKey = (typeof(item.api_key) != 'undefined' && item.api_key) ? item.api_key : '';
                            this.sendjimConnected = (connectedFlag !== null) ? !!connectedFlag : !!(tokens && tokens.toString().trim() != '');
                            if(this.sendjimConnected === true) {
                                this.btnConnectDisconnectSendjimText = 'Disconnect SendJim';
                            } else {
                                this.btnConnectDisconnectSendjimText = 'Connect SendJim';
                            }
                            // no client-level quicksend config anymore
                        }
                    });
                } else {
                    // This is normal for new clients - no integration data exists yet
                    if (!this.modals.create) {
                        // Only log error if not in wizard mode (for existing clients)
                        console.error("Integration details not found or not in the expected format.");
                    }
                }
            } catch (error) {
                console.error("Error fetching integration details:", error);
            }

            await this.handleDefaultCustomFields(_integrationDetails);

            $('#btnSaveIntegration').attr('disabled',false);
            $('#btnSaveIntegration').html('Save');

            // Only open standalone modal if not in wizard mode
            if (!this.modals.create) {
                this.modals.integrations = true;
            }

            // no quicksend template list at client level
        },
        isIntegrationEnabled(slug) {
            if (!this.enabledconntector) {
                return false;
            }
            
            if (slug === 'sendjim') {
                // In wizard mode, check checkbox state (enabledconntector.sendjim)
                // In standalone mode, check OAuth connection (sendjimConnected)
                if (this.modals.create && this.campaignCreateActiveStep === 3) {
                    // Wizard mode: use checkbox state
                    return this.enabledconntector.sendjim === true;
                } else {
                    // Standalone mode: use OAuth connection status
                    return this.sendjimConnected === true;
                }
            }
            
            return this.enabledconntector[slug] === true;
        },
        isIntegrationConfigured(slug) {
            // Check based on integration type using current form values
            switch(slug) {
                case 'gohighlevel':
                    return this.enabledconntector && this.enabledconntector.gohighlevel;
                case 'sendgrid':
                    return this.enabledconntector && this.enabledconntector.sendgrid && this.sendgridapikey && this.sendgridapikey.trim() !== '';
                case 'kartra':
                    return this.enabledconntector && this.enabledconntector.kartra && this.kartraappid && this.kartraappid.trim() !== '';
                case 'mailgun':
                    return this.enabledconntector && this.enabledconntector.mailgun && this.mailgunapikey && this.mailgunapikey.trim() !== '';
                case 'sendjim':
                    return this.sendjimConnected === true;
                default:
                    return false;
            }
        },
        async handleIntegrationItemClick(item){
            if(this.selectedIntegration == item.slug){
                return;
            }

            // Save current integration values if in wizard mode
            if(this.modals.create && this.campaignCreateActiveStep === 3){
                // Save current integration before switching
                if(this.selectedIntegration){
                    this.saveWizardIntegrationValues(this.selectedIntegration);
                }
            }

            this.selectedIntegration = item.slug;
            this.nameActiveIntegration = item.custom_name || item.name;

            // In wizard mode, don't refetch data - just restore saved values
            // In standalone mode, refetch to get latest data
            if(this.selectedRowData){
                if(this.modals.create && this.campaignCreateActiveStep === 3){
                    // Wizard mode: restore saved values for this integration
                    this.restoreWizardIntegrationValues(item.slug);
                    
                    // For SendJim, ensure checkbox state is explicitly restored
                    if(item.slug === 'sendjim'){
                        if(this.wizardIntegrationValues && this.wizardIntegrationValues.sendjim){
                            this.enabledconntector.sendjim = this.wizardIntegrationValues.sendjim.enabled !== undefined ? 
                                this.wizardIntegrationValues.sendjim.enabled : false;
                        } else {
                            // If not saved yet, default to false
                            this.enabledconntector.sendjim = false;
                        }
                    }
                } else {
                    // Standalone mode: fetch latest data
                    this.isIntegrationItemsFetch = true;
                    await this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                    this.isIntegrationItemsFetch = false;
                }
            }

            const refCode = item.refcode;
            if(refCode){
                const parsedData = JSON.parse(`[${refCode}]`);
                const findRefCode = parsedData.filter(item => item.rootid == this.$global.idsys).map(item => item.refcode)
                this.referralCodeActive = findRefCode;
            }

            const capitalizedModule = item.slug.charAt(0).toUpperCase() + item.slug.slice(1);

            this.handleDefaultCheckAllCustomFields('General', capitalizedModule)
            this.handleDefaultCheckAllCustomFields('B2b', capitalizedModule)
            this.handleDefaultCheckAllCustomFields('Advance', capitalizedModule)
        },
        saveWizardIntegrationValues(slug){
            // Save current integration form values to temporary storage
            if(!this.wizardIntegrationValues){
                this.wizardIntegrationValues = {};
            }

            // Check if integration has any meaningful data
            const hasApiKey = this.userApiKey[slug] &&
                (typeof this.userApiKey[slug] === 'string' ? this.userApiKey[slug].trim() !== '' :
                 Array.isArray(this.userApiKey[slug]) ? this.userApiKey[slug].some(k => k && k.trim() !== '') : false);

            const hasKartraPassword = slug === 'kartra' && this.kartraApiPassword && this.kartraApiPassword.trim() !== '';
            const hasSendjimSecret = slug === 'sendjim' && this.sendjim.clientSecret && this.sendjim.clientSecret.trim() !== '';
            const hasClickfunnelsData = slug === 'clickfunnels' && (
                (this.clickfunnels.subdomain && this.clickfunnels.subdomain.trim() !== '') ||
                (this.clickfunnels.workspaceId && this.clickfunnels.workspaceId.trim() !== '')
            );
            const isEnabled = this.enabledconntector[slug];
            
            // Check if this integration was previously configured (exists in wizardIntegrationValues)
            const wasPreviouslyConfigured = this.wizardIntegrationValues[slug] !== undefined;

            // For SendJim, also check if checkbox is enabled (even without OAuth connection)
            const hasSendjimEnabled = slug === 'sendjim' && this.enabledconntector.sendjim;

            // Always save if:
            // 1. Integration has data (API key, password, etc.)
            // 2. Integration is enabled
            // 3. Integration was previously configured (to preserve disabled state)
            // 4. For SendJim: if checkbox is enabled (even without OAuth)
            if (!hasApiKey && !hasKartraPassword && !hasSendjimSecret && !hasClickfunnelsData && !isEnabled && !wasPreviouslyConfigured && !hasSendjimEnabled) {
                // Don't save empty integrations that were never configured
                return;
            }

            // Always save enabled state and any existing data, even if disabled
            // This ensures that disabled state is preserved when user switches between integrations
            this.wizardIntegrationValues[slug] = {
                enabled: this.enabledconntector[slug],
                apiKey: this.userApiKey[slug],
                kartraPassword: this.kartraApiPassword,
                sendjimClientSecret: this.sendjim.clientSecret,
                clickfunnelsSubdomain: this.clickfunnels.subdomain,
                clickfunnelsWorkspaceId: this.clickfunnels.workspaceId,
                integrationVersion: this.integrationVersion.gohighlevel,
                sendTestZapier: this.enabledconntector.sendTestZapier,
                sendTestAgencyZoom: this.enabledconntector.sendTestAgencyZoom,
                // Custom fields
                customFieldsGeneral: this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] ? [...this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`]] : [],
                customFieldsB2b: this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] ? [...this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`]] : [],
                customFieldsAdvance: this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] ? [...this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`]] : []
            };
        },
        restoreWizardIntegrationValues(slug){
            // Restore saved integration form values from temporary storage
            if(this.wizardIntegrationValues && this.wizardIntegrationValues[slug]){
                const saved = this.wizardIntegrationValues[slug];

                // Always restore enabled state (explicitly set to false if undefined/null)
                // This ensures disabled state is preserved correctly
                this.enabledconntector[slug] = saved.enabled !== undefined && saved.enabled !== null ? saved.enabled : false;
                this.userApiKey[slug] = saved.apiKey !== undefined ? saved.apiKey : (Array.isArray(this.userApiKey[slug]) ? [''] : '');

                if(slug === 'kartra'){
                    this.kartraApiPassword = saved.kartraPassword;
                }
                if(slug === 'sendjim'){
                    this.sendjim.clientSecret = saved.sendjimClientSecret;
                    // Explicitly restore checkbox state for SendJim
                    this.enabledconntector.sendjim = saved.enabled !== undefined && saved.enabled !== null ? saved.enabled : false;
                }
                if(slug === 'clickfunnels'){
                    this.clickfunnels.subdomain = saved.clickfunnelsSubdomain;
                    this.clickfunnels.workspaceId = saved.clickfunnelsWorkspaceId;
                }
                if(slug === 'gohighlevel'){
                    this.integrationVersion.gohighlevel = saved.integrationVersion;
                }
                if(slug === 'zapier'){
                    this.enabledconntector.sendTestZapier = saved.sendTestZapier;
                }
                if(slug === 'agencyzoom'){
                    this.enabledconntector.sendTestAgencyZoom = saved.sendTestAgencyZoom;
                }

                // Restore custom fields
                const capitalizedSlug = slug.charAt(0).toUpperCase() + slug.slice(1);
                if(saved.customFieldsGeneral){
                    this[`listValueFieldsIntegration${capitalizedSlug}`] = [...saved.customFieldsGeneral];
                }
                if(saved.customFieldsB2b){
                    this[`listValueFieldsIntegration${capitalizedSlug}b2b`] = [...saved.customFieldsB2b];
                }
                if(saved.customFieldsAdvance){
                    this[`listValueFieldsIntegration${capitalizedSlug}advance`] = [...saved.customFieldsAdvance];
                }
            }
        },
        getCustomIntegrations(){
            this.integrationStatus.loading = true;
            this.integrationStatus.error = false;

            const userData = this.$store.getters.userData;
            const payload = {
                company_id: userData.company_id,
            }

            this.$store.dispatch('getCustomIntegrations', payload).then(response => {
                this.integrations = response.data;
                this.integrationStatus.loading = false;
            }).catch(error => {
                console.log(error);
                this.integrationStatus.loading = false;
                this.integrationStatus.error = true;
            })
        },
        async handleDefaultCustomFields(integrations){
            this.isLoadingCustomFieldsBySlug = true;
            this.isErrorCustomFieldsBySlug = false;

            await this.$store.dispatch('getListCustomFields').then(response => {
                this.isLoadingCustomFieldsBySlug = false;
                const data = response.data;
                const customFieldsBySlug = {};

                data.forEach(item => {
                    const slug = item.slug;

                    // Reset value
                    this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] = [];
                    this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] = [];
                    this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] = [];
                    // Reset value

                    customFieldsBySlug[slug] = item.custom_fields;
                    const customFieldsGeneral = customFieldsBySlug[slug] ? (customFieldsBySlug[slug] || []).filter(field => field.type === 'general').map(field => field.name) : customFieldsBySlug[slug]
                    const customFieldsB2b = customFieldsBySlug[slug] ? (customFieldsBySlug[slug] || []).filter(field => field.type === 'b2b').map(field => field.name) : customFieldsBySlug[slug]
                    const customFieldsAdvance = customFieldsBySlug[slug] ? (customFieldsBySlug[slug] || []).filter(field => field.type === 'advance').map(field => field.name) : customFieldsBySlug[slug]

                    if(integrations.data == '' || integrations.data.length == 0){
                        this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] = customFieldsGeneral;
                        this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] = customFieldsB2b;
                        this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] = customFieldsAdvance;
                    }
                })
                this.customFieldsBySlug = customFieldsBySlug;

                if(integrations.data == '' || integrations.data.length == 0){
                    return;
                } else {
                    integrations.data.forEach(item => {
                        const slug = item.integration_slug;
                        const customFieldsGeneral = this.customFieldsBySlug[slug] ? (this.customFieldsBySlug[slug] || []).filter(field => field.type === 'general').map(field => field.name) : this.customFieldsBySlug[slug];
                        const customFieldsB2b = this.customFieldsBySlug[slug] ? (this.customFieldsBySlug[slug] || []).filter(field => field.type === 'b2b').map(field => field.name) : this.customFieldsBySlug[slug];
                        const customFieldsAdvance = this.customFieldsBySlug[slug] ? (this.customFieldsBySlug[slug] || []).filter(field => field.type === 'advance').map(field => field.name) : this.customFieldsBySlug[slug];

                        if(item.custom_fields){
                            const listDisabledCustomFields = (this.customFieldsBySlug[slug] || []).filter(field => field.disabled && field.type === 'general').map(field => field.name)
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] = [...(listDisabledCustomFields || []), ...(item.custom_fields || [])]
                        } else {
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] = [...(customFieldsGeneral || [])]
                        }

                        if (item.custom_fields_b2b){
                            const listDisabledCustomFields = (this.customFieldsBySlug[slug] || []).filter(field => field.disabled && field.type === 'b2b').map(field => field.name);
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] = [...(listDisabledCustomFields || []), ...(item.custom_fields_b2b || [])]
                        } else {
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] = [...(customFieldsB2b || [])]
                        }
                        
                        if (item.custom_fields_advance){
                            const listDisabledCustomFields = (this.customFieldsBySlug[slug] || []).filter(field => field.disabled && field.type === 'advance').map(field => field.name);
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] = [...(listDisabledCustomFields || []), ...(item.custom_fields_advance || [])]
                        } else {
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] = [...(customFieldsAdvance || [])]
                        }
                    })
                }

                this.handleCustomFieldsEmpty(integrations, 'Clickfunnels')
                this.handleCustomFieldsEmpty(integrations, 'Gohighlevel')
                this.handleCustomFieldsEmpty(integrations, 'Sendjim')

                // FOR LOGS
                this.handleDefaultLogsCustomFields('Clickfunnels')
                this.handleDefaultLogsCustomFields('Gohighlevel')
                this.handleDefaultLogsCustomFields('Sendjim')
                // FOR LOGS

            }).catch(error => {
                console.log(error);
                
                this.isErrorCustomFieldsBySlug = true;
                this.isLoadingCustomFieldsBySlug = false;
            })
        },
        async saveIntegrationSettingslocal() {
            var _slug = this.selectedIntegration;

            // const handleFilterListCustomFields = (name) => {
            //     const listDisabledCustomFields = this.customFieldsBySlug[name.toLowerCase()].filter(item => item.disabled).map(item => item.name)
            //     const filteredListGeneral = this[`listValueFieldsIntegration${name}`].filter(item => !listDisabledCustomFields.includes(item));
            //     const filteredListB2b = this[`listValueFieldsIntegration${name}b2b`].filter(item => !listDisabledCustomFields.includes(item));

            //     return { filteredListGeneral, filteredListB2b }
            // }
            
            $('#btnSaveIntegration').attr('disabled',true);
            $('#btnSaveIntegration').html('Saving...');   

            let data = {
                integration_slug: this.selectedIntegration,
                company_id: this.selectedRowData.company_id,
                api_key: this.userApiKey[_slug],
                enable_sendgrid: this.enabledconntector[_slug] ? 1 : 0,
                enable_default_campaign: 0,
            }

            if (!this.validateConfiguration(data)) {
                $('#btnSaveIntegration').attr('disabled',false);
                $('#btnSaveIntegration').html('Save');  
                return;
            }
            
            if(_slug === 'kartra'){
                data.password = this.kartraApiPassword
                // data.app_id = this.kartraAppId
            }
            if(_slug === 'sendjim'){
                if(!this.userApiKey.sendjim || this.userApiKey.sendjim.trim() === ''){
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');  
                    return this.$notify({ type: 'danger', message: 'Client ID is required', icon: 'fas fa-bug' });
                }
                if(!this.sendjim.clientSecret || this.sendjim.clientSecret.trim() === ''){
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');  
                    return this.$notify({ type: 'danger', message: 'Client Secret is required', icon: 'fas fa-bug' });
                }
                if (this.sendjimQuickSendEnabled && (!Array.isArray(this.sendjimQuickSendTemplates) || this.sendjimQuickSendTemplates.length === 0)){
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');
                    return this.$notify({ type: 'danger', message: 'Please select at least one Quick Send template', icon: 'fas fa-bug' });
                }
                data.password = this.sendjim.clientSecret;
            }
            if(_slug === 'gohighlevel'){
                try {
                    await MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    });

                } catch (error) {
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');  
                    return;
                }
                
                const { filteredListGeneral, filteredListB2b, filteredListAdvance } = this.handleFilterListCustomFields('Gohighlevel');

                data.version = this.integrationVersion.gohighlevel;
                data.custom_fields = filteredListGeneral;
                data.custom_fields_b2b = filteredListB2b;
                data.custom_fields_advance = filteredListAdvance;
            }
            if(_slug === 'zapier'){
                data.send_test_zapier = this.enabledconntector.sendTestZapier
                const validWebhookUrls = this.userApiKey.zapier.filter(item => !item || item.trim() != "");
                data.api_key = validWebhookUrls
                const validLabels = this.zapierWebhookLabels.slice(0, validWebhookUrls.length).map((label, idx) => {
                    return (label || '').trim();
                });
                data.webhook_labels = validLabels
            }
            if(_slug === 'clickfunnels'){
                if (this.validateClickFunnelsFields(_slug)) {
                    return;
                }
                
                try {
                    await MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    });

                } catch (error) {
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');  
                    return;
                }

                data.subdomain = this.clickfunnels.subdomain;
                data.workspace_id = this.clickfunnels.workspaceId;
                
                const { filteredListGeneral, filteredListB2b, filteredListAdvance } = this.handleFilterListCustomFields('Clickfunnels')
            
                data.custom_fields = filteredListGeneral;
                data.custom_fields_b2b = filteredListB2b;
                data.custom_fields_advance = filteredListAdvance;
            }
            if(_slug === 'agencyzoom'){
                data.send_test_agency_zoom = this.enabledconntector.sendTestAgencyZoom
                const validWebhookUrls = this.userApiKey.agencyzoom.filter(item => !item || item.trim() != "");
                data.api_key = validWebhookUrls
                // Only send enable_sendgrid if checkbox is enabled, otherwise don't send it at all
                // Backend will auto-enable if enable_sendgrid field exists, even if value is 0
                if (!this.enabledconntector.agencyzoom) {
                    delete data.enable_sendgrid;
                }
            }

            const response = await this.saveIntegrationSettings({ data })

            // FOR LOGS
            if(response.result == 'success'){
                const userData = this.$store.getters.userData;
                
                if(_slug === 'clickfunnels' || _slug === 'gohighlevel'){
                    const capitalizeFirstSlug = _slug.charAt(0).toUpperCase() + _slug.slice(1);
                    let desc = `Company Id: ${this.selectedRowData.company_id} | Integration Type: ${_slug} | `;

                    const appendDescription = (field, prevValue, newValue) => {
                        desc += `${field} : Update values from ${prevValue || 'Empty'} to: ${newValue || 'Empty'} | `;
                    };
                    const joinArray = (arr) => (arr && arr.length > 0 ? arr.join(', ') : 'Empty');

                    const isChangedCustomFields = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}`], data.custom_fields)
                    const isChangedCustomFieldsB2b = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}b2b`], data.custom_fields_b2b)
                    const isChangedCustomFieldsAdvance = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}advance`], data.custom_fields_advance)

                    if(isChangedCustomFields){
                        appendDescription(
                            "Custom Fields",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}`]),
                            joinArray(data.custom_fields)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += `Custom Fields : No changes, value remains ${joinArray(data.custom_fields)}`;
                    }

                    if(isChangedCustomFieldsB2b){
                        appendDescription(
                            " | Custom Fields B2B",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}b2b`]),
                            joinArray(data.custom_fields_b2b)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += ` | Custom Fields B2B : No changes, value remains ${joinArray(data.custom_fields_b2b)}`;
                    }

                    if(isChangedCustomFieldsAdvance){
                        appendDescription(
                            " | Custom Fields Enhance Advance",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}advance`]),
                            joinArray(data.custom_fields_advance)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += ` | Custom Fields Advance : No changes, value remains ${joinArray(data.custom_fields_advance)}`;
                    }

                    // const payload = {
                    //     userID: userData.id,
                    //     action: "Custom Fields",
                    //     desc,
                    //     userIP: this.$store.getters.userData.ip_login,
                    // }
                    // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                    // if(userViewMode){
                    //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                    //     payload.userID = userRoot.id;
                    // }
                    // this.userLogSaved({ data: payload });
                    this.$store.dispatch('onSaveUserLogs', {
                        desc: desc,
                        action: "Custom Fields",
                        target_id: userData.id,
                    })

                }

                // fetch ulang data nya setiap pindah integration agar selalu uptodate
                if(this.selectedRowData){
                    await this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                }
                // fetch ulang data nya setiap pindah integration agar selalu uptodate
            }
            // FOR LOGS

            $('#btnSaveIntegration').attr('disabled',false);
            $('#btnSaveIntegration').html('Save');
            // this.modals.integrations = false;
        },
        async saveIntegrationSettingsWizardSingle() {
            // Save single integration without showing toast notifications (used in wizard)
            var _slug = this.selectedIntegration;
            const isEnabled = this.enabledconntector[_slug];

            let data = {
                integration_slug: this.selectedIntegration,
                company_id: this.selectedRowData.company_id,
                api_key: this.userApiKey[_slug],
                enable_sendgrid: isEnabled ? 1 : 0,
                enable_default_campaign: 0,
            }

            // Only validate if integration is enabled
            // If disabled, skip validation and save as disabled
            if (isEnabled && !this.validateConfiguration(data)) {
                // Get more specific error message from validateConfiguration
                const errorMsg = this.getValidationErrorMessage(data);
                throw new Error(errorMsg || 'Validation failed: Required fields are missing');
            }

            if(_slug === 'kartra'){
                data.password = this.kartraApiPassword
            }
            if(_slug === 'sendjim'){
                // Only require Client ID and Secret if integration is enabled
                if(this.enabledconntector.sendjim){
                    if(!this.userApiKey.sendjim || this.userApiKey.sendjim.trim() === ''){
                        throw new Error('Client ID is required');
                    }
                    if(!this.sendjim.clientSecret || this.sendjim.clientSecret.trim() === ''){
                        throw new Error('Client Secret is required');
                    }
                    if (this.sendjimQuickSendEnabled && (!Array.isArray(this.sendjimQuickSendTemplates) || this.sendjimQuickSendTemplates.length === 0)){
                        throw new Error('Please select at least one Quick Send template');
                    }
                    data.password = this.sendjim.clientSecret;
                }
            }
            if(_slug === 'gohighlevel'){
                const { filteredListGeneral, filteredListB2b, filteredListAdvance } = this.handleFilterListCustomFields('Gohighlevel');

                data.version = this.integrationVersion.gohighlevel;
                data.custom_fields = filteredListGeneral;
                data.custom_fields_b2b = filteredListB2b;
                data.custom_fields_advance = filteredListAdvance;
            }
            if(_slug === 'zapier'){
                data.send_test_zapier = this.enabledconntector.sendTestZapier
                const validWebhookUrls = this.userApiKey.zapier.filter(item => !item || item.trim() != "");
                data.api_key = validWebhookUrls
                const validLabels = this.zapierWebhookLabels.slice(0, validWebhookUrls.length).map((label, idx) => {
                    return (label || '').trim();
                });
                data.webhook_labels = validLabels
            }
            if(_slug === 'clickfunnels'){
                if (this.validateClickFunnelsFields(_slug)) {
                    throw new Error('ClickFunnels validation failed');
                }

                data.subdomain = this.clickfunnels.subdomain;
                data.workspace_id = this.clickfunnels.workspaceId;

                const { filteredListGeneral, filteredListB2b, filteredListAdvance } = this.handleFilterListCustomFields('Clickfunnels')

                data.custom_fields = filteredListGeneral;
                data.custom_fields_b2b = filteredListB2b;
                data.custom_fields_advance = filteredListAdvance;
            }
            if(_slug === 'agencyzoom'){
                data.send_test_agency_zoom = this.enabledconntector.sendTestAgencyZoom
                const validWebhookUrls = this.userApiKey.agencyzoom.filter(item => !item || item.trim() != "");
                data.api_key = validWebhookUrls
                // Only send enable_sendgrid if checkbox is enabled, otherwise don't send it at all
                // Backend will auto-enable if enable_sendgrid field exists, even if value is 0
                if (!this.enabledconntector.agencyzoom) {
                    delete data.enable_sendgrid;
                }
            }

            const response = await this.saveIntegrationSettings({ data, silent: true })

            // FOR LOGS (same as saveIntegrationSettingslocal but without notifications)
            if(response.result == 'success'){
                const userData = this.$store.getters.userData;

                if(_slug === 'clickfunnels' || _slug === 'gohighlevel'){
                    const capitalizeFirstSlug = _slug.charAt(0).toUpperCase() + _slug.slice(1);
                    let desc = `Company Id: ${this.selectedRowData.company_id} | Integration Type: ${_slug} | `;

                    const appendDescription = (field, prevValue, newValue) => {
                        desc += `${field} : Update values from ${prevValue || 'Empty'} to: ${newValue || 'Empty'} | `;
                    };
                    const joinArray = (arr) => (arr && arr.length > 0 ? arr.join(', ') : 'Empty');

                    const isChangedCustomFields = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}`], data.custom_fields)
                    const isChangedCustomFieldsB2b = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}b2b`], data.custom_fields_b2b)
                    const isChangedCustomFieldsAdvance = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}advance`], data.custom_fields_advance)

                    if(isChangedCustomFields){
                        appendDescription(
                            "Custom Fields",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}`]),
                            joinArray(data.custom_fields)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += `Custom Fields : No changes, value remains ${joinArray(data.custom_fields)}`;
                    }

                    if(isChangedCustomFieldsB2b){
                        appendDescription(
                            " | Custom Fields B2B",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}b2b`]),
                            joinArray(data.custom_fields_b2b)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += ` | Custom Fields B2B : No changes, value remains ${joinArray(data.custom_fields_b2b)}`;
                    }

                    if(isChangedCustomFieldsAdvance){
                        appendDescription(
                            " | Custom Fields Enhance Advance",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}advance`]),
                            joinArray(data.custom_fields_advance)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += ` | Custom Fields Advance : No changes, value remains ${joinArray(data.custom_fields_advance)}`;
                    }

                    this.$store.dispatch('onSaveUserLogs', {
                        desc: desc,
                        action: "Custom Fields",
                        target_id: userData.id,
                    })

                }

                // fetch ulang data nya setiap pindah integration agar selalu uptodate
                if(this.selectedRowData){
                    await this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                }
            }

            return response;
        },
        async saveIntegrationSettingsWizard() {
            // Save ALL configured integrations in wizard mode and close the wizard
            this.updateSaveNextButtonState({ disabled: true, loading: true });

            let savedCount = 0;
            let failedIntegrations = [];
            let successIntegrations = [];
            let hasValidationError = false; // Flag to track if validation failed

            try {
                // Save current integration values first
                this.saveWizardIntegrationValues(this.selectedIntegration);

                // Get list of all integrations that have been configured
                const configuredIntegrations = Object.keys(this.wizardIntegrationValues);

                if (configuredIntegrations.length === 0) {
                    // No integrations configured, just close wizard
                    this.modals.create = false;
                    this.campaignCreateActiveStep = 0;
                    this.createdClientData = null;
                    this.wizardIntegrationValues = {};
                    this.GetClientList(this.currSortBy, this.currOrderBy);

                    this.updateSaveNextButtonState({ disabled: false, loading: false });
                    
                    // Clear iframe status
                    this.createdClientIframeStatus = null;
                    return;
                }

                // Pre-validate all enabled integrations before attempting to save
                // This ensures we catch all validation errors upfront
                const validationErrors = [];
                for (const slug of configuredIntegrations) {
                    // Restore values for this integration to check
                    this.restoreWizardIntegrationValues(slug);
                    this.selectedIntegration = slug;
                    
                    // Get integration name for error message
                    const integration = this.integrations.find(item => item.slug === slug);
                    const integrationName = integration ? (integration.custom_name || integration.name) : slug;
                    
                    // Check if integration is enabled
                    const isEnabled = this.enabledconntector[slug];
                    
                    // Only validate if integration is enabled
                    if (isEnabled) {
                        let data = {
                            integration_slug: slug,
                            company_id: this.selectedRowData.company_id,
                            api_key: this.userApiKey[slug],
                            enable_sendgrid: 1,
                            enable_default_campaign: 0,
                        };
                        
                        // Pre-validate before attempting to save
                        let validationError = this.getValidationErrorMessage(data);
                        
                        // Additional validation for specific integrations
                        if (slug === 'sendjim') {
                            if (!this.userApiKey.sendjim || this.userApiKey.sendjim.trim() === '') {
                                validationError = 'Client ID is required';
                            } else if (!this.sendjim.clientSecret || this.sendjim.clientSecret.trim() === '') {
                                validationError = 'Client Secret is required';
                            }
                        }
                        
                        // Additional validation for ClickFunnels
                        if (slug === 'clickfunnels') {
                            const { subdomain, workspaceId } = this.clickfunnels;
                            const apiKey = this.userApiKey[slug];
                            let missingFields = [];
                            if (!apiKey || apiKey.trim() === "") missingFields.push("API Key");
                            if (!subdomain || subdomain.trim() === "") missingFields.push("Subdomain");
                            if (!workspaceId || workspaceId.trim() === "") missingFields.push("Workspace ID");
                            if (missingFields.length > 0) {
                                validationError = `Please fill in: ${missingFields.join(', ')}`;
                            }
                        }
                        
                        if (validationError) {
                            // Collect validation errors - don't save if any enabled integration is invalid
                            validationErrors.push({
                                slug: slug,
                                name: integrationName,
                                error: validationError
                            });
                        }
                    }
                }
                
                // If there are validation errors, stop and show error message
                if (validationErrors.length > 0) {
                    hasValidationError = true; // Set flag to prevent notifications in finally
                    this.updateSaveNextButtonState({ disabled: false, loading: false });
                    
                    let errorMessage = `Please fill in required fields for the following integration${validationErrors.length > 1 ? 's' : ''}:\n\n`;
                    validationErrors.forEach((error, index) => {
                        errorMessage += `${index + 1}. ${error.name}: ${error.error}`;
                        if (index < validationErrors.length - 1) {
                            errorMessage += '\n';
                        }
                    });
                    errorMessage += '\n\nPlease complete the required fields before saving.';
                    
                    this.$notify({
                        type: 'danger',
                        title: 'Validation Failed',
                        message: errorMessage,
                        icon: 'fas fa-exclamation-triangle',
                        duration: 10000,
                        dangerouslyUseHTMLString: false,
                        offset: 80
                    });
                    
                    // Don't close modal, don't save anything
                    return;
                }

                // All validations passed, proceed with saving
                // Save each configured integration sequentially
                for (const slug of configuredIntegrations) {
                    try {
                        // Get integration name for error message
                        const integration = this.integrations.find(item => item.slug === slug);
                        const integrationName = integration ? (integration.custom_name || integration.name) : slug;

                        // Restore values for this integration
                        this.restoreWizardIntegrationValues(slug);
                        this.selectedIntegration = slug;

                        // Save this integration without showing toast
                        const response = await this.saveIntegrationSettingsWizardSingle();

                        if (response && response.result === 'success') {
                            savedCount++;
                            successIntegrations.push({
                                slug: slug,
                                name: integrationName
                            });
                        } else {
                            // Extract error message from response
                            let errorMessage = 'Unknown error';
                            if (response && response.message) {
                                errorMessage = response.message;
                            } else if (response && response.msg) {
                                errorMessage = response.msg;
                            }
                            // Continue saving other integrations even if one fails
                            failedIntegrations.push({
                                slug: slug,
                                name: integrationName,
                                error: errorMessage
                            });
                        }
                    } catch (error) {
                        console.error(`Failed to save ${slug} integration:`, error);
                        // Get integration name for error message
                        const integration = this.integrations.find(item => item.slug === slug);
                        const integrationName = integration ? (integration.custom_name || integration.name) : slug;
                        
                        // Continue saving other integrations even if one fails
                        failedIntegrations.push({
                            slug: slug,
                            name: integrationName,
                            error: error.message || 'Failed to save integration'
                        });
                    }
                }

                // Close wizard
                this.modals.create = false;
                this.campaignCreateActiveStep = 0;
                this.createdClientData = null;
                this.wizardIntegrationValues = {}; // Clear temporary storage

                // Refresh the client list
                this.GetClientList(this.currSortBy, this.currOrderBy);

            } catch (error) {
                console.error('Error saving integrations:', error);
                // Don't show notification here, will show in finally
            } finally {
                this.updateSaveNextButtonState({ disabled: false, loading: false });

                // Don't show notifications if validation failed (already shown error message)
                if (hasValidationError) {
                    return;
                }

                // Helper to escape HTML for safety
                const escapeHtml = (text) => {
                    if (!text) return '';
                    const div = document.createElement('div');
                    div.textContent = text;
                    return div.innerHTML;
                };

                const renderList = (items, variant) => {
                    const colorClass = {
                        success: 'int-success',
                        warning: 'int-warning',
                        danger: 'int-danger'
                    }[variant] || 'int-default';

                    return `
                        <ul class="int-list ${colorClass}">
                            ${items.map(item => `
                                <li>
                                    <span class="int-item">${escapeHtml(item.name)}</span>
                                    ${item.error ? `<div class="int-sub">${escapeHtml(item.error)}</div>` : ''}
                                </li>
                            `).join('')}
                        </ul>
                    `;
                };

                // Show consolidated notification after all integrations are processed
                if (failedIntegrations.length === 0 && savedCount > 0) {
                    const successHtml = `
                        <div class="int-section">
                            <div class="int-section-title int-success">
                                <i class="el-icon-success"></i>
                                <span>Successfully configured ${savedCount} integration${savedCount > 1 ? 's' : ''}</span>
                            </div>
                            ${renderList(successIntegrations, 'success')}
                        </div>
                    `;

                    Notification({
                        title: 'Integrations Configured',
                        message: successHtml,
                        customClass: 'integration-notify-card',
                        duration: 8000,
                        dangerouslyUseHTMLString: true,
                        offset: 80
                    });
                } else if (savedCount > 0 && failedIntegrations.length > 0) {
                    // Some integrations saved, some failed
                    const skippedIntegrations = failedIntegrations.filter(f => f.skipped);
                    const failedIntegrationsOnly = failedIntegrations.filter(f => !f.skipped);

                    let message = '';

                    if (successIntegrations.length > 0) {
                        message += `
                            <div class="int-section">
                                <div class="int-section-title int-success">
                                    <i class="el-icon-success"></i>
                                    <span>Successfully configured ${savedCount} integration${savedCount > 1 ? 's' : ''}</span>
                                </div>
                                ${renderList(successIntegrations, 'success')}
                            </div>
                        `;
                    }

                    if (skippedIntegrations.length > 0) {
                        message += `
                            <div class="int-section">
                                <div class="int-section-title int-warning">
                                    <i class="el-icon-warning"></i>
                                    <span>Skipped ${skippedIntegrations.length} integration${skippedIntegrations.length > 1 ? 's' : ''} (enabled but missing data)</span>
                                </div>
                                ${renderList(skippedIntegrations, 'warning')}
                            </div>
                        `;
                    }

                    if (failedIntegrationsOnly.length > 0) {
                        message += `
                            <div class="int-section">
                                <div class="int-section-title int-danger">
                                    <i class="el-icon-error"></i>
                                    <span>Failed to save ${failedIntegrationsOnly.length} integration${failedIntegrationsOnly.length > 1 ? 's' : ''}</span>
                                </div>
                                ${renderList(failedIntegrationsOnly, 'danger')}
                            </div>
                        `;
                    }

                    message += `
                        <div class="int-footer">
                            <i class="el-icon-info"></i>
                            <span>You can configure them later in Integration Settings.</span>
                        </div>
                    `;

                    Notification({
                        title: 'Integrations Partially Configured',
                        message: message,
                        customClass: 'integration-notify-card',
                        duration: 15000,
                        dangerouslyUseHTMLString: true,
                        offset: 80
                    });
                } else if (failedIntegrations.length > 0 && savedCount === 0) {
                    // All integrations failed or skipped
                    const skippedIntegrations = failedIntegrations.filter(f => f.skipped);
                    const failedIntegrationsOnly = failedIntegrations.filter(f => !f.skipped);

                    let failedMessage = '';

                    if (skippedIntegrations.length > 0) {
                        failedMessage += `
                            <div class="int-section">
                                <div class="int-section-title int-warning">
                                    <i class="el-icon-warning"></i>
                                    <span>Skipped ${skippedIntegrations.length} integration${skippedIntegrations.length > 1 ? 's' : ''} (enabled but missing data)</span>
                                </div>
                                ${renderList(skippedIntegrations, 'warning')}
                            </div>
                        `;
                    }

                    if (failedIntegrationsOnly.length > 0) {
                        failedMessage += `
                            <div class="int-section">
                                <div class="int-section-title int-danger">
                                    <i class="el-icon-error"></i>
                                    <span>Failed to save ${failedIntegrationsOnly.length} integration${failedIntegrationsOnly.length > 1 ? 's' : ''}</span>
                                </div>
                                ${renderList(failedIntegrationsOnly, 'danger')}
                            </div>
                        `;
                    }

                    failedMessage += `
                        <div class="int-footer danger">
                            <i class="el-icon-warning-outline"></i>
                            <span>Please review and try again.</span>
                        </div>
                    `;

                    Notification({
                        title: 'Integration Configuration Issues',
                        message: failedMessage,
                        customClass: 'integration-notify-card',
                        duration: 15000,
                        dangerouslyUseHTMLString: true,
                        offset: 80
                    });
                } else {
                    // Fallback: no integrations configured
                    Notification({
                        title: 'Wizard Completed',
                        message: 'Client setup completed successfully!',
                        customClass: 'integration-notify-card',
                        duration: 5000,
                        dangerouslyUseHTMLString: false,
                        offset: 80
                    });
                }
                
                // Clear iframe status after showing notification
                this.createdClientIframeStatus = null;
            }
        },
        displayMoney(val) {
          return this.$global.formatMoney(parseFloat(val));
        },
        failedInvoiceTotal() {
            // Calculate the total of the array items
            this.failedTotalOutstanding = this.failedInvoiceAmount.reduce((acc, val) => acc + parseFloat(val), 0);
            return this.$global.formatMoney(this.failedTotalOutstanding);
        },
        /** FOR UPLOAD FILE */
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
            this.uploadFieldName = 'clientoptoutfile';
            $('input[type="file"]').val(null);
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

           //console.log(formData);

           const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin' : '*',
                }
           };

            axios.post(process.env.VUE_APP_APISERVER_URL + '/api/tools/optout-client/upload', formData, config)
            .then(response => {
                //console.log(response.data);
                if(response.data.result == 'success') {
                    this.currentStatus = STATUS_SUCCESS;
                    this.reset();
                }else{
                    this.currentStatus = STATUS_FAILED;
                    this.reset();
                }
            })
            .catch(error => {
                //console.log(error);
                this.currentStatus = STATUS_FAILED;
                this.reset();
                //reject(error)
            })

            setTimeout(() => {
                this.checkStatusFileUpload()
            }, 2000)

            /* UPLOAD FILE */
            // try 
            // {
            //     const response = await axios.post(process.env.VUE_APP_APISERVER_URL + '/api/tools/optout-client/upload', formData, config)
                
            //     if (response.data.result == 'success') {
            //         this.currentStatus = STATUS_SUCCESS;
            //         this.checkStatusFileUpload();
            //         setTimeout(() => {
            //             this.reset();
            //         }, 2000);
            //     } else {
            //         this.currentStatus = STATUS_FAILED;
            //         setTimeout(() => {
            //             this.reset();
            //         }, 2000);
            //     }
            // } 
            // catch(error) 
            // {
            //     console.error(error);
            //     this.currentStatus = STATUS_FAILED;
            //     setTimeout(() => {
            //         this.reset();
            //     }, 2000);
            // }
            /* UPLOAD FILE */
        },
        purgeSuppressionList(action){
            swal.fire({
                title: 'Record Purge Confirmation',
                text: "Are you sure you want to purge existing records?",
                showCancelButton: true,
                confirmButtonColor: 'blue',
                cancelButtonColor: 'red',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    // Perform the deletion
                    this.$store.dispatch('purgeSuppressionList', {
                        paramID: this.whiteListClientID,
                        campaignType: action,
                    }).then(response => {
                        this.supressionDone = [];
                        if (response.result === 'success') {
                            swal.fire({
                                icon: 'success',
                                title: response.title,
                                text: response.msg,
                                confirmButtonText: 'OK'
                            });
                        } else {
                            swal.fire({
                                icon: 'error',
                                title: response.title,
                                text: response.msg,
                                confirmButtonText: 'OK'
                            });
                        }
                    }).catch(error => {
                        swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'There was an error processing your request.',
                            confirmButtonText: 'OK'
                        });
                    });
                }
            });
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) return;
            const file = fileList[0];
            const validCSV = /\.(csv)$/i.test(file.name);

            if (!validCSV) {
                this.$notify({
                    type: 'danger',
                    message: 'Invalid file format. This upload only supports CSV files.',
                    icon: 'fas fa-bug'
                })

                return;
            }

            // append the files to FormData
            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                const fileMapping = fileList[x];
                const cleanFileName = fileMapping.name
                    .replace(/\s+/g, "_")
                    .replace(/[^a-zA-Z0-9_.-]/g, "")
                    .toLowerCase();

                const newFile = new File([fileMapping], cleanFileName, { type: fileMapping.type });

                formData.append(fieldName, newFile, cleanFileName);
            });
            
            formData.append("ClientCompanyID",this.whiteListClientID);
            formData.append("campaigntype","client");
            // save it
            this.save(formData);
        },
        showWhitelist(index,row) {
            //console.log(row);
            if (row.optoutfile !== null) {
                this.optoutfileexist = false;
            }
            this.whiteListClientID = row.company_id;
            this.modals.whitelist = true;

            this.checkStatusFileUpload();
        },
        getCardStatus(row) {
            const styleObject = {};
            if (row.customer_payment_id == '' || row.customer_card_id == '') {
                styleObject.color = 'gray';
            }else{
                styleObject.color = 'green';
                if (row.payment_status == "failed") {
                    styleObject.color = 'red';
                }
            }
            return styleObject;
        },
        closebtnupdatecard() {
            window.location.reload();
        },
        clientreceiveemail(row) {
            if (row.disabled_receive_email == 'T') {
                row.disabled_receive_email = 'F';
            }else{
                row.disabled_receive_email = 'T';
            }
        },
        clientaddcampaign(row) {
            if (row.disable_client_add_campaign == 'T') {
                row.disable_client_add_campaign = 'F';
            }else{
                row.disable_client_add_campaign = 'T';
            }
        },
        clientenableeditor(row) {
            if (row.editor_spreadsheet == 'T') {
                row.editor_spreadsheet = 'F';
            }else{
                row.editor_spreadsheet = 'T';
            }
        },
        clientenablephonenumber(row) {
            if (row.enabled_phone_number == 'T') {
                row.enabled_phone_number = 'F';
            }else{
                row.enabled_phone_number = 'T';
            }
        },
        validateMinimumInput(event,type) {
            const handlers = {
                keyup: {
                    maxBid: () => {
                    	this.simplifiErrorInput.maxBid = (Number(this.SimplifiMaxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) ?
                                                         (`*Max Bid Minimum $${this.simplifiPriceRule.maxBid.minimum}`) :
                                                         (``) ;
                    },
                    dailyBudget: () => {
                        this.simplifiErrorInput.dailyBudget = (Number(this.SimplifiDailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) ?
                                                              (`*Daily Budget Minimum $${this.simplifiPriceRule.dailyBudget.minimum}`) :
                                                              (``) ;
                    }
                },
                blur: {
                    maxBid: () => {
                        this.simplifiErrorInput.maxBid = "";
                        this.SimplifiMaxBid = (Number(this.SimplifiMaxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) ?
                                              (this.simplifiPriceRule.maxBid.minimum) :
                                              (this.SimplifiMaxBid) ;
                    },
                    dailyBudget: () => {
                        this.simplifiErrorInput.dailyBudget = "";
                        this.SimplifiDailyBudget = (Number(this.SimplifiDailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) ?
                                                   (this.simplifiPriceRule.dailyBudget.minimum) :
                                                   (this.SimplifiDailyBudget) ;
                    }
                }
            }

            if (handlers[event] && handlers[event][type]) {
                handlers[event][type]();
            }
        },
        set_fee(type,typevalue) {
            if (type == 'local') {

                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    if (typevalue == 'LeadspeekPlatformFee') {
                        this.costagency.local.Weekly.LeadspeekPlatformFee = this.LeadspeekPlatformFee;
                    }else if (typevalue == 'LeadspeekCostperlead') {
                        this.costagency.local.Weekly.LeadspeekCostperlead = this.LeadspeekCostperlead;
                    }else if (typevalue == 'LeadspeekCostperleadAdvanced') {
                        this.costagency.local.Weekly.LeadspeekCostperleadAdvanced = this.LeadspeekCostperleadAdvanced;
                    }else if (typevalue == 'LeadspeekMinCostMonth') {
                        this.costagency.local.Weekly.LeadspeekMinCostMonth = this.LeadspeekMinCostMonth;
                    }else if (typevalue == 'LeadspeekLeadsPerday') {
                        this.costagency.local.Weekly.LeadspeekLeadsPerday = this.LeadspeekLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    if (typevalue == 'LeadspeekPlatformFee') {
                        this.costagency.local.Monthly.LeadspeekPlatformFee = this.LeadspeekPlatformFee;
                    }else if (typevalue == 'LeadspeekCostperlead') {
                        this.costagency.local.Monthly.LeadspeekCostperlead = this.LeadspeekCostperlead;
                    }else if (typevalue == 'LeadspeekCostperleadAdvanced') {
                        this.costagency.local.Monthly.LeadspeekCostperleadAdvanced = this.LeadspeekCostperleadAdvanced;
                    }else if (typevalue == 'LeadspeekMinCostMonth') {
                        this.costagency.local.Monthly.LeadspeekMinCostMonth = this.LeadspeekMinCostMonth;
                    }else if (typevalue == 'LeadspeekLeadsPerday') {
                        this.costagency.local.Monthly.LeadspeekLeadsPerday = this.LeadspeekLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    if (typevalue == 'LeadspeekPlatformFee') {
                        this.costagency.local.OneTime.LeadspeekPlatformFee = this.LeadspeekPlatformFee;
                    }else if (typevalue == 'LeadspeekCostperlead') {
                        this.costagency.local.OneTime.LeadspeekCostperlead = this.LeadspeekCostperlead;
                    }else if (typevalue == 'LeadspeekCostperleadAdvanced') {
                        this.costagency.local.OneTime.LeadspeekCostperleadAdvanced = this.LeadspeekCostperleadAdvanced;
                    }else if (typevalue == 'LeadspeekMinCostMonth') {
                        this.costagency.local.OneTime.LeadspeekMinCostMonth = this.LeadspeekMinCostMonth;
                    }else if (typevalue == 'LeadspeekLeadsPerday') {
                        this.costagency.local.OneTime.LeadspeekLeadsPerday = this.LeadspeekLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    if (typevalue == 'LeadspeekPlatformFee') {
                        this.costagency.local.Prepaid.LeadspeekPlatformFee = this.LeadspeekPlatformFee;
                    }else if (typevalue == 'LeadspeekCostperlead') {
                        this.costagency.local.Prepaid.LeadspeekCostperlead = this.LeadspeekCostperlead;
                    }else if (typevalue == 'LeadspeekCostperleadAdvanced') {
                        this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced = this.LeadspeekCostperleadAdvanced;
                    }else if (typevalue == 'LeadspeekMinCostMonth') {
                        this.costagency.local.Prepaid.LeadspeekMinCostMonth = this.LeadspeekMinCostMonth;
                    }else if (typevalue == 'LeadspeekLeadsPerday') {
                        this.costagency.local.Prepaid.LeadspeekLeadsPerday = this.LeadspeekLeadsPerday;
                    }
                }

            }else if (type == 'locator') {

                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    if (typevalue == 'LocatorPlatformFee') {
                        this.costagency.locator.Weekly.LocatorPlatformFee = this.LocatorPlatformFee;
                    }else if (typevalue == 'LocatorCostperlead') {
                        this.costagency.locator.Weekly.LocatorCostperlead = this.LocatorCostperlead;
                    }else if (typevalue == 'LocatorMinCostMonth') {
                        this.costagency.locator.Weekly.LocatorMinCostMonth = this.LocatorMinCostMonth;
                    }else if (typevalue == 'LocatorLeadsPerday') {
                        this.costagency.locator.Weekly.LocatorLeadsPerday = this.LocatorLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    if (typevalue == 'LocatorPlatformFee') {
                        this.costagency.locator.Monthly.LocatorPlatformFee = this.LocatorPlatformFee;
                    }else if (typevalue == 'LocatorCostperlead') {
                        this.costagency.locator.Monthly.LocatorCostperlead = this.LocatorCostperlead;
                    }else if (typevalue == 'LocatorMinCostMonth') {
                        this.costagency.locator.Monthly.LocatorMinCostMonth = this.LocatorMinCostMonth;
                    }else if (typevalue == 'LocatorLeadsPerday') {
                        this.costagency.locator.Monthly.LocatorLeadsPerday = this.LocatorLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    if (typevalue == 'LocatorPlatformFee') {
                        this.costagency.locator.OneTime.LocatorPlatformFee = this.LocatorPlatformFee;
                    }else if (typevalue == 'LocatorCostperlead') {
                        this.costagency.locator.OneTime.LocatorCostperlead = this.LocatorCostperlead;
                    }else if (typevalue == 'LocatorMinCostMonth') {
                        this.costagency.locator.OneTime.LocatorMinCostMonth = this.LocatorMinCostMonth;
                    }else if (typevalue == 'LocatorLeadsPerday') {
                        this.costagency.locator.OneTime.LocatorLeadsPerday = this.LocatorLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    if (typevalue == 'LocatorPlatformFee') {
                        this.costagency.locator.Prepaid.LocatorPlatformFee = this.LocatorPlatformFee;
                    }else if (typevalue == 'LocatorCostperlead') {
                        this.costagency.locator.Prepaid.LocatorCostperlead = this.LocatorCostperlead;
                    }else if (typevalue == 'LocatorMinCostMonth') {
                        this.costagency.locator.Prepaid.LocatorMinCostMonth = this.LocatorMinCostMonth;
                    }else if (typevalue == 'LocatorLeadsPerday') {
                        this.costagency.locator.Prepaid.LocatorLeadsPerday = this.LocatorLeadsPerday;
                    }
                }

            }else if (type == 'locatorlead') {
                if (typevalue == 'FirstName_LastName') {
                    this.costagency.locatorlead.FirstName_LastName = this.lead_FirstName_LastName;
                }else if (typevalue == 'FirstName_LastName_MailingAddress') {
                    this.costagency.locatorlead.FirstName_LastName_MailingAddress = this.lead_FirstName_LastName_MailingAddress;
                }else if (typevalue == 'FirstName_LastName_MailingAddress_Phone') {
                    this.costagency.locatorlead.FirstName_LastName_MailingAddress_Phone = this.lead_FirstName_LastName_MailingAddress_Phone;
                    this.costagency.locator.Weekly.LocatorCostperlead = this.lead_FirstName_LastName_MailingAddress_Phone;
                    this.costagency.locator.Monthly.LocatorCostperlead = this.lead_FirstName_LastName_MailingAddress_Phone;
                    this.costagency.locator.OneTime.LocatorCostperlead = this.lead_FirstName_LastName_MailingAddress_Phone;
                    this.costagency.locator.Prepaid.LocatorCostperlead = this.lead_FirstName_LastName_MailingAddress_Phone;
                }
            }else if (type == 'enhance') {

                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    if (typevalue == 'EnhancePlatformFee') {
                        this.costagency.enhance.Weekly.EnhancePlatformFee = this.EnhancePlatformFee;
                    }else if (typevalue == 'EnhanceCostperlead') {
                        this.costagency.enhance.Weekly.EnhanceCostperlead = this.EnhanceCostperlead;
                    }else if (typevalue == 'EnhanceMinCostMonth') {
                        this.costagency.enhance.Weekly.EnhanceMinCostMonth = this.EnhanceMinCostMonth;
                    }else if (typevalue == 'EnhanceLeadsPerday') {
                        if(Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.enhance.Weekly.EnhanceLeadsPerday = this.EnhanceLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    if (typevalue == 'EnhancePlatformFee') {
                        this.costagency.enhance.Monthly.EnhancePlatformFee = this.EnhancePlatformFee;
                    }else if (typevalue == 'EnhanceCostperlead') {
                        this.costagency.enhance.Monthly.EnhanceCostperlead = this.EnhanceCostperlead;
                    }else if (typevalue == 'EnhanceMinCostMonth') {
                        this.costagency.enhance.Monthly.EnhanceMinCostMonth = this.EnhanceMinCostMonth;
                    }else if (typevalue == 'EnhanceLeadsPerday') {
                        if(Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.enhance.Monthly.EnhanceLeadsPerday = this.EnhanceLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    if (typevalue == 'EnhancePlatformFee') {
                        this.costagency.enhance.OneTime.EnhancePlatformFee = this.EnhancePlatformFee;
                    }else if (typevalue == 'EnhanceCostperlead') {
                        this.costagency.enhance.OneTime.EnhanceCostperlead = this.EnhanceCostperlead;
                    }else if (typevalue == 'EnhanceMinCostMonth') {
                        this.costagency.enhance.OneTime.EnhanceMinCostMonth = this.EnhanceMinCostMonth;
                    }else if (typevalue == 'EnhanceLeadsPerday') {
                        if(Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.enhance.OneTime.EnhanceLeadsPerday = this.EnhanceLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    if (typevalue == 'EnhancePlatformFee') {
                        this.costagency.enhance.Prepaid.EnhancePlatformFee = this.EnhancePlatformFee;
                    }else if (typevalue == 'EnhanceCostperlead') {
                        this.costagency.enhance.Prepaid.EnhanceCostperlead = this.EnhanceCostperlead;
                    }else if (typevalue == 'EnhanceMinCostMonth') {
                        this.costagency.enhance.Prepaid.EnhanceMinCostMonth = this.EnhanceMinCostMonth;
                    }else if (typevalue == 'EnhanceLeadsPerday') {
                        if(Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.enhance.Prepaid.EnhanceLeadsPerday = this.EnhanceLeadsPerday;
                    }
                }

            }else if (type == 'b2b') {

                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    if (typevalue == 'B2bPlatformFee') {
                        this.costagency.b2b.Weekly.B2bPlatformFee = this.B2bPlatformFee;
                    }else if (typevalue == 'B2bCostperlead') {
                        this.costagency.b2b.Weekly.B2bCostperlead = this.B2bCostperlead;
                    }else if (typevalue == 'B2bMinCostMonth') {
                        this.costagency.b2b.Weekly.B2bMinCostMonth = this.B2bMinCostMonth;
                    }else if (typevalue == 'B2bLeadsPerday') {
                        if(Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.b2b.Weekly.B2bLeadsPerday = this.B2bLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    if (typevalue == 'B2bPlatformFee') {
                        this.costagency.b2b.Monthly.B2bPlatformFee = this.B2bPlatformFee;
                    }else if (typevalue == 'B2bCostperlead') {
                        this.costagency.b2b.Monthly.B2bCostperlead = this.B2bCostperlead;
                    }else if (typevalue == 'B2bMinCostMonth') {
                        this.costagency.b2b.Monthly.B2bMinCostMonth = this.B2bMinCostMonth;
                    }else if (typevalue == 'B2bLeadsPerday') {
                        if(Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.b2b.Monthly.B2bLeadsPerday = this.B2bLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    if (typevalue == 'B2bPlatformFee') {
                        this.costagency.b2b.OneTime.B2bPlatformFee = this.B2bPlatformFee;
                    }else if (typevalue == 'B2bCostperlead') {
                        this.costagency.b2b.OneTime.B2bCostperlead = this.B2bCostperlead;
                    }else if (typevalue == 'B2bMinCostMonth') {
                        this.costagency.b2b.OneTime.B2bMinCostMonth = this.B2bMinCostMonth;
                    }else if (typevalue == 'B2bLeadsPerday') {
                        if(Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.b2b.OneTime.B2bLeadsPerday = this.B2bLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    if (typevalue == 'B2bPlatformFee') {
                        this.costagency.b2b.Prepaid.B2bPlatformFee = this.B2bPlatformFee;
                    }else if (typevalue == 'B2bCostperlead') {
                        this.costagency.b2b.Prepaid.B2bCostperlead = this.B2bCostperlead;
                    }else if (typevalue == 'B2bMinCostMonth') {
                        this.costagency.b2b.Prepaid.B2bMinCostMonth = this.B2bMinCostMonth;
                    }else if (typevalue == 'B2bLeadsPerday') {
                        if(Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.b2b.Prepaid.B2bLeadsPerday = this.B2bLeadsPerday;
                    }
                }

            }else if (type == 'simplifi') {
                if (typevalue == 'SimplifiMaxBid') {
                    this.costagency.simplifi.Prepaid.SimplifiMaxBid = this.SimplifiMaxBid;
                    this.validateMinimumInput('keyup', 'maxBid');
                } else if (typevalue == 'SimplifiDailyBudget') {
                    this.costagency.simplifi.Prepaid.SimplifiDailyBudget = this.SimplifiDailyBudget;
                    this.validateMinimumInput('keyup', 'dailyBudget');
                } else if (typevalue == 'SimplifiAgencyMarkup') {
                    this.costagency.simplifi.Prepaid.SimplifiAgencyMarkup = this.SimplifiAgencyMarkup;
                }
            }
        
        },
        paymentTermStatus() {
            if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                this.txtLeadService = 'weekly';
                this.txtLeadIncluded = 'in that weekly charge';
                this.txtLeadOver ='from the weekly charge';

                /** SET VALUE */
                this.LeadspeekPlatformFee = this.costagency.local.Weekly.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.Weekly.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.Weekly.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.Weekly.LeadspeekLeadsPerday;

                this.LocatorPlatformFee  = this.costagency.locator.Weekly.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.Weekly.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.Weekly.LocatorMinCostMonth;
                this.LocatorLeadsPerday = this.costagency.locator.Weekly.LocatorLeadsPerday;

                this.EnhancePlatformFee  = this.costagency.enhance.Weekly.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.Weekly.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.Weekly.EnhanceMinCostMonth;
                this.EnhanceLeadsPerday = this.costagency.enhance.Weekly.EnhanceLeadsPerday;
                
                this.B2bPlatformFee  = this.costagency.b2b.Weekly.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.Weekly.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.Weekly.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.Weekly.B2bLeadsPerday;

                this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekCostperlead:0;
                this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekCostperleadAdvanced:0;
                this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorCostperlead:0;
                this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhanceCostperlead:0;
                this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bCostperlead:0;

                this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekPlatformFee:0;
                this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekMinCostMonth:0;
                this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorPlatformFee:0;
                this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorMinCostMonth:0;
                this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhancePlatformFee:0;
                this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhanceMinCostMonth:0;
                this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bPlatformFee:0;
                this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bMinCostMonth:0;
                /** SET VALUE */
            }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                this.txtLeadService = 'monthly';
                this.txtLeadIncluded = 'in that monthly charge';
                this.txtLeadOver ='from the monthly charge';

                /** SET VALUE */
                this.LeadspeekPlatformFee = this.costagency.local.Monthly.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.Monthly.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.Monthly.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.Monthly.LeadspeekLeadsPerday;
                
                this.LocatorPlatformFee  = this.costagency.locator.Monthly.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.Monthly.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.Monthly.LocatorMinCostMonth;
                this.LocatorLeadsPerday = this.costagency.locator.Monthly.LocatorLeadsPerday;
                
                this.EnhancePlatformFee  = this.costagency.enhance.Monthly.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.Monthly.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.Monthly.EnhanceMinCostMonth;
                this.EnhanceLeadsPerday = this.costagency.enhance.Monthly.EnhanceLeadsPerday;

                this.B2bPlatformFee  = this.costagency.b2b.Monthly.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.Monthly.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.Monthly.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.Monthly.B2bLeadsPerday;

                this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekCostperlead:0;
                this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekCostperleadAdvanced:0;
                this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorCostperlead:0;
                this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhanceCostperlead:0;
                this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bCostperlead:0;

                this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekPlatformFee:0;
                this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekMinCostMonth:0;
                this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorPlatformFee:0;
                this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorMinCostMonth:0;
                this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhancePlatformFee:0;
                this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhanceMinCostMonth:0;
                this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bPlatformFee:0;
                this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bMinCostMonth:0;
                /** SET VALUE */
            }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                this.txtLeadService = '';
                this.txtLeadIncluded = '';
                this.txtLeadOver ='';

                /** SET VALUE */
                this.LeadspeekPlatformFee = this.costagency.local.OneTime.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.OneTime.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.OneTime.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.OneTime.LeadspeekLeadsPerday;
                
                this.LocatorPlatformFee  = this.costagency.locator.OneTime.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.OneTime.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.OneTime.LocatorMinCostMonth
                this.LocatorLeadsPerday = this.costagency.locator.OneTime.LocatorLeadsPerday;
                
                this.EnhancePlatformFee  = this.costagency.enhance.OneTime.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.OneTime.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.OneTime.EnhanceMinCostMonth
                this.EnhanceLeadsPerday = this.costagency.enhance.OneTime.EnhanceLeadsPerday;

                this.B2bPlatformFee  = this.costagency.b2b.OneTime.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.OneTime.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.OneTime.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.OneTime.B2bLeadsPerday;

                this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekCostperlead:0;
                this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekCostperleadAdvanced:0;
                this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorCostperlead:0;
                this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhanceCostperlead:0;
                this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bCostperlead:0;

                this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekPlatformFee:0;
                this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekMinCostMonth:0;
                this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorPlatformFee:0;
                this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorMinCostMonth:0;
                this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhancePlatformFee:0;
                this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhanceMinCostMonth:0;
                this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bPlatformFee:0;
                this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bMinCostMonth:0;
                /** SET VALUE */

            }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                this.txtLeadService = 'monthly';
                this.txtLeadIncluded = 'in that monthly charge';
                this.txtLeadOver ='from the monthly charge';

                if (typeof(this.costagency.local.Prepaid) == 'undefined') {
                    this.$set(this.costagency.local,'Prepaid',{
                    LeadspeekPlatformFee: '0',
                    LeadspeekCostperlead: '0',
                    LeadspeekCostperleadAdvanced: '0',
                    LeadspeekMinCostMonth: '0',
                    LeadspeekLeadsPerday: '50',
                    });
                }

                if (typeof(this.costagency.locator.Prepaid) == 'undefined') {
                    this.$set(this.costagency.locator,'Prepaid',{
                    LocatorPlatformFee: '0',
                    LocatorCostperlead: '0',
                    LocatorMinCostMonth: '0',
                    LocatorLeadsPerday: '10',
                    });
                }

                if (typeof(this.costagency.enhance.Prepaid) == 'undefined') {
                    this.$set(this.costagency.enhance,'Prepaid',{
                    EnhancePlatformFee: '0',
                    EnhanceCostperlead: '0',
                    EnhanceMinCostMonth: '0',
                    EnhanceLeadsPerday: '10',
                    });
                }

                if (typeof(this.costagency.b2b.Prepaid) == 'undefined') {
                    this.$set(this.costagency.b2b,'Prepaid',{
                    B2bPlatformFee: '0',
                    B2bCostperlead: '0',
                    B2bMinCostMonth: '0',
                    B2bLeadsPerday: '10',
                    });
                }
                
                /** SET VALUE */
                this.LeadspeekPlatformFee = this.costagency.local.Prepaid.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.Prepaid.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.Prepaid.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.Prepaid.LeadspeekLeadsPerday;
                
                this.LocatorPlatformFee  = this.costagency.locator.Prepaid.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.Prepaid.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.Prepaid.LocatorMinCostMonth
                this.LocatorLeadsPerday = this.costagency.locator.Prepaid.LocatorLeadsPerday;
                
                this.EnhancePlatformFee  = this.costagency.enhance.Prepaid.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.Prepaid.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.Prepaid.EnhanceMinCostMonth
                this.EnhanceLeadsPerday = this.costagency.enhance.Prepaid.EnhanceLeadsPerday;

                this.B2bPlatformFee  = this.costagency.b2b.Prepaid.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.Prepaid.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.Prepaid.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.Prepaid.B2bLeadsPerday;
                
                this.m_LeadspeekCostPerLead =  (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekCostperlead:0; 
                this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekCostperleadAdvanced:0;
                this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorCostperlead:0;
                this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhanceCostperlead:0;
                this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bCostperlead:0;

                this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekPlatformFee:0;
                this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekMinCostMonth:0;
                this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorPlatformFee:0;
                this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorMinCostMonth:0;
                this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhancePlatformFee:0;
                this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhanceMinCostMonth:0;
                this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bPlatformFee:0;
                this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bMinCostMonth:0;
                /** SET VALUE */

            }
            const updateLogs = {
                ...this.prevDefaultRetailPrice,
                setupFeeLocal: this.LeadspeekPlatformFee,
                campaignFeeLocal: this.LeadspeekMinCostMonth,
                costPerLeadLocal: this.LeadspeekCostperlead,
                costPerLeadAdvancedLocal: this.LeadspeekCostperleadAdvanced,
                leadPerDayLocal: this.LeadspeekLeadsPerday,

                setupFeeLocator: this.LocatorPlatformFee,
                campaignFeeLocator: this.LocatorMinCostMonth,
                costPerLeadLocator: this.LocatorCostperlead,
                leadPerDayLocator: this.LocatorLeadsPerday,

                setupFeeEnhance: this.EnhancePlatformFee,
                campaignFeeEnhance: this.EnhanceMinCostMonth,
                costPerLeadEnhance: this.EnhanceCostperlead,
                leadPerDayEnhance: this.EnhanceLeadsPerday,

                setupFeeB2B: this.B2bPlatformFee,
                campaignFeeB2B: this.B2bMinCostMonth,
                costPerLeadB2B: this.B2bCostperlead,
                leadPerDayB2B: this.B2bLeadsPerday,
            }
            this.$set(this, 'prevDefaultRetailPrice', updateLogs);

        },
        paymentTermChange() {
            this.paymentTermStatus();

            this.$store.dispatch('updateGeneralSetting', {
                companyID: this.activeClientCompanyID,
                actionType: 'paymenttermDefault',
                paymenttermDefault: this.selectsPaymentTerm.PaymentTermSelect,
            }).then(response => {
                if (response.result == "success") {
                    this.tableData[this.activeClientCompanyIndex].paymentterm_default = this.selectsPaymentTerm.PaymentTermSelect;
                    
                    this.$notify({
                        type: 'success',
                        message: 'Default Payment Term has been saved.',
                        icon: 'tim-icons icon-bell-55'
                    });  

                    //// for log users
                    let descriptionLogs = "";
                    const { billingFrequency} = this.prevDefaultRetailPrice;
                    
                    const updates = [
                        { label: "Billing Frequency", prev: billingFrequency, new: this.selectsPaymentTerm.PaymentTermSelect },
                    ];

                    updates.forEach(({ label, prev, new: newValue }) => {
                        if (prev !== newValue) {
                            descriptionLogs += `${label} : Update values from ${prev} to ${newValue} `;
                        } else {
                            descriptionLogs += `${label} : No changes, value remains ${prev}`;
                        }
                    });

                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action: "Billing Frequency Client Change",
                        target_id: this.activeClientID,
                    });

                    Object.assign(this.prevDefaultRetailPrice, {
                        billingFrequency: this.selectsPaymentTerm.PaymentTermSelect,
                    })

                    
                }
            },error => {
                        
            });

        },
        
        sortcolumn: function(a,b) {
            return a.value - b.value;
        },
        sortdate: function(a,b) {
            return new Date(b.created_at) - new Date(a.created_at);
        },
         sortnumber: function(a,b) {
             return a - b;
        },
        checkLeadsType() {
            if (this.selectsAppModule.LeadsLimitSelect == 'Max') {
                this.LeadspeekMaxDateVisible = true;
            }else{
                this.LeadspeekMaxDateVisible = false;
            }
        },
        checkLeadsPerDay(){
            const fields = [
                'LeadspeekLeadsPerday',
                'LocatorLeadsPerday',
                'EnhanceLeadsPerday',
                'B2bLeadsPerday'
            ]

            return fields.some(field => this[field] == '0' || this[field] == '')
        },
        save_default_price() {
            this.isLoadingClientFinancials = true
            const isValidationLeadsPerDay = this.checkLeadsPerDay();
            if(isValidationLeadsPerDay){
                this.$notify({
                    type: 'primary',
                    message: 'Please check each module: contacts per day must be at least 1',
                    icon: 'fas fa-exclamation-triangle'
                })
                
                return
            }

            this.$store.dispatch('updateGeneralSetting', {
                companyID: this.activeClientCompanyID,
                actionType: 'customsmtpmodule',
                comsetname: 'clientdefaultprice',
                comsetval: this.costagency,
            }).then(response => {
                if (response.result == "success") {
                    this.modals.pricesetup = false;
                    this.selectsAppModule.AppModuleSelect = 'LeadsPeek';
                    this.$notify({
                        type: 'success',
                        message: 'Default Prices has been saved.',
                        icon: 'tim-icons icon-bell-55'
                    });  

                    //// for log users
                    let descriptionLogs = "";
                    const {  
                            billingFrequency,
                            setupFeeLocal, 
                            campaignFeeLocal, 
                            costPerLeadLocal, 
                            costPerLeadAdvancedLocal, 
                            leadPerDayLocal,
                            setupFeeLocator, 
                            campaignFeeLocator, 
                            costPerLeadLocator, 
                            leadPerDayLocator,
                            setupFeeEnhance, 
                            campaignFeeEnhance, 
                            costPerLeadEnhance,
                            leadPerDayEnhance,
                            setupFeeB2B,
                            campaignFeeB2B,
                            costPerLeadB2B,
                            leadPerDayB2B,
                        } 
                        = this.prevDefaultRetailPrice;
                    
                    const updates = [
                        { label: "Billing Frequency", prev: billingFrequency, new: this.selectsPaymentTerm.PaymentTermSelect },
                        { label: "Local One Time Setup Fee", prev: setupFeeLocal, new: this.LeadspeekPlatformFee },
                        { label: "Local Campaign Fee", prev: campaignFeeLocal, new: this.LeadspeekMinCostMonth },
                        { label: "Local Basic Cost", prev: costPerLeadLocal, new: this.LeadspeekCostperlead },
                        { label: "Local Advanced Cost", prev: costPerLeadAdvancedLocal, new: this.LeadspeekCostperleadAdvanced },
                        { label: "Local Lead Per Day", prev: leadPerDayLocal, new: this.LeadspeekLeadsPerday },

                        { label: "Locator One Time Setup Fee", prev: setupFeeLocator, new: this.LocatorPlatformFee },
                        { label: "Locator Campaign Fee", prev: campaignFeeLocator, new: this.LocatorMinCostMonth },
                        { label: "Locator Basic Cost", prev: costPerLeadLocator, new: this.LocatorCostperlead },
                        { label: "Locator Lead Per Day", prev: leadPerDayLocator, new: this.LocatorLeadsPerday },

                        { label: "Enhance One Time Setup Fee", prev: setupFeeEnhance, new: this.EnhancePlatformFee },
                        { label: "Enhance Campaign Fee", prev: campaignFeeEnhance, new: this.EnhanceMinCostMonth },
                        { label: "Enhance Basic Cost", prev: costPerLeadEnhance, new: this.EnhanceCostperlead },
                        { label: "Enhance Lead Per Day", prev: leadPerDayEnhance, new: this.EnhanceLeadsPerday },

                        { label: "B2B One Time Setup Fee", prev: setupFeeB2B, new: this.B2bPlatformFee },
                        { label: "B2B Campaign Fee", prev: campaignFeeB2B, new: this.B2bMinCostMonth },
                        { label: "B2B Basic Cost", prev: costPerLeadB2B, new: this.B2bCostperlead },
                        { label: "B2B Lead Per Day", prev: leadPerDayB2B, new: this.B2bLeadsPerday },
                    ];

                    updates.forEach(({ label, prev, new: newValue }) => {
                        if (prev !== newValue) {
                            if ( prev == undefined && (label == "Local Lead Per Day" || label == "Locator Lead Per Day" || label == "Enhance Lead Per Day" || label == "B2B Lead Per Day") ) {
                                descriptionLogs += `${label} : First set values to ${newValue} | `;
                            } else {
                                descriptionLogs += `${label} : Update values from ${prev} to ${newValue} | `;
                            }
                        } else {
                            if (label == 'Billing Frequency') {
                                descriptionLogs += `${label} : No changes, value remains ${prev} | `;
                            }
                        }
                    });

                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action: "Update Campaign Pricing Client",
                        target_id: this.activeClientID,
                    })

                    this.GetClientList();
                    this.isLoadingClientFinancials = false
                }
            },error => {
                    this.isLoadingClientFinancials = false
            });
        },
        save_default_price_wizard() {
            this.isLoadingClientFinancials = true
            this.updateSaveNextButtonState({ disabled: true, loading: true });

            const isValidationLeadsPerDay = this.checkLeadsPerDay();
            if(isValidationLeadsPerDay){
                this.$notify({
                    type: 'primary',
                    message: 'Please check each module: contacts per day must be at least 1',
                    icon: 'fas fa-exclamation-triangle'
                })
                this.isLoadingClientFinancials = false
                this.updateSaveNextButtonState({ disabled: false, loading: false });
                return
            }

            this.$store.dispatch('updateGeneralSetting', {
                companyID: this.activeClientCompanyID,
                actionType: 'customsmtpmodule',
                comsetname: 'clientdefaultprice',
                comsetval: this.costagency,
            }).then(response => {
                if (response.result == "success") {
                    this.selectsAppModule.AppModuleSelect = 'LeadsPeek';
                    this.$notify({
                        type: 'success',
                        message: 'Default Prices has been saved.',
                        icon: 'tim-icons icon-bell-55'
                    });

                    this.$store.dispatch('onSaveUserLogs', {
                        desc: 'Financial setup completed in client creation wizard',
                        action: "Update Campaign Pricing Client",
                        target_id: this.activeClientID,
                    })

                    this.isLoadingClientFinancials = false
                    this.updateSaveNextButtonState({ disabled: false, loading: false });
                    // Move to next step in wizard
                    this.updateCreateClientStep()
                } else {
                    // Response not success - reset loading state
                    this.isLoadingClientFinancials = false
                    this.updateSaveNextButtonState({ disabled: false, loading: false });
                    this.$notify({
                        type: 'danger',
                        message: response.message || 'Failed to save default prices',
                        icon: 'fas fa-exclamation-triangle'
                    });
                }
            },error => {
                this.isLoadingClientFinancials = false
                this.updateSaveNextButtonState({ disabled: false, loading: false });
                this.$notify({
                    type: 'danger',
                    message: 'Failed to save default prices. Please try again.',
                    icon: 'fas fa-bug'
                });
            });
        },

        loadDefaultPricingForNewClient() {
            // For new clients in wizard: getGeneralSetting with agencydefaultprice 
            // automatically falls back to rootagencydefaultprice if agencydefaultprice doesn't exist
            // Payment term will be taken from response.dpay from getGeneralSetting
            this.$store.dispatch('getGeneralSetting', {
                companyID: this.companyID,
                settingname: 'agencydefaultprice',
                idSys: this.$global.idsys
            }).then(response => {
                if (response.data != '' && response.data) {
                    // Use agencydefaultprice (or rootagencydefaultprice if agencydefaultprice doesn't exist)
                    this.costagency = JSON.parse(JSON.stringify(response.data)); // Deep copy
                    // Use dpay from response (which contains paymentterm_default)
                    this.selectsPaymentTerm.PaymentTermSelect = response.dpay || 'Weekly';
                    this.paymentTermStatus();
                    this.loadPricingForPaymentTerm();
                } else {
                    // If no pricing found, set default payment term
                    this.selectsPaymentTerm.PaymentTermSelect = 'Weekly';
                    this.paymentTermStatus();
                }
            }).catch(error => {
                console.error('Error loading default pricing:', error);
                // Set default payment term on error
                this.selectsPaymentTerm.PaymentTermSelect = 'Weekly';
                this.paymentTermStatus();
            });
        },
        handleUseDefaultPricingChange() {
            // Update disabled field styles when useDefaultPricing changes
            this.$nextTick(() => {
                this.updateDisabledFieldStyles();
            });
            if (this.useDefaultPricing) {
                // Reload default pricing when checkbox is enabled
                this.loadDefaultPricingForNewClient();
            }
        },
        rowClicked(row) {
            // Open edit modal instead of expanding row
            this.openEditClientModal(row);
        },
        tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
                return 'clickable-rows ClientRow' + rowIndex;
        },
        ClearClientForm() {
            this.ClientCompanyName = '';
            this.ClientFullName = '';
            this.ClientEmail = '';
            this.ClientPhone = '';
            this.checkboxes.phoneenabled = false;
            this.selects.ghlv2SubAccount = '';
        },

        resetAddClientModal() {
            // Reset all form fields
            this.ClearClientForm();

            // Reset wizard state
            this.campaignCreateActiveStep = 0;
            this.createdClientData = null;
            this.wizardIntegrationValues = {};

            // Reset checkboxes
            this.disabledreceiveemail = false;
            this.disabledaddcampaign = false;
            this.seteditor = false;

            // Reset phone number
            this.clientPhoneNumber = {
                number: '',
                countryCode: 'US',
                countryCallingCode: '+1',
                isValid: false
            };

            // Reset phone errors
            this.phoneError = '';
            this.phoneRowError = '';

            // Reset button state
            this.saveNextButtonState = {
                disabled: false,
                loading: false,
                text: 'Save & Next'
            };

            // Reset use default pricing checkbox
            this.useDefaultPricing = true;

            // Reset integration states
            this.enabledconntector.agencyzoom = false;
            this.userApiKey.agencyzoom = [''];

            // Reset validation if form exists
            if (this.$refs.frmAddDownline) {
                this.$refs.frmAddDownline.reset();
            }
        },

        AddEditClient(id) {
            // Reset modal state before opening
            this.resetAddClientModal();
            
            this.modals.create = true
        },
        async CancelAddEditClient(id) {
            if(id == '') {
                // Check if there's any data entered
                const hasData = this.ClientFullName || 
                               this.ClientEmail || 
                               this.ClientCompanyName || 
                               this.clientPhoneNumber.number ||
                               this.campaignCreateActiveStep > 0 ||
                               (this.createdClientData && this.createdClientData.id);
                
                if (hasData) {
                    // Show warning confirmation (same style as edit product empty)
                    const confirm = await swal.fire({
                        title: "Are you sure?",
                        text: "All entered data will be lost. Do you want to cancel?",
                        showCancelButton: true,
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, cancel"
                    });

                    if (!confirm.isConfirmed) {
                        // User chose to continue, don't close modal
                        return;
                    }
                }
             
                // Close the modal and reset everything
                this.ClearClientForm();
                
                this.modals.create = false;
                this.campaignCreateActiveStep = 0;
                this.createdClientData = null;
                this.wizardIntegrationValues = {}; // Clear temporary storage
            }else{
                this.$refs.tableData.toggleRowExpansion(id);
                this.GetClientList(this.currSortBy,this.currOrderBy);
            }

        },
        updateDisabledFieldStyles() {
            // Add/remove 'disabled-field' class to campaign-cost-input form-groups based on disabled state
            // This provides fallback styling for browsers that don't support :has() selector
            const campaignCostInputs = document.querySelectorAll('.campaign-cost-input.form-group');
            campaignCostInputs.forEach(formGroup => {
                const input = formGroup.querySelector('.form-control, input[type="text"]');
                if (input && input.disabled) {
                    formGroup.classList.add('disabled-field');
                } else {
                    formGroup.classList.remove('disabled-field');
                }
            });
        },
        ResendInvitation(id) {
            if(id.id != '') {
                $('#btnResend' + id.id).attr('disabled',true);
                $('#btnResend' + id.id).html('Sending...');

                /** RESEND THE INVITATION */
                this.$store.dispatch('ResendInvitation', {
                    ClientID: id.id,
                }).then(response => {
                    //console.log(response[0]);
                    this.$refs.tableData.toggleRowExpansion(id);
                    $('#btnResend' + id.id).attr('disabled',false);
                    $('#btnResend' + id.id).html('Resend Invitation');

                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });

                },error => {
                    $('#btnResend' + id.id).attr('disabled',false);
                    $('#btnResend' + id.id).html('Resend Invitation');

                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    });
                });
                /** RESEND THE INVITATION */
            }
        },
        openEditClientModal(row) {
            // Open edit modal with client data
            this.editClientData = { ...row, newpassword: '' };

            // Convert checkbox values from 'T'/'F' string to boolean for base-checkbox component
            // base-checkbox expects boolean, not string
            this.editClientData.disabled_receive_email = row.disabled_receive_email == 'T';
            this.editClientData.disable_client_add_campaign = row.disable_client_add_campaign == 'T';
            this.editClientData.editor_spreadsheet = row.editor_spreadsheet == 'T';

            // Set phone number
            this.clientRowPhoneNumber = {
                number: row.phonenum || '',
                countryCode: row.phone_country_code || 'US',
                countryCallingCode: row.phone_country_calling_code || '+1'
            };

            // Set checkbox states
            this.rowCheckboxes.phoneenabled = row.enabled_phone_number == 'T';

            // Set selected modules from row.selected_side_bar
            this.prevSelectedModules = row.selected_side_bar || [];

            let result = {};
            if (row.selected_side_bar != undefined && row.selected_side_bar != null) {
                row.selected_side_bar.forEach(item => {
                    result[item.type] = item.status;
                });
            }
            this.selectedModules = result;

            this.modals.edit = true;
        },
        cancelEditClient() {
            this.modals.edit = false;
            this.editClientData = null;
            this.GetClientList(this.currSortBy, this.currOrderBy);
        },
        async saveEditClient() {
            const isValid = await this.$refs.frmEditClient.validate();
            if (!isValid) {
                return false;
            }

            // Validate phone number
            if (this.clientRowPhoneNumber.number && !this.clientRowPhoneNumber.isValid) {
                this.phoneRowError = 'Please enter a valid phone number';
                this.$notify({
                    type: 'danger',
                    message: 'Please enter a valid phone number',
                    icon: 'fas fa-exclamation-triangle'
                });
                return false;
            }

            if (this.clientRowPhoneNumber.number && this.clientRowPhoneNumber.number.length > 20) {
                this.phoneRowError = 'Phone number cannot be more than 20 characters';
                this.$notify({
                    type: 'danger',
                    message: 'Phone number cannot be more than 20 characters',
                    icon: 'fas fa-exclamation-triangle'
                });
                return false;
            }

            const id = this.editClientData;

            if ((id.name != '' && id.email != '') && (typeof id.name != 'undefined' && typeof id.email != 'undefined')) {
                $('#btnSaveEdit').attr('disabled',true);
                $('#btnSaveEdit').html('Processing...');

                Object.entries(this.customsidebarleadmenu).forEach(([key, sidebar]) => {
                    if (!(key in this.selectedModules)) {
                        this.$set(this.selectedModules, key, false);
                    }
                });
                let selectedModulesArray = [];
                for (let key in this.selectedModules) {
                    selectedModulesArray.push({
                        type: key,
                        status: this.selectedModules[key]
                    });
                }

                const prevSelectedModules = this.prevSelectedModules
                const selectModules = selectedModulesArray
                const checkModuleChanges = this.checkModuleChanges(prevSelectedModules, selectModules)
                this.localActiveCampaignId = []
                this.locatorActiveCampaignId = []
                this.enhanceActiveCampaignId = []
                this.b2bActiveCampaignId = []
                this.simplifiActiveCampaignId = [];

                if(checkModuleChanges.length > 0){
                    const promises = checkModuleChanges.map(item => {
                        return this.$store.dispatch('checkCampaignActive', {
                            company_id: id.company_parent,
                            leadspeek_type: item.type,
                            user_type: 'client',
                            user_id: id.id
                        }).then((response) => {
                            if (item.type == 'local') {
                                this.localActiveCampaignId = response.active_campaign_id;
                            }

                            if (item.type == 'locator') {
                                this.locatorActiveCampaignId = response.active_campaign_id;
                            }

                            if (item.type == 'enhance') {
                                this.enhanceActiveCampaignId = response.active_campaign_id;
                            }

                            if (item.type == 'b2b') {
                                this.b2bActiveCampaignId = response.active_campaign_id;
                            }

                            if (item.type == 'simplifi') {
                                this.simplifiActiveCampaignId = response.active_campaign_id;
                            }

                        }, error => {
                            this.$notify({
                                type: 'primary',
                                message: 'Server might be busy please try again later',
                                icon: 'fas fa-bug'
                            });
                        }).catch(error => {
                            this.$notify({
                                type: 'primary',
                                message: 'Server might be busy please try again later',
                                icon: 'fas fa-bug'
                            });
                        });
                    });

                await Promise.all(promises);

                const htmlLocal = `<div style="font-weight: 600">${this.customsidebarleadmenu.local && this.customsidebarleadmenu.local.name} with campaign id : ${this.localActiveCampaignId.join(', ')}</div>`;
                const htmlLocator = `<div style="font-weight: 600">${this.customsidebarleadmenu.locator && this.customsidebarleadmenu.locator.name} with campaign id : ${this.locatorActiveCampaignId.join(', ')}</div>`;
                const htmlEnhance = `<div style="font-weight: 600">${this.customsidebarleadmenu.enhance && this.customsidebarleadmenu.enhance.name} with campaign id : ${this.enhanceActiveCampaignId.join(', ')}</div>`;
                const htmlB2b = `<div style="font-weight: 600">${this.customsidebarleadmenu.b2b && this.customsidebarleadmenu.b2b.name} with campaign id : ${this.b2bActiveCampaignId.join(', ')}</div>`;
                const htmlSimplifi = `<div style="font-weight: 600">${this.customsidebarleadmenu.simplifi && this.customsidebarleadmenu.simplifi.name} with campaign id : ${this.simplifiActiveCampaignId.join(', ')}</div>`;

                if (this.localActiveCampaignId.length > 0 ||
                    this.locatorActiveCampaignId.length > 0 ||
                    this.enhanceActiveCampaignId.length > 0 ||
                    this.b2bActiveCampaignId.length > 0 ||
                    this.simplifiActiveCampaignId.length > 0) {

                    swal.fire({
                        html: `<div style="display: flex; flex-direction: column;">
                                <div style="font-size: 100px; color: #f8bb86;">
                                    <i class="el-icon-warning"></i>
                                </div>
                                <div style="margin-bottom: 16px;">
                                    Unable to disable the product due to active campaigns. Please manually stop the campaigns before disabling the product.
                                </div>
                                ${this.localActiveCampaignId.length > 0 ? htmlLocal : ""}
                                ${this.locatorActiveCampaignId.length > 0 ? htmlLocator : ""}
                                ${this.enhanceActiveCampaignId.length > 0 ? htmlEnhance : ""}
                                ${this.b2bActiveCampaignId.length > 0 ? htmlB2b : ""}
                                ${this.simplifiActiveCampaignId.length > 0 ? htmlSimplifi : ""}
                            </div>`,
                        confirmButtonClass: 'btn btn-fill',
                        buttonsStyling: false
                    });

                    $('#btnSaveEdit').attr('disabled', false);
                    $('#btnSaveEdit').html('Save');
                    return;
                }
            }

            var _enablephonenumber = this.rowCheckboxes.phoneenabled ? 'T' : 'F';


           const isProductEmpty = selectedModulesArray.every(product => product.status === false);

         if (isProductEmpty) {
            const confirmEmpty = await swal.fire({
                title: "Are you sure?",
                text: "You haven't selected any products. Do you still want to continue updating this client?",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, continue",
            });

            if (!confirmEmpty.isConfirmed) {
                $('#btnSaveEdit').attr('disabled', false);
                $('#btnSaveEdit').html('Save');
                return;
            }
        }

        this.$store.dispatch('UpdateClient', {
            companyID: id.company_id,
            idsys: this.$global.idsys,
            ClientID: id.id,
            ClientCompanyName: id.company_name,
            ClientFullName: id.name,
            ClientEmail: id.email,
            ClientPhone: this.clientRowPhoneNumber.number,
            ClientPhoneCountryCode: this.clientRowPhoneNumber.countryCode,
            ClientPhoneCountryCallingCode: this.clientRowPhoneNumber.countryCallingCode,
            ClientDomain: id.domain,
            ClientPass: id.newpassword,
            disabledreceivedemail: id.disabled_receive_email ? 'T' : 'F',
            disabledaddcampaign: id.disable_client_add_campaign ? 'T' : 'F',
            editorspreadsheet: id.editor_spreadsheet ? 'T' : 'F',
            enablephonenumber: _enablephonenumber,
            selectedmodules: selectedModulesArray,
            action: 'client',
        }).then(response => {

            $('#btnSaveEdit').attr('disabled', false);
            $('#btnSaveEdit').html('Save');
            id.newpassword = '';

            this.onLogsUser(id.id, _enablephonenumber === 'T');
            this.GetClientList(this.currSortBy, this.currOrderBy);

            this.modals.edit = false;
            this.editClientData = null;

            this.$notify({
                type: 'success',
                message: 'Client has been updated successfully',
                icon: 'far fa-save'
            });

        }, error => {
            $('#btnSaveEdit').attr('disabled', false);
            $('#btnSaveEdit').html('Save');

            if (error.status === 422) {
                this.$notify({
                    type: 'primary',
                    message: error.data.message,
                    icon: 'fas fa-bug'
                });
                return;
            }

            this.$notify({
                type: 'primary',
                message: 'Server might be busy, please try again later',
                icon: 'fas fa-bug'
            });
            });    /** UPDATE CLIENT */
        }
        },
        resendInvitationEdit() {
            if(this.editClientData && this.editClientData.id != '') {
                $('#btnResendEdit').attr('disabled',true);
                $('#btnResendEdit').html('Sending...');

                /** RESEND THE INVITATION */
                this.$store.dispatch('ResendInvitation', {
                    ClientID: this.editClientData.id,
                }).then(response => {
                    $('#btnResendEdit').attr('disabled',false);
                    $('#btnResendEdit').html('Resend Invitation');

                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });

                },error => {
                    $('#btnResendEdit').attr('disabled',false);
                    $('#btnResendEdit').html('Resend Invitation');

                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    });
                });
                /** RESEND THE INVITATION */
            }
        },
        handlePhoneCheckboxClick(checkbox){
            // Native checkbox with @click.prevent - value doesn't change until we explicitly set it
            const currentValue = this[checkbox].phoneenabled;
            // If currently enabled, user wants to disable - no confirmation needed
            if (currentValue === true) {
                this.$set(this[checkbox], 'phoneenabled', false);
                return;
            }
            
            // If currently disabled, user wants to enable - show confirmation first
            // Checkbox stays unchecked until user confirms
            swal.fire({
                  title: "<span style='font-size:21px;'>Phone numbers are provided without warranty or guarantee. The end-user is responsible for verifying the Do-Not-Call status of each number and ensuring compliance with all applicable laws. The end-user must obtain all necessary permissions before making calls or sending messages<span>",
                  text: '',
                  icon: '',
                  showCancelButton: true,
                  customClass: {
                  confirmButton: 'btn btn-fill mr-3',
                  cancelButton: 'btn btn-danger btn-fill'
                  },
                  confirmButtonText: "I Agree",
                  buttonsStyling: false
          }).then(result => {
            // Only update if user confirmed
            if (result.isConfirmed) {
                this.$set(this[checkbox], 'phoneenabled', true);
            }
            // If cancelled, do nothing - checkbox stays unchecked
          });
        },
        openPhoneConfirmationModal(checkbox, id){
            // Legacy method - kept for compatibility
            // Get current value and toggle it
            const currentValue = this[checkbox].phoneenabled;
            const newValue = !currentValue;
            this.handlePhoneCheckboxInput(checkbox, id, newValue);
        },

        onLogsUser(id, checkbox){
            let action = '';
            let desc = '';
            if(checkbox){
                action = 'enabled phone number on client management';
                desc = `Agreed with pop up information (enabled phone number) on client id ${id}`;
            } else {
                action = 'disabled phone number on client management';
                desc = `User disable phone number on client id ${id}`;
            }

            const userData = this.$store.getters.userData;
            // let data = {
            //     userID: userData.id,
            //     action,
            //     desc,
            //     userIP: this.$store.getters.userData.ip_login,
            // }
            // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
            // if(userViewMode){
            //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
            //     data.userID = userRoot.id;
            // }
            
            // this.userLogSaved({ data});
            this.$store.dispatch('onSaveUserLogs', {
                desc: desc,
                action: action,
                target_id: id,
            })
        },
        async ProcessAddEditClient(id) {
            const isValid = await this.$refs.frmAddDownline.validate();
            if (!isValid) {
                return false;
            }

            // Validate phone number
            if (this.clientPhoneNumber.number && !this.clientPhoneNumber.isValid) {
                this.phoneError = 'Please enter a valid phone number';
                this.$notify({
                    type: 'danger',
                    message: 'Please enter a valid phone number',
                    icon: 'fas fa-exclamation-triangle'
                });
                return false;
            }

            if (this.clientPhoneNumber.number && this.clientPhoneNumber.number.length > 20) {
                this.phoneError = 'Phone number cannot be more than 20 characters';
                this.$notify({
                    type: 'danger',
                    message: 'Phone number cannot be more than 20 characters',
                    icon: 'fas fa-exclamation-triangle'
                });
                return false;
            }

        // ADD CLIENT
          if (this.ClientFullName != '' && this.ClientEmail != '' && id == '') {

            /** PROCESS ADD / EDIT ORGANIZATION */
            if (id == '') {
                // Validate that at least one product is selected
                Object.entries(this.customsidebarleadmenu).forEach(([key, sidebar]) => {
                    if (!(key in this.selectedModulesCreate)) {
                        this.$set(this.selectedModulesCreate, key, false);
                    }
                });

                let selectedModulesCreateArray = [];
                for (let key in this.customsidebarleadmenu) {
                    // Only include visible products (those that pass validateBetaFeature)
                    if (this.validateBetaFeature(key) && (this.customsidebarleadmenu[key].url != 'simplifiid' || this.$global.idsys == this.$global.masteridsys)) {
                        selectedModulesCreateArray.push({
                            type: key,
                            status: this.selectedModulesCreate[key]
                        });
                    }
                }

                // Check if at least one product is selected
                const hasSelectedProduct = selectedModulesCreateArray.some(product => product.status === true);
                if (!hasSelectedProduct) {
                    this.$notify({
                        type: 'danger',
                        message: 'Please select at least one product before continuing.',
                        icon: 'fas fa-exclamation-triangle',
                        duration: 5000
                    });
                    this.updateSaveNextButtonState({ disabled: false, loading: false });
                    return false;
                }

                this.updateSaveNextButtonState({ disabled: true, loading: true });

                var _disabledreceivedemail = this.disabledreceiveemail ? 'T' : 'F';
                var _disabledaddcampaign = this.disabledaddcampaign ? 'T' : 'F';
                var _seteditor = this.seteditor ? 'T' : 'F';
                var _enablephonenumber = this.checkboxes.phoneenabled ? 'T' : 'F';

                // Regenerate selectedModulesCreateArray for saving (include all, not just visible)
                selectedModulesCreateArray = [];
                for (let key in this.selectedModulesCreate) {
                    selectedModulesCreateArray.push({
                        type: key,
                        status: this.selectedModulesCreate[key]
                    });
                }

                const regex = /^\s*$/;
                if (regex.test(this.ClientCompanyName)) {
                    this.$notify({
                        type: 'danger',
                        message: 'Client Name invalid',
                        icon: 'fas fa-exclamation'
                    });
                    this.updateSaveNextButtonState({ disabled: false, loading: false });
                    return;
                }

                if (regex.test(this.ClientFullName)) {
                    this.$notify({
                        type: 'danger',
                        message: 'Contact Name invalid',
                        icon: 'fas fa-exclamation'
                    });
                    this.updateSaveNextButtonState({ disabled: false, loading: false });
                    return;
                }

                if (!emailPattern.test(this.ClientEmail)) {
                    this.$notify({
                        type: 'danger',
                        message: `Email invalid`,
                        icon: 'fas fa-exclamation-circle'
                    });

                    this.updateSaveNextButtonState({ disabled: false, loading: false });
                    return;
                }

                // Name custom menu for client (GHL V2)
                let custom_menu_name = "";
                if (this.ghlV2AgencyConnected === true && this.selects.ghlv2SubAccount != '') {
                    try {
                        this.updateSaveNextButtonState({ disabled: false, loading: false });

                        const { value } = await MessageBox.prompt(
                            'Enter the text that you want to display as your single sign on custom menu link. (30 Characters Max)',
                            'Enter Your Custom Menu Link Text.',
                            {
                                confirmButtonText: 'OK',
                                cancelButtonText: 'Cancel',
                                inputPattern: /^$|^[a-zA-Z0-9\s]{1,30}$/,
                                inputErrorMessage: 'Only letters, numbers, and spaces, max 30 characters',
                                inputPlaceholder: '[Client-Name]',
                                inputValue: this.ClientCompanyName,
                                customClass: 'message-general-ghl'

                            })
                            custom_menu_name = value;
                            this.updateSaveNextButtonState({ disabled: true, loading: true });
                        } catch (err) {
                            this.updateSaveNextButtonState({ disabled: false, loading: false });
                            return;
                        }
                    }
                    // name custom menu for client

                    /** CREATE CLIENT */
                    this.$store.dispatch('CreateClient', {
                        companyID: this.companyID,
                        idsys: this.$global.idsys,
                        userType:'client',
                        ClientCompanyName: this.ClientCompanyName,
                        ClientFullName: this.ClientFullName,
                        ClientEmail: this.ClientEmail,
                        ClientPhone: this.clientPhoneNumber.number,
                        ClientPhoneCountryCode: this.clientPhoneNumber.countryCode,
                        ClientPhoneCountryCallingCode: this.clientPhoneNumber.countryCallingCode,
                        ClientDomain: this.ClientDomain,
                        disabledreceivedemail: _disabledreceivedemail,
                        disabledaddcampaign: _disabledaddcampaign,
                        editorspreadsheet: _seteditor,
                        enablephonenumber: _enablephonenumber,
                        selectedmodules: selectedModulesCreateArray,
                        location_id: this.selects.ghlv2SubAccount,
                        custom_menu_name: custom_menu_name,
                        ip_login: this.$store.getters.userData.ip_login,
                    }).then(response => {
                        //console.log(response);
                        if (response.result == 'success') {
                            this.tableData.push(response.data[0]);
                            this.initialSearchFuse();
                            this.onLogsUser(response.data[0].id, _enablephonenumber == 'T' ? true : false)

                            // Store the created client data for use in subsequent steps
                            this.createdClientData = response.data[0];

                            this.ClearClientForm();
                          
                            this.updateSaveNextButtonState({ disabled: false, loading: false });
                            this.GetClientList(this.currSortBy, this.currOrderBy);
                            this.ghlv2ResetListSubAccounts();
                            this.ghlv2GetListSubAccounts();

                            const isCreateIframeClientGHLV2 = typeof(response.isCreateIframeClientGHLV2) != 'undefined' ? response.isCreateIframeClientGHLV2 : false;
                            const isSuccessCreateIframeClientGHLV2 = typeof(response.isSuccessCreateIframeClientGHLV2) != 'undefined' ? response.isSuccessCreateIframeClientGHLV2 : false;

                            // Store iframe status for notification in step 3 if needed
                            this.createdClientIframeStatus = {
                                isCreateIframeClientGHLV2: isCreateIframeClientGHLV2,
                                isSuccessCreateIframeClientGHLV2: isSuccessCreateIframeClientGHLV2
                            };

                            // Show notification for step 0 (client creation)
                            let message = "Client has been added successfully";
                            if(isCreateIframeClientGHLV2 === true && isSuccessCreateIframeClientGHLV2 === false) {
                                message += ", But create iframe gohighlevel failed";
                            }
                            this.$notify({
                                type: 'success',
                                message: message,
                                icon: 'far fa-save'
                            });
                            
                            this.updateCreateClientStep()
                        }else{
                            this.updateSaveNextButtonState({ disabled: false, loading: false });

                            this.$notify({
                                type: 'primary',
                                message: response.message,
                                icon: 'fas fa-bug'
                            });
                        }
                    },error => {
                        this.updateSaveNextButtonState({ disabled: false, loading: false });

                        this.$notify({
                            type: 'primary',
                            message: 'Server might be busy please try again later',
                            icon: 'fas fa-bug'
                        });
                    });
                    /** CREATE CLIENT */
                }
                /** PROCESS ADD / EDIT ORGANIZATION */
            }else{
                var frmName = 'frmuser' + id.id;
                const isValid = await this.$refs[frmName].validate();

                if (!isValid) {
                    return false;
                }

                if ((id.name != '' && id.email != '') && (typeof id.name != 'undefined' && typeof id.email != 'undefined')) {
                    $('#btnSave' + id.id).attr('disabled',true);
                    $('#btnSave' + id.id).html('Processing...');

                    Object.entries(this.customsidebarleadmenu).forEach(([key, sidebar]) => {
                        if (!(key in this.selectedModules)) {
                            this.$set(this.selectedModules, key, false);
                        }
                    });
                    let selectedModulesArray = [];
                    for (let key in this.selectedModules) {
                        selectedModulesArray.push({
                            type: key,
                            status: this.selectedModules[key]
                        });
                    }

                    const prevSelectedModules = this.prevSelectedModules
                    const selectModules = selectedModulesArray
                    const checkModuleChanges = this.checkModuleChanges(prevSelectedModules, selectModules)
                    this.localActiveCampaignId = []
                    this.locatorActiveCampaignId = []
                    this.enhanceActiveCampaignId = []
                    this.b2bActiveCampaignId = []
                    this.simplifiActiveCampaignId = [];

                    if(checkModuleChanges.length > 0){
                        const promises = checkModuleChanges.map(item => {
                            return this.$store.dispatch('checkCampaignActive', {
                                company_id: id.company_parent,
                                leadspeek_type: item.type,
                                user_type: 'client',
                                user_id: id.id
                            }).then((response) => {
                                if (item.type == 'local') {
                                    this.localActiveCampaignId = response.active_campaign_id;
                                }

                                if (item.type == 'locator') {
                                    this.locatorActiveCampaignId = response.active_campaign_id;
                                }

                                if (item.type == 'enhance') {
                                    this.enhanceActiveCampaignId = response.active_campaign_id;
                                }

                                if (item.type == 'b2b') {
                                    this.b2bActiveCampaignId = response.active_campaign_id;
                                }

                                if (item.type == 'simplifi') {
                                    this.simplifiActiveCampaignId = response.active_campaign_id;
                                }

                            }, error => {
                                this.$notify({
                                    type: 'primary',
                                    message: 'Server might be busy please try again later',
                                    icon: 'fas fa-bug'
                                });
                            }).catch(error => {
                                this.$notify({
                                    type: 'primary',
                                    message: 'Server might be busy please try again later',
                                    icon: 'fas fa-bug'
                                });
                            });
                        });

                    await Promise.all(promises);

                    const htmlLocal = `<div style="font-weight: 600">${this.customsidebarleadmenu.local && this.customsidebarleadmenu.local.name} with campaign id : ${this.localActiveCampaignId.join(', ')}</div>`;
                    const htmlLocator = `<div style="font-weight: 600">${this.customsidebarleadmenu.locator && this.customsidebarleadmenu.locator.name} with campaign id : ${this.locatorActiveCampaignId.join(', ')}</div>`;
                    const htmlEnhance = `<div style="font-weight: 600">${this.customsidebarleadmenu.enhance && this.customsidebarleadmenu.enhance.name} with campaign id : ${this.enhanceActiveCampaignId.join(', ')}</div>`;
                    const htmlB2b = `<div style="font-weight: 600">${this.customsidebarleadmenu.b2b && this.customsidebarleadmenu.b2b.name} with campaign id : ${this.b2bActiveCampaignId.join(', ')}</div>`;
                    const htmlSimplifi = `<div style="font-weight: 600">${this.customsidebarleadmenu.simplifi && this.customsidebarleadmenu.simplifi.name} with campaign id : ${this.simplifiActiveCampaignId.join(', ')}</div>`;

                    if (this.localActiveCampaignId.length > 0 ||
                        this.locatorActiveCampaignId.length > 0 ||
                        this.enhanceActiveCampaignId.length > 0 ||
                        this.b2bActiveCampaignId.length > 0 ||
                        this.simplifiActiveCampaignId.length > 0) {

                        swal.fire({
                            html: `<div style="display: flex; flex-direction: column;">
                                    <div style="font-size: 100px; color: #f8bb86;">
                                        <i class="el-icon-warning"></i>
                                    </div>
                                    <div style="margin-bottom: 16px;">
                                        Unable to disable the product due to active campaigns. Please manually stop the campaigns before disabling the product.
                                    </div>
                                    ${this.localActiveCampaignId.length > 0 ? htmlLocal : ""}
                                    ${this.locatorActiveCampaignId.length > 0 ? htmlLocator : ""}
                                    ${this.enhanceActiveCampaignId.length > 0 ? htmlEnhance : ""}
                                    ${this.b2bActiveCampaignId.length > 0 ? htmlB2b : ""}
                                    ${this.simplifiActiveCampaignId.length > 0 ? htmlSimplifi : ""}
                                </div>`,
                            confirmButtonClass: 'btn btn-fill',
                            buttonsStyling: false
                        });

                        $('#btnSave' + id.id).attr('disabled', false);
                        $('#btnSave' + id.id).html('Save');
                        return;
                    }
                }

                var _enablephonenumber = this.rowCheckboxes.phoneenabled ? 'T' : 'F';


               const isProductEmpty = selectedModulesArray.every(product => product.status === false);

             if (isProductEmpty) {
                const confirmEmpty = await swal.fire({
                    title: "Are you sure?",
                    text: "You haven't selected any products. Do you still want to continue updating this client?",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, continue",
                });

                if (!confirmEmpty.isConfirmed) {
                    $('#btnSave' + id.id).attr('disabled', false);
                    $('#btnSave' + id.id).html('Save');
                    return;
                }
            }

            this.$store.dispatch('UpdateClient', {
                companyID: id.company_id,
                idsys: this.$global.idsys,
                ClientID: id.id,
                ClientCompanyName: id.company_name,
                ClientFullName: id.name,
                ClientEmail: id.email,
                ClientPhone: this.clientRowPhoneNumber.number,
                ClientPhoneCountryCode: this.clientRowPhoneNumber.countryCode,
                ClientPhoneCountryCallingCode: this.clientRowPhoneNumber.countryCallingCode,
                ClientDomain: id.domain,
                ClientPass: id.newpassword,
                disabledreceivedemail: id.disabled_receive_email ? 'T' : 'F',
                disabledaddcampaign: id.disable_client_add_campaign ? 'T' : 'F',
                editorspreadsheet: id.editor_spreadsheet ? 'T' : 'F',
                enablephonenumber: _enablephonenumber,
                selectedmodules: selectedModulesArray,
                action: 'client',
            }).then(response => {

                this.$refs.tableData.toggleRowExpansion(id);
                $('#btnSave' + id.id).attr('disabled', false);
                $('#btnSave' + id.id).html('Save');
                id.newpassword = '';

                this.onLogsUser(id.id, _enablephonenumber === 'T');
                this.GetClientList(this.currSortBy, this.currOrderBy);

                this.$notify({
                    type: 'success',
                    message: 'Client has been updated successfully',
                    icon: 'far fa-save'
                });

            }, error => {
                $('#btnSave' + id.id).attr('disabled', false);
                $('#btnSave' + id.id).html('Save');

                if (error.status === 422) {
                    this.$notify({
                        type: 'primary',
                        message: error.data.message,
                        icon: 'fas fa-bug'
                    });
                    return;
                }

                this.$notify({
                    type: 'primary',
                    message: 'Server might be busy, please try again later',
                    icon: 'fas fa-bug'
                });
                });    /** UPDATE CLIENT */
            }
            }
        },
        sortdynamic(column,prop,order) { 
            this.currSortBy = column.prop;
            this.currOrderBy = column.order;
            this.GetClientList(column.prop,column.order);
        },
        searchKeyWord() {
            this.pagination.currentPage = 1;
            this.GetClientList(this.currSortBy,this.currOrderBy);
        },
        async GetClientList(sortby,order) {
            var _sortby = '';
            var _order = '';
            var _searchkey = '';

            if (typeof(sortby) != 'undefined') {
                _sortby = sortby;
            }
            if (typeof(order) != 'undefined') {
                _order = order;
            }

            if (this.searchQuery != '') {
                _searchkey = this.searchQuery;
            }
           
            /** GET CLIENT LIST */
            this.tableData = [];
            $('.el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');
            await this.$store.dispatch('GetClientList', {
                companyID: this.companyID,
                idsys: this.$global.idsys,
                userType:'client',
                sortby: _sortby,
                order: _order,
                searchkey: _searchkey,
                page:this.pagination.currentPage,
                cardStatus: this.filters.cardStatus,
                campaignStatus: this.filters.campaignStatus,
            }).then(response => {
                this.pagination.currentPage = response.current_page? response.current_page : 1
                this.pagination.total = response.total ?response.total : 0
                this.pagination.lastPage = response.last_page ? response.last_page : 0
                this.pagination.from = response.from ? response.from : 0
                this.pagination.to = response.to ? response.to : 0
                
                if (response.data.length == 0) {
                    $('.el-table__empty-text').html('No Data');
                }
                
                for(let i=0;i<response.data.length;i++) {
                    if (response.data[i].phonenum == '') {
                        response.data[i].phonenum = '000-000-0000';
                    }
                }
                this.tableData = response.data
                this.initialSearchFuse()
                if (response.data.length == 0) {
                    $('.el-table__empty-text').html('No Data');
                }
            },error => {
                
            });
            /** GET CLIENT LIST */
        },

        initialSearchFuse() {
            // Fuse search initialization.
            // this.fuseSearch = new Fuse(this.tableData, {
            //     keys: ['company_name','name','email','phonenum','created_at'],
            //     threshold: 0.1
            // });
        },

        handleLike(index, row) {
            swal.fire({
                title: `You liked ${row.name}`,
                buttonsStyling: false,
                icon: 'success',
                customClass: {
                confirmButton: 'btn btn-success btn-fill'
                }
            });
        },
        handleCardSet(index,row) {
            this.cleanCCform();
            this.ClientActiveID = row.id;
            this.LeadspeekCompany = row.company_name;
            this.selectedClientPaymentStatus = row.payment_status;
            this.clientPaymentFailed = false;
            if (row.payment_status == 'failed' && row.failed_campaignid != '' && row.failed_campaignid !== null) {
                this.clientPaymentFailed = true;
                this.failedCampaignNumber = row.failed_campaignid.split('|');
                this.failedInvoiceAmount = row.failed_total_amount.split('|');
            }
            this.termhost = row.company_id;
            this.getCardInfo(row.id);
        },
        resetClientCost() {
            this.selectsAppModule.AppModuleSelect = 'LeadsPeek';
            this.LeadspeekPlatformFee = '0';
            this.LeadspeekCostperlead = '0';
            this.LeadspeekCostperleadAdvanced = '0';
            this.LeadspeekMinCostMonth = '0';

            this.LocatorPlatformFee = '0';
            this.LocatorCostperlead = '0';
            this.LocatorMinCostMonth = '0';
            
            this.EnhancePlatformFee = '0';
            this.EnhanceCostperlead = '0';
            this.EnhanceMinCostMonth = '0';
            
            this.lead_FirstName_LastName = '0';
            this.lead_FirstName_LastName_MailingAddress = '0';
            this.lead_FirstName_LastName_MailingAddress_Phone = '0';

            this.costagency.local.Weekly.LeadspeekPlatformFee = '0';
            this.costagency.local.Weekly.LeadspeekCostperlead = '0';
            this.costagency.local.Weekly.LeadspeekCostperleadAdvanced = '0';
            this.costagency.local.Weekly.LeadspeekMinCostMonth = '0';
            this.costagency.local.Weekly.LeadspeekLeadsPerday = '0';

            this.costagency.local.Monthly.LeadspeekPlatformFee = '0';
            this.costagency.local.Monthly.LeadspeekCostperlead = '0';
            this.costagency.local.Monthly.LeadspeekMinCostMonth = '0';
            this.costagency.local.Monthly.LeadspeekLeadsPerday = '0';

            this.costagency.local.OneTime.LeadspeekPlatformFee = '0';
            this.costagency.local.OneTime.LeadspeekCostperlead = '0';
            this.costagency.local.OneTime.LeadspeekMinCostMonth = '0';
            this.costagency.local.OneTime.LeadspeekLeadsPerday = '0';

            this.costagency.locator.Weekly.LocatorPlatformFee = '0';
            this.costagency.locator.Weekly.LocatorCostperlead = '0';
            this.costagency.locator.Weekly.LocatorMinCostMonth = '0';
            this.costagency.locator.Weekly.LeadspeekLeadsPerday = '0';

            this.costagency.locator.Monthly.LocatorPlatformFee = '0';
            this.costagency.locator.Monthly.LocatorCostperlead = '0';
            this.costagency.locator.Monthly.LocatorMinCostMonth = '0';
            this.costagency.locator.Monthly.LeadspeekLeadsPerday = '0';

            this.costagency.locator.OneTime.LocatorPlatformFee = '0';
            this.costagency.locator.OneTime.LocatorCostperlead = '0';
            this.costagency.locator.OneTime.LocatorMinCostMonth = '0';
            this.costagency.locator.OneTime.LeadspeekLeadsPerday = '0';

            this.costagency.enhance.Weekly.enhancePlatformFee = '0';
            this.costagency.enhance.Weekly.enhanceCostperlead = '0';
            this.costagency.enhance.Weekly.enhanceMinCostMonth = '0';
            this.costagency.enhance.Weekly.LeadspeekLeadsPerday = '0';

            this.costagency.enhance.Monthly.enhancePlatformFee = '0';
            this.costagency.enhance.Monthly.enhanceCostperlead = '0';
            this.costagency.enhance.Monthly.enhanceMinCostMonth = '0';
            this.costagency.enhance.Monthly.LeadspeekLeadsPerday = '0';

            this.costagency.enhance.OneTime.enhancePlatformFee = '0';
            this.costagency.enhance.OneTime.enhanceCostperlead = '0';
            this.costagency.enhance.OneTime.enhanceMinCostMonth = '0';
            this.costagency.enhance.OneTime.LeadspeekLeadsPerday = '0';

            this.costagency.locatorlead.FirstName_LastName = '0';
            this.costagency.locatorlead.FirstName_LastName_MailingAddress = '0';
            this.costagency.locatorlead.FirstName_LastName_MailingAddress_Phone = '0';
        },
        handlePriceSet(index, row) {
            //console.log(row);
            this.initial_default_price();
            this.activeClientCompanyID = row.company_id; 
            this.activeClientCompanyIndex = index;
            this.activeClientID = row.id;
            this.LeadspeekCompany = row.company_name;
            this.resetClientCost();
            this.$store.dispatch('getGeneralSetting', {
                companyID: row.company_id,
                settingname: 'clientdefaultprice',
                idSys: this.$global.idsys
            }).then(response => {
                //console.log(response);
                if (response.data != '') {
                    this.costagency = response.data;
                    this.clientMinLeadDayEnhance = response.clientMinLeadDayEnhance;
                    // this.selectsPaymentTerm.PaymentTermSelect = row.paymentterm_default;
                    this.selectsPaymentTerm.PaymentTermSelect = this.tableData[this.activeClientCompanyIndex].paymentterm_default;
                    this.paymentTermStatus();

                    if(this.clientMinLeadDayEnhance != '') {
                        if(Number(this.costagency.enhance.Weekly.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.enhance.Weekly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.enhance.Monthly.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.enhance.Monthly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.enhance.OneTime.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.enhance.OneTime.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.enhance.Prepaid.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.enhance.Prepaid.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                        }

                        if(Number(this.costagency.b2b.Weekly.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.b2b.Weekly.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.b2b.Monthly.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.b2b.Monthly.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.b2b.OneTime.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.b2b.OneTime.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.b2b.Prepaid.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.b2b.Prepaid.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                    }


                    //this.selectsPaymentTerm.PaymentTermSelect = 'Weekly';
                    if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                        this.LeadspeekPlatformFee = this.costagency.local.Weekly.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperlead;
                        this.LeadspeekCostperleadAdvanced = this.costagency.local.Weekly.LeadspeekCostperleadAdvanced;
                        this.LeadspeekMinCostMonth = this.costagency.local.Weekly.LeadspeekMinCostMonth;
                        this.LeadspeekLeadsPerday = this.costagency.local.Weekly.LeadspeekLeadsPerday;

                        this.LocatorPlatformFee  = this.costagency.locator.Weekly.LocatorPlatformFee;
                        this.LocatorCostperlead = this.costagency.locator.Weekly.LocatorCostperlead;
                        this.LocatorMinCostMonth = this.costagency.locator.Weekly.LocatorMinCostMonth;
                        this.LocatorLeadsPerday = this.costagency.locator.Weekly.LocatorLeadsPerday;
                        
                        this.EnhancePlatformFee  = this.costagency.enhance.Weekly.EnhancePlatformFee;
                        this.EnhanceCostperlead = this.costagency.enhance.Weekly.EnhanceCostperlead;
                        this.EnhanceMinCostMonth = this.costagency.enhance.Weekly.EnhanceMinCostMonth;
                        this.EnhanceLeadsPerday = this.costagency.enhance.Weekly.EnhanceLeadsPerday;
                        
                        this.B2bPlatformFee  = this.costagency.b2b.Weekly.B2bPlatformFee;
                        this.B2bCostperlead = this.costagency.b2b.Weekly.B2bCostperlead;
                        this.B2bMinCostMonth = this.costagency.b2b.Weekly.B2bMinCostMonth;
                        this.B2bLeadsPerday = this.costagency.b2b.Weekly.B2bLeadsPerday;

                        /* ENABLE MINIMUM LEAD PER DAY */
                        // this.LeadspeekEnableMinimumLeadsPerDay = typeof(this.costagency.local.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.local.EnableMinimumLeadsPerday : false;
                        // this.LocatorEnableMinimumLeadsPerDay = typeof(this.costagency.locator.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.locator.EnableMinimumLeadsPerday : false;
                        // this.EnhanceEnableMinimumLeadsPerDay = typeof(this.costagency.enhance.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.enhance.EnableMinimumLeadsPerday : false;
                        // this.B2bEnableMinimumLeadsPerDay = typeof(this.costagency.b2b.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.b2b.EnableMinimumLeadsPerday : false;
                        this.LeadspeekEnableMinimumLeadsPerDay = false;
                        this.LocatorEnableMinimumLeadsPerDay = false;
                        this.EnhanceEnableMinimumLeadsPerDay = false;
                        this.B2bEnableMinimumLeadsPerDay = false;
                        /* ENABLE MINIMUM LEAD PER DAY */
                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                        this.LeadspeekPlatformFee = this.costagency.local.Monthly.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperlead;
                        this.LeadspeekCostperleadAdvanced = this.costagency.local.Monthly.LeadspeekCostperleadAdvanced;
                        this.LeadspeekMinCostMonth = this.costagency.local.Monthly.LeadspeekMinCostMonth;
                        this.LeadspeekLeadsPerday = this.costagency.local.Monthly.LeadspeekLeadsPerday;

                        this.LocatorPlatformFee  = this.costagency.locator.Monthly.LocatorPlatformFee;
                        this.LocatorCostperlead = this.costagency.locator.Monthly.LocatorCostperlead;
                        this.LocatorMinCostMonth = this.costagency.locator.Monthly.LocatorMinCostMonth;
                        this.LocatorLeadsPerday = this.costagency.locator.Monthly.LocatorLeadsPerday;

                        this.EnhancePlatformFee  = this.costagency.enhance.Monthly.EnhancePlatformFee;
                        this.EnhanceCostperlead = this.costagency.enhance.Monthly.EnhanceCostperlead;
                        this.EnhanceMinCostMonth = this.costagency.enhance.Monthly.EnhanceMinCostMonth;
                        this.EnhanceLeadsPerday = this.costagency.enhance.Monthly.EnhanceLeadsPerday;

                        this.B2bPlatformFee  = this.costagency.b2b.Monthly.B2bPlatformFee;
                        this.B2bCostperlead = this.costagency.b2b.Monthly.B2bCostperlead;
                        this.B2bMinCostMonth = this.costagency.b2b.Monthly.B2bMinCostMonth;
                        this.B2bLeadsPerday = this.costagency.b2b.Monthly.B2bLeadsPerday;

                        /* ENABLE MINIMUM LEAD PER DAY */
                        // this.LeadspeekEnableMinimumLeadsPerDay = typeof(this.costagency.local.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.local.EnableMinimumLeadsPerday : false;
                        // this.LocatorEnableMinimumLeadsPerDay = typeof(this.costagency.locator.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.locator.EnableMinimumLeadsPerday : false;
                        // this.EnhanceEnableMinimumLeadsPerDay = typeof(this.costagency.enhance.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.enhance.EnableMinimumLeadsPerday : false;
                        // this.B2bEnableMinimumLeadsPerDay = typeof(this.costagency.b2b.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.b2b.EnableMinimumLeadsPerday : false;
                        this.LeadspeekEnableMinimumLeadsPerDay = false;
                        this.LocatorEnableMinimumLeadsPerDay = false;
                        this.EnhanceEnableMinimumLeadsPerDay = false;
                        this.B2bEnableMinimumLeadsPerDay = false;
                        /* ENABLE MINIMUM LEAD PER DAY */
                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                        this.LeadspeekPlatformFee = this.costagency.local.OneTime.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperlead;
                        this.LeadspeekCostperleadAdvanced = this.costagency.local.OneTime.LeadspeekCostperleadAdvanced;
                        this.LeadspeekMinCostMonth = this.costagency.local.OneTime.LeadspeekMinCostMonth;
                        this.LeadspeekLeadsPerday = this.costagency.local.OneTime.LeadspeekLeadsPerday;

                        this.LocatorPlatformFee  = this.costagency.locator.OneTime.LocatorPlatformFee;
                        this.LocatorCostperlead = this.costagency.locator.OneTime.LocatorCostperlead;
                        this.LocatorMinCostMonth = this.costagency.locator.OneTime.LocatorMinCostMonth;
                        this.LocatorLeadsPerday = this.costagency.locator.OneTime.LocatorLeadsPerday;
                        
                        this.EnhancePlatformFee  = this.costagency.enhance.OneTime.EnhancePlatformFee;
                        this.EnhanceCostperlead = this.costagency.enhance.OneTime.EnhanceCostperlead;
                        this.EnhanceMinCostMonth = this.costagency.enhance.OneTime.EnhanceMinCostMonth;
                        this.EnhanceLeadsPerday = this.costagency.enhance.OneTime.EnhanceLeadsPerday;

                        this.B2bPlatformFee  = this.costagency.b2b.OneTime.B2bPlatformFee;
                        this.B2bCostperlead = this.costagency.b2b.OneTime.B2bCostperlead;
                        this.B2bMinCostMonth = this.costagency.b2b.OneTime.B2bMinCostMonth;
                        this.B2bLeadsPerday = this.costagency.b2b.OneTime.B2bLeadsPerday;

                        /* ENABLE MINIMUM LEAD PER DAY */
                        // this.LeadspeekEnableMinimumLeadsPerDay = typeof(this.costagency.local.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.local.EnableMinimumLeadsPerday : false;
                        // this.LocatorEnableMinimumLeadsPerDay = typeof(this.costagency.locator.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.locator.EnableMinimumLeadsPerday : false;
                        // this.EnhanceEnableMinimumLeadsPerDay = typeof(this.costagency.enhance.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.enhance.EnableMinimumLeadsPerday : false;
                        // this.B2bEnableMinimumLeadsPerDay = typeof(this.costagency.b2b.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.b2b.EnableMinimumLeadsPerday : false;
                        this.LeadspeekEnableMinimumLeadsPerDay = false;
                        this.LocatorEnableMinimumLeadsPerDay = false;
                        this.EnhanceEnableMinimumLeadsPerDay = false;
                        this.B2bEnableMinimumLeadsPerDay = false;
                        /* ENABLE MINIMUM LEAD PER DAY */
                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {

                        this.LeadspeekPlatformFee = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekPlatformFee:0;
                        this.LeadspeekCostperlead = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekCostperlead:0;
                        this.LeadspeekCostperleadAdvanced = (typeof(this.costagency.local.Prepaid) != 'undefined')?this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced:0;
                        this.LeadspeekMinCostMonth = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekMinCostMonth:0;
                        this.LeadspeekLeadsPerday = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekLeadsPerday:10;

                        this.LocatorPlatformFee  = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorPlatformFee:0;
                        this.LocatorCostperlead = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorCostperlead:0;
                        this.LocatorMinCostMonth = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorMinCostMonth:0;
                        this.LocatorLeadsPerday = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorLeadsPerday:10;

                        this.EnhancePlatformFee  = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhancePlatformFee:0;
                        this.EnhanceCostperlead = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceCostperlead:0;
                        this.EnhanceMinCostMonth = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceMinCostMonth:0;
                        this.EnhanceLeadsPerday = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceLeadsPerday:10;
                        
                        this.B2bPlatformFee  = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bPlatformFee:0;
                        this.B2bCostperlead = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bCostperlead:0;
                        this.B2bMinCostMonth = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bMinCostMonth:0;
                        this.B2bLeadsPerday = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bLeadsPerday:10;

                        /* ENABLE MINIMUM LEAD PER DAY */
                        // this.LeadspeekEnableMinimumLeadsPerDay = typeof(this.costagency.local.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.local.EnableMinimumLeadsPerday : false;
                        // this.LocatorEnableMinimumLeadsPerDay = typeof(this.costagency.locator.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.locator.EnableMinimumLeadsPerday : false;
                        // this.EnhanceEnableMinimumLeadsPerDay = typeof(this.costagency.enhance.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.enhance.EnableMinimumLeadsPerday : false;
                        // this.B2bEnableMinimumLeadsPerDay = typeof(this.costagency.b2b.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.b2b.EnableMinimumLeadsPerday : false;
                        this.LeadspeekEnableMinimumLeadsPerDay = false;
                        this.LocatorEnableMinimumLeadsPerDay = false;
                        this.EnhanceEnableMinimumLeadsPerDay = false;
                        this.B2bEnableMinimumLeadsPerDay = false;
                        /* ENABLE MINIMUM LEAD PER DAY */
                    }

                    // for Simplifi Settings
                    const prepaidSimplifi = (this.costagency && this.costagency.simplifi && this.costagency.simplifi.Prepaid);
                    this.SimplifiMaxBid = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiMaxBid) != 'undefined')?prepaidSimplifi.SimplifiMaxBid:0;
                    this.SimplifiDailyBudget = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiDailyBudget) != 'undefined')?prepaidSimplifi.SimplifiDailyBudget:0;
                    this.SimplifiAgencyMarkup = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiAgencyMarkup) != 'undefined')?prepaidSimplifi.SimplifiAgencyMarkup:0;
                    // for Simplifi Settings

                    this.lead_FirstName_LastName = this.costagency.locatorlead.FirstName_LastName;
                    this.lead_FirstName_LastName_MailingAddress  = this.costagency.locatorlead.FirstName_LastName_MailingAddress;
                    this.lead_FirstName_LastName_MailingAddress_Phone = this.costagency.locatorlead.FirstName_LastName_MailingAddress_Phone;

                    const updateLogs = {
                        billingFrequency: this.selectsPaymentTerm.PaymentTermSelect,
                        
                        setupFeeLocal: this.LeadspeekPlatformFee,
                        campaignFeeLocal: this.LeadspeekMinCostMonth,
                        costPerLeadLocal: this.LeadspeekCostperlead,
                        costPerLeadAdvancedLocal: this.LeadspeekCostperleadAdvanced,
                        leadPerDayLocal: this.LeadspeekLeadsPerday,

                        setupFeeLocator: this.LocatorPlatformFee,
                        campaignFeeLocator: this.LocatorMinCostMonth,
                        costPerLeadLocator: this.LocatorCostperlead,
                        leadPerDayLocator: this.LocatorLeadsPerday,

                        setupFeeEnhance: this.EnhancePlatformFee,
                        campaignFeeEnhance: this.EnhanceMinCostMonth,
                        costPerLeadEnhance: this.EnhanceCostperlead,
                        leadPerDayEnhance: this.EnhanceLeadsPerday,

                        setupFeeB2B: this.B2bPlatformFee,
                        campaignFeeB2B: this.B2bMinCostMonth,
                        costPerLeadB2B: this.B2bCostperlead,
                        leadPerDayB2B: this.B2bLeadsPerday,
                    }
                    this.$set(this, 'prevDefaultRetailPrice', updateLogs);

                }else{
                    this.selectsPaymentTerm.PaymentTermSelect = response.dpay;
                    this.paymentTermStatus();
                }
                this.modals.pricesetup = true;
            },error => {
                    
            });
            
        },
        initial_default_price() {
            this.resetAgencyCost();

            this.$store.dispatch('getGeneralSetting', {
                companyID: this.companyID,
                settingname: 'agencydefaultprice',
                idSys: this.$global.idsys
            }).then(response => {
                //console.log(response.data);
                if (response.data != '') {
                    // this.costagency = response.data;
                    this.rootCostAgency = response.rootcostagency;

                    if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                                                
                        this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekCostperlead:0;
                        this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekCostperleadAdvanced:0;
                        this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorCostperlead:0;
                        this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhanceCostperlead:0;
                        this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bCostperlead:0;

                        this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekPlatformFee:0;
                        this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekMinCostMonth:0;
                        this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorPlatformFee:0;
                        this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorMinCostMonth:0;
                        this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhancePlatformFee:0;
                        this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhanceMinCostMonth:0;
                        this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bPlatformFee:0;
                        this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bMinCostMonth:0;

                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                        
                        this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekCostperlead:0;
                        this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekCostperleadAdvanced:0;
                        this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorCostperlead:0;
                        this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhanceCostperlead:0;
                        this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bCostperlead:0;

                        this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekPlatformFee:0;
                        this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekMinCostMonth:0;
                        this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorPlatformFee:0;
                        this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorMinCostMonth:0;
                        this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhancePlatformFee:0;
                        this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhanceMinCostMonth:0;
                        this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bPlatformFee:0;
                        this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bMinCostMonth:0;

                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {

                        this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekCostperlead:0;
                        this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekCostperleadAdvanced:0;
                        this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorCostperlead:0;
                        this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhanceCostperlead:0;
                        this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bCostperlead:0;

                        this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekPlatformFee:0;
                        this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekMinCostMonth:0;
                        this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorPlatformFee:0;
                        this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorMinCostMonth:0;
                        this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhancePlatformFee:0;
                        this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhanceMinCostMonth:0;
                        this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bPlatformFee:0;
                        this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bMinCostMonth:0;

                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {

                        this.m_LeadspeekCostPerLead =  (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekCostperlead:0; 
                        this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekCostperleadAdvanced:0;
                        this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorCostperlead:0;
                        this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhanceCostperlead:0;
                        this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bCostperlead:0;

                        this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekPlatformFee:0;
                        this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekMinCostMonth:0;
                        this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorPlatformFee:0;
                        this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorMinCostMonth:0;
                        this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhancePlatformFee:0;
                        this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhanceMinCostMonth:0;
                        this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bPlatformFee:0;
                        this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bMinCostMonth:0;

                    }

                }
                
            },error => {
                    
            });
        },
        resetAgencyCost() {

            this.rootCostAgency.local.Weekly.LeadspeekPlatformFee = '0';
            this.rootCostAgency.local.Weekly.LeadspeekCostperlead = '0';
            this.rootCostAgency.local.Weekly.LeadspeekCostperleadAdvanced = '0';
            this.rootCostAgency.local.Weekly.LeadspeekMinCostMonth = '0';

            this.rootCostAgency.local.Monthly.LeadspeekPlatformFee = '0';
            this.rootCostAgency.local.Monthly.LeadspeekCostperlead = '0';
            this.rootCostAgency.local.Monthly.LeadspeekCostperleadAdvanced = '0';
            this.rootCostAgency.local.Monthly.LeadspeekMinCostMonth = '0';

            this.rootCostAgency.local.OneTime.LeadspeekPlatformFee = '0';
            this.rootCostAgency.local.OneTime.LeadspeekCostperlead = '0';
            this.rootCostAgency.local.OneTime.LeadspeekCostperleadAdvanced = '0';
            this.rootCostAgency.local.OneTime.LeadspeekMinCostMonth = '0';

            if (typeof(this.rootCostAgency.local.Prepaid) !== 'undefined') {
                this.rootCostAgency.local.Prepaid.LeadspeekPlatformFee = '0';
                this.rootCostAgency.local.Prepaid.LeadspeekCostperlead = '0';
                this.rootCostAgency.local.Prepaid.LeadspeekCostperleadAdvanced = '0';
                this.rootCostAgency.local.Prepaid.LeadspeekMinCostMonth = '0';
            }

            this.rootCostAgency.locator.Weekly.LocatorPlatformFee = '0';
            this.rootCostAgency.locator.Weekly.LocatorCostperlead = '0';
            this.rootCostAgency.locator.Weekly.LocatorMinCostMonth = '0';

            this.rootCostAgency.locator.Monthly.LocatorPlatformFee = '0';
            this.rootCostAgency.locator.Monthly.LocatorCostperlead = '0';
            this.rootCostAgency.locator.Monthly.LocatorMinCostMonth = '0';

            this.rootCostAgency.locator.OneTime.LocatorPlatformFee = '0';
            this.rootCostAgency.locator.OneTime.LocatorCostperlead = '0';
            this.rootCostAgency.locator.OneTime.LocatorMinCostMonth = '0';

            if (typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined') {
                this.rootCostAgency.locator.Prepaid.LocatorPlatformFee = '0';
                this.rootCostAgency.locator.Prepaid.LocatorCostperlead = '0';
                this.rootCostAgency.locator.Prepaid.LocatorMinCostMonth = '0';
            }

            this.rootCostAgency.enhance.Weekly.EnhancePlatformFee = '0';
            this.rootCostAgency.enhance.Weekly.EnhanceCostperlead = '0';
            this.rootCostAgency.enhance.Weekly.EnhanceMinCostMonth = '0';

            this.rootCostAgency.enhance.Monthly.EnhancePlatformFee = '0';
            this.rootCostAgency.enhance.Monthly.EnhanceCostperlead = '0';
            this.rootCostAgency.enhance.Monthly.EnhanceMinCostMonth = '0';

            this.rootCostAgency.enhance.OneTime.EnhancePlatformFee = '0';
            this.rootCostAgency.enhance.OneTime.EnhanceCostperlead = '0';
            this.rootCostAgency.enhance.OneTime.EnhanceMinCostMonth = '0';

            if (typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined') {
                this.rootCostAgency.enhance.Prepaid.EnhancePlatformFee = '0';
                this.rootCostAgency.enhance.Prepaid.EnhanceCostperlead = '0';
                this.rootCostAgency.enhance.Prepaid.EnhanceMinCostMonth = '0';
            }

            this.rootCostAgency.b2b.Weekly.B2bPlatformFee = '0';
            this.rootCostAgency.b2b.Weekly.B2bCostperlead = '0';
            this.rootCostAgency.b2b.Weekly.B2bMinCostMonth = '0';

            this.rootCostAgency.b2b.Monthly.B2bPlatformFee = '0';
            this.rootCostAgency.b2b.Monthly.B2bCostperlead = '0';
            this.rootCostAgency.b2b.Monthly.B2bMinCostMonth = '0';

            this.rootCostAgency.b2b.OneTime.B2bPlatformFee = '0';
            this.rootCostAgency.b2b.OneTime.B2bCostperlead = '0';
            this.rootCostAgency.b2b.OneTime.B2bMinCostMonth = '0';

            if (typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined') {
                this.rootCostAgency.b2b.Prepaid.B2bPlatformFee = '0';
                this.rootCostAgency.b2b.Prepaid.B2bCostperlead = '0';
                this.rootCostAgency.b2b.Prepaid.B2bMinCostMonth = '0';
            }
        },
        handleDelete(index, row) {
            //console.log('Row: ' + index);
            swal.fire({
                title: 'Are you sure want to delete this?',
                text: `You won't be able to revert this!`,
                icon: '',
                showCancelButton: true,
                customClass: {
                confirmButton: 'btn btn-fill mr-3',
                cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
        }).then(result => {
                if (result.value) {
                    /** REMOVE ORGANIZATION */
                    
                        this.$store.dispatch('RemoveClient', {
                            companyID: row.company_id,
                            userID: row.id,
                        }).then(response => {
                            //console.log(response)
                            if(response.data.result == "success") {
                                this.deleteRow(row);
                                this.ghlv2ResetListSubAccounts();
                                this.ghlv2GetListSubAccounts();
                                swal.fire({
                                    title: 'Deleted!',
                                    text: `You deleted ${row.name}`,
                                    icon: 'success',
                                    confirmButtonClass: 'btn btn-default btn-fill',
                                    buttonsStyling: false
                                });
                            }else{
                                this.$notify({
                                    type: 'primary',
                                    message: response.data.message,
                                    icon: 'fas fa-bug'
                                }); 
                            }
                        },error => {
                            
                        });
                        
                    /** REMOVE ORGANIZATION */    
                }
        });
        },
        deleteRow(row) {
            let indexToDelete = this.tableData.findIndex(
                tableRow => tableRow.id === row.id
            );
            if (indexToDelete >= 0) {
                this.tableData.splice(indexToDelete, 1);
            }
        },
        processRechargeExisting(_act) {
            this.$store.dispatch('processUpdateCard', {
                tokenid: '',
                cardholder: '',
                address: '',
                city: '',
                state: '',
                country: '',
                zip: '',
                usrID: this.ClientActiveID,
                companyParentID: this.companyID,
                action: _act,
                document: DOCUMENTS.DEFAULT_CLIENT,
            }).then(response => {
                const formCCRef = this.getFormCCRef();
                if (formCCRef) {
                    formCCRef.reset();
                }

                if(response.result == 'success' && response.msg != '') {
                    $('#btnRetryExistCard').html('Retry charge with existing card');
                    $('#btnRetryExistCard').attr('disabled',false);
                    $('#btnUpdateAndCharge').html('save and charge amount due');
                    $('#btnUpdateAndCharge').attr('disabled', false);
                    $('#btnClearPaymentStatus').attr('disabled', false);
                    this.GetClientList();

                    swal.fire({
                        icon: "success",
                        title: response.title,
                        text: response.msg
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Refresh the page when the user clicks "OK"
                            // location.reload();
                        }
                    });
                    
                }else{
                    $('#btnRetryExistCard').html('Retry charge with existing card');
                    $('#btnRetryExistCard').attr('disabled',false);
                    $('#btnUpdateAndCharge').html('save and charge amount due');
                    $('#btnUpdateAndCharge').attr('disabled', false);
                    $('#btnClearPaymentStatus').attr('disabled', false);

                    const formCCRef = _this.getFormCCRef();
                    if (formCCRef) {
                        formCCRef.reset();
                    }
                    _this.cleanCCform();
                    
                    swal.fire({
                        icon: "error",
                        title: response.title,
                        text: response.msg
                    });
                     
                    // this.modals.cardsetup = false;
                    // this.modals.cardupdate = false;
                    // this.cardretrychargeTitle = response.title;
                    // this.cardretrychargeTxt = response.msg;
                    // this.modals.cardretrycharge = false;
                    
                }
        
            },error => {
                
            });
        },
        clearPaymentStatusHandler() {
            var _this = this;
            
            // Validate that a client is selected
            if (!this.ClientActiveID || this.ClientActiveID === '') {
                swal.fire({
                    icon: "warning",
                    title: "No Client Selected",
                    text: "Please select a client first."
                });
                return;
            }
            
            // Show confirmation dialog
            swal.fire({
                title: "Reactivate existing card",
                text: "This action does not charge your card now. It only sets this card as active for upcoming payments.",
                showCancelButton: true,
                confirmButtonText: "Reactivate",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            }).then((result) => {
                if (result.isConfirmed) {
                    $('#btnClearPaymentStatus').html('Processing...');
                    $('#btnClearPaymentStatus').attr('disabled', true);
                    $('#btnRetryExistCard').attr('disabled', true);
                    $('#btnUpdateAndCharge').attr('disabled', true);

                    _this.$store.dispatch('clearPaymentStatus', {
                        usrID: _this.ClientActiveID,
                        companyParentID: _this.companyID,
                    }).then(response => {
                        $('#btnClearPaymentStatus').html('Reactivate card');
                        $('#btnClearPaymentStatus').attr('disabled', false);
                        $('#btnRetryExistCard').attr('disabled', false);
                        $('#btnUpdateAndCharge').attr('disabled', false);

                        if(response.result == 'success' && response.msg != '') {
                            // Update payment status after successful reactivation
                            _this.selectedClientPaymentStatus = '';
                            _this.modals.cardsetup = false;
                            _this.GetClientList();

                            swal.fire({
                                icon: "success",
                                title: response.title,
                                text: response.msg
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Refresh client list after success
                                }
                            });
                        } else {
                            swal.fire({
                                icon: "error",
                                title: response.title || 'Error',
                                text: response.msg || 'Failed to clear payment status'
                            });
                        }
                    }).catch(error => {
                        $('#btnClearPaymentStatus').html('Reactivate card');
                        $('#btnClearPaymentStatus').attr('disabled', false);
                        $('#btnRetryExistCard').attr('disabled', false);
                        $('#btnUpdateAndCharge').attr('disabled', false);

                        swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Failed to clear payment status. Please try again."
                        });
                    });
                }
            });
        },
        getFormCCRef() {
            // Helper function to get the correct formCC ref based on context
            // In wizard mode (step 1), use formCCWizard
            // In standalone modal, use formCC
            if (this.modals.create && this.campaignCreateActiveStep === 1) {
                return this.$refs.formCCWizard;
            } else if (this.modals.cardsetup) {
                return this.$refs.formCC;
            } else {
                // Fallback: try wizard first, then modal
                return this.$refs.formCCWizard || this.$refs.formCC;
            }
        },
        validateCC(action) {
            if (action == 'existcard') {
                $('#btnRetryExistCard').html('Processing...')
                $('#btnRetryExistCard').attr('disabled', true);
                $('#btnUpdateAndCharge').attr('disabled', true);
                $('#btnClearPaymentStatus').attr('disabled', true);

                /** UPDATE THE CARD INFORMATION */
                this.processRechargeExisting(action);
                /** UPDATE THE CARD INFORMATION */
                return false;
            }

            if(this.selects.country === '' || this.selects.state === ''){
                this.showErrorMessage = true
            }
            
            // Use multiple $nextTick to ensure modal is fully rendered
            // This is especially important for Card Settings modal which may take time to render
            return this.$nextTick().then(() => {
                return this.$nextTick().then(() => {
                    // Get the correct formCC ref based on context
                    const formCCRef = this.getFormCCRef();
                    
                    // Check if formCC ref exists before validating
                    if (!formCCRef || !formCCRef.validate) {
                        console.error('formCC ref is not available. Modal state:', {
                            cardsetup: this.modals.cardsetup,
                            create: this.modals.create,
                            step: this.campaignCreateActiveStep,
                            refs: Object.keys(this.$refs)
                        });
                        return Promise.resolve(false);
                    }
                    
                    return formCCRef.validate().then(res => {
                        if(res) {
                            this.agreeTermStat = false;
                            if (this.agreeTerm == false) {
                                this.agreeTermStat = true;
                                return false;
                            }

                            if (this.selects.state != '' && this.selects.country != '') {
                                // Update Save & Next button state if in wizard mode
                                if(this.modals.create && this.campaignCreateActiveStep === 1) {
                                    this.updateSaveNextButtonState({ disabled: true, loading: true });
                                }
                                
                                $('#btnupdcc').attr('disabled',true);
                                $('#btnupdcc').html('Processing...'); 
                                $('#btnUpdateAndCharge').html('Processing...');
                                $('#btnUpdateAndCharge').attr('disabled', true);
                                $('#btnRetryExistCard').attr('disabled', true);
                                $('#btnClearPaymentStatus').attr('disabled', true);
                                /** UPDATE THE CARD INFORMATION */
                                if (this.btncardupdate === true) {
                                    this.processUpdateCard(action);
                                    // console.log('CC updated!');
                                }else{
                                    this.processAddCard(action);
                                    // console.log('CC Added!');
                                }
                                /** UPDATE THE CARD INFORMATION */
                            }else{
                                this.showErrorMessage = true
                            }

                        }
                    });
                });
            });
            
        },
        processAddCard(action) {
            var _store = this.$store;
            var _this = this;
            var _act = action;

            return new Promise((resolve, reject) => {
                _stripe.createToken(_cardElement).then(function(result) {
                    if(result.error) {
                        //console.log(result.error.message);
                        // Reset Save & Next button state if in wizard mode
                        if(_this.modals.create && _this.campaignCreateActiveStep === 1) {
                            _this.updateSaveNextButtonState({ disabled: false, loading: false });
                        }
                        $('#btnupdcc').attr('disabled',false);
                        $('#btnupdcc').html('Update'); 
                        $('#btnUpdateAndCharge').html('save and charge amount due');
                        $('#btnUpdateAndCharge').attr('disabled',false);
                        $('#btnRetryExistCard').html('Retry charge with existing card');
                        $('#btnRetryExistCard').attr('disabled', false);
                        $('#carderror').html('<small style="color:red !important;"><sup>*</sup>' + result.error.message + '</small>');
                        $('.card-border').addClass('error-border');
                        $('#carderror').show();
                    }else{
                        $('#carderror').hide();
                        $('.card-border').removeClass('error-border');
                        _tokenid = result.token.id;
                        _store.dispatch('paymentcustomersetup', {
                            tokenid: _tokenid,
                            cardholder: _this.cardholdername,
                            address: _this.billingaddress,
                            city: _this.city,
                            state: _this.selects.state,
                            country: _this.selects.country,
                            zip: _this.zipcode,
                            usrID: _this.ClientActiveID,
                            action: _act,
                            document_type: DOCUMENTS.DEFAULT_CLIENT,
                            from: 'client-management',
                        }).then(response => {
                            //console.log(response.result)
                            if(response.result == 'success' && response.msg != '') {
                                const formCCRef = _this.getFormCCRef();
                                if (formCCRef) {
                                    formCCRef.reset();
                                }

                                // Check if we're in wizard mode
                                if(_this.modals.create && _this.campaignCreateActiveStep === 1) {
                                    // In wizard mode, move to next step
                                    _this.updateCreateClientStep();
                                } else {
                                    // In standalone mode, close the modal
                                    _this.modals.cardsetup = false;
                                }

                                _this.GetClientList();
                                $('#btnupdcc').attr('disabled',false);
                                $('#btnupdcc').html('Update');
                                $('#btnRetryExistCard').html('Retry charge with existing card');
                                $('#btnRetryExistCard').attr('disabled',false);
                                $('#btnUpdateAndCharge').html('save and charge amount due');
                                $('#btnUpdateAndCharge').attr('disabled', false);
                                swal.fire({
                                    icon: "success",
                                    title: response.title,
                                    text: response.msg
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        // Refresh the page when the user clicks "OK"
                                        // location.reload();
                                    }
                                });
                                // _this.modals.cardupdate = true;
                                // _this.modals.cardretrycharge = false;
                                // $('#btnupdcc').attr('disabled',false);
                                // $('#btnupdcc').html('Update');
                            }else{
                                // Reset Save & Next button state if in wizard mode
                                if(_this.modals.create && _this.campaignCreateActiveStep === 1) {
                                    _this.updateSaveNextButtonState({ disabled: false, loading: false });
                                }
                                if (_this.$refs.formCC) {
                                    _this.$refs.formCC.reset();
                                }
                                //_this.modals.cardsetup = false;
                                // _this.modals.cardupdate = false;
                                // _this.cardretrychargeTitle = response.title;
                                // _this.cardretrychargeTxt = response.msg;
                                // _this.modals.cardretrycharge = true;
                                _this.cleanCCform();
                                $('#btnupdcc').attr('disabled',false);
                                $('#btnupdcc').html('Update'); 
                                swal.fire({
                                    icon: "error",
                                    title: response.title,
                                    text: response.msg
                                });
                            }
                        },error => {
                            
                        });
                    }
                });
            });
        },
        processUpdateCard(action) {
            var _store = this.$store;
            var _this = this;
            var _act = action;

            return new Promise((resolve, reject) => {
              _stripe.createToken(_cardElement).then(function(result) {
                  if(result.error) {
                      //console.log(result.error.message);
                      // Reset Save & Next button state if in wizard mode
                      if(_this.modals.create && _this.campaignCreateActiveStep === 1) {
                          _this.updateSaveNextButtonState({ disabled: false, loading: false });
                      }
                      $('#btnupdcc').html('Update');
                      $('#btnupdcc').attr('disabled',false);
                      $('#btnUpdateAndCharge').html('save and charge amount due');
                      $('#btnUpdateAndCharge').attr('disabled',false);
                      $('#btnRetryExistCard').html('Retry charge with existing card');
                      $('#btnRetryExistCard').attr('disabled', false);
                      $('#carderror').html('<small style="color:red !important;"><sup>*</sup>' + result.error.message + '</small>');
                      $('.card-border').addClass('error-border');
                      $('#carderror').show();
                  }else{
                      $('#carderror').hide();
                      $('.card-border').removeClass('error-border');
                      _tokenid = result.token.id;
                      _store.dispatch('processUpdateCard', {
                          tokenid: _tokenid,
                          cardholder: _this.cardholdername,
                          address: _this.billingaddress,
                          city: _this.city,
                          state: _this.selects.state,
                          country: _this.selects.country,
                          zip: _this.zipcode,
                          usrID: _this.ClientActiveID,
                          companyParentID: _this.companyID,
                          action: _act,
                          document_type: DOCUMENTS.DEFAULT_CLIENT,
                      }).then(response => {
                          //console.log(response.result)
                          if(response.result == 'success' && response.msg != '') {
                            if (_this.$refs.formCC) {
                                _this.$refs.formCC.reset();
                            }

                            // Check if we're in wizard mode
                            if(_this.modals.create && _this.campaignCreateActiveStep === 1) {
                                // In wizard mode, move to next step
                                _this.updateCreateClientStep();
                            } else {
                                // In standalone mode, close the modal
                                _this.modals.cardsetup = false;
                            }

                            _this.GetClientList();
                            $('#btnupdcc').attr('disabled',false);
                            $('#btnupdcc').html('Update');
                            $('#btnRetryExistCard').html('Retry charge with existing card');
                            $('#btnRetryExistCard').attr('disabled',false);
                            $('#btnUpdateAndCharge').html('save and charge amount due');
                            $('#btnUpdateAndCharge').attr('disabled', false);
                            swal.fire({
                                icon: "success",
                                title: response.title,
                                text: response.msg
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Refresh the page when the user clicks "OK"
                                    // location.reload();
                                }
                            });
                            // _this.modals.cardupdate = true;
                            // _this.modals.cardretrycharge = false;
                            // $('#btnupdcc').attr('disabled',false);
                            // $('#btnupdcc').html('Update');
                          }else {
                            // Reset Save & Next button state if in wizard mode
                            if(_this.modals.create && _this.campaignCreateActiveStep === 1) {
                                _this.updateSaveNextButtonState({ disabled: false, loading: false });
                            }
                            if (_this.$refs.formCC) {
                                _this.$refs.formCC.reset();
                            }
                            //_this.modals.cardsetup = false;
                            // _this.modals.cardupdate = false;
                            // _this.cardretrychargeTitle = response.title;
                            // _this.cardretrychargeTxt = response.msg;
                            // _this.modals.cardretrycharge = true;
                            _this.cleanCCform();
                            $('#btnupdcc').attr('disabled',false);
                            $('#btnupdcc').html('Update'); 
                            $('#btnRetryExistCard').html('Retry charge with existing card');
                            $('#btnRetryExistCard').attr('disabled',false);
                            $('#btnUpdateAndCharge').html('save and charge amount due');
                            $('#btnUpdateAndCharge').attr('disabled', false);
                            swal.fire({
                              icon: "error",
                              title: response.title,
                              text: response.msg
                            });
                          }
                      },error => {
                          // Reset Save & Next button state if in wizard mode on error
                          if(_this.modals.create && _this.campaignCreateActiveStep === 1) {
                              _this.updateSaveNextButtonState({ disabled: false, loading: false });
                          }
                      });
                  }
              });
            });
        },
        initstripelib() {
            var chkload = this.$global.stripescriptload;
            if (chkload === false) {
                this.$global.initStripeScriptLoad(true);
                $.getScript( "https://js.stripe.com/v3/" )
                .done(function( script, textStatus ) {
                    initcreditcard();
                })
                .fail(function( jqxhr, settings, exception ) {
                    //$( "div.log" ).text( "Triggered ajaxError handler." );
                });
            }else{
                initcreditcard();
            }
        
        },
        cleanCCform() {
          this.cardholdername = '';
          this.billingaddress = '';
          this.city = '';
          this.selects.state = '';
          this.zipcode = '';
          this.agreeTerm = false;
          if (this.$refs.formCC) {
              this.$refs.formCC.reset();
          }
        //   this.currCardHolder = '';
        //   this.currCardlastdigit = '';
        //   this.currCardType = '';
          if (typeof(_cardElement) == "undefined") {
            this.cardfailetoload = true;
          }else{
            _cardElement.clear();
          }
        },
        getStateList() {
            this.$store.dispatch('getStateList').then(response => {
                this.selects.statelist = response.params
            },error => {
                
            });
        },

        getCardInfo(_usrID) {
            this.$store.dispatch('getCardInfo', {
                    usrID: _usrID,
            }).then(response => {
               //console.log(response.params);
               this.btncardupdate = false;
               if (response.params != '') {
                    this.currCardHolder = (response.params.name != null)?response.params.name:''
                    this.currCardlastdigit = (response.params.last4 != null)?response.params.last4:''
                    this.currCardType = (response.params.brand != null)?response.params.brand:''
                    this.btncardupdate = true;
               } else {
                    this.currCardHolder = ''
                    this.currCardlastdigit =''
                    this.currCardType = ''
               }
               // Only open standalone modal if not in wizard mode
               if (!this.modals.create) {
                   this.modals.cardsetup = true;
               }
            },error => {

            });
        },
        onExpandClick(row){
            this.rowClicked(row);
        },
        checkModuleChanges(prevModules, currentModules){
            const changedModules = currentModules.reduce((acc, current) => {
                const prev = prevModules.find(prev => prev.type === current.type);

                if (prev && prev.status === true && current.status === false) {
                acc.push({ type: current.type });
                }

                return acc;
            }, []);

            return changedModules;
        },
        handleFormatCurrency(type, field){
            const validInput = /^[0-9]*(\.[0-9]*)?$/;
            const isLeadsPerDay = field == 'LeadspeekLeadsPerday' || field == 'LocatorLeadsPerday' || field == 'EnhanceLeadsPerday' || field == 'B2bLeadsPerday'

            if(!validInput.test(this[field])){
                this[field] = 0
            }

            if(isLeadsPerDay){
                if(this[field] == '0' || this[field] == ""){
                    this[field] = 1
                }
            }

            if(field == 'EnhanceLeadsPerday' || field == 'B2bLeadsPerday'){
                this.validateMinLead(field)
            }

            if(type == 'simplifi'){
                if(field == 'SimplifiMaxBid'){
                    this.validateMinimumInput('blur', 'maxBid')
                }else if(field == "SimplifiDailyBudget"){
                    this.validateMinimumInput('blur', 'dailyBudget')
                }
            }

            const formatNumber = formatCurrencyUSD(this[field])
            this[field] = formatNumber
            this.set_fee(type, field)
        },
        restrictInput(event) {
            const input = event.target.value;
            const char = event.key;

            if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
                return; 
            }

            if (!char.match(/[0-9]/) && char !== '.') {
                event.preventDefault();
            }

            // Allow only one period
            if (char === '.' && input.includes('.')) {
                event.preventDefault();
            }
        },
        exportDataClient(){
            const userData = this.$store.getters.userData;
            let search = ''
            let orderBy = ''
            let sortBy = ''

            if(this.currSortBy){
                sortBy = '/' + this.currSortBy
            }
            if(this.currOrderBy){
                orderBy = '/' + this.currOrderBy
            }
            if(this.searchQuery){
                search = '/' + this.searchQuery
            }

            const url = `${process.env.VUE_APP_DATASERVER_URL}/configuration/clients-report/download/${userData.company_id}${sortBy}${orderBy}${search}?CardStatus=${encodeURIComponent(JSON.stringify(this.filters.cardStatus))}&CampaignStatus=${encodeURIComponent(JSON.stringify(this.filters.campaignStatus))}`;

            downloadFileInBackground(url, 'clients.csv')
        },
        validateClickFunnelsFields(_slug) {
            const { subdomain, workspaceId } = this.clickfunnels;
            const apiKey = this.userApiKey[_slug];

            let missingFields = [];

            if (apiKey.trim() === "") missingFields.push("API Key");
            if (subdomain.trim() === "") missingFields.push("Subdomain");
            if (workspaceId.trim() === "") missingFields.push("Workspace ID");

            if (missingFields.length > 0) {
                this.$notify({
                    type: 'primary',
                    message: `Please fill in the following fields: ${missingFields.join(', ')}`,
                    icon: 'fas fa-exclamation-circle'
                });

                $('#btnSaveIntegration').attr('disabled', false);
                $('#btnSaveIntegration').html('Save');

                return true;
            }

            return false;
        },
         handleCheckItemCustomFields(type, name, module){
            const handleModule = () => {
                switch (module) {
                    case 'b2b':
                    return 'b2b';
                    case 'advance':
                    return 'advance'
                    default:
                    return ''
                }
            }

            const listValueIntegration = this[`listValueFieldsIntegration${type}${handleModule()}`];
            const isChecked = listValueIntegration.includes(name);

            const listAll = this.customFieldsBySlug[type.toLowerCase()].filter(item => item.type == module).map(item => item.name)
            
            MessageBox.confirm(
                isChecked 
                    ? `Unchecking "${name}" will stop sending this data to your CRM. Are you sure?` 
                    : `Checking "${name}" will create this custom field in your CRM, and start sending this data. Are your sure?`,
                'Warning',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }
            ).then(() => {
                const capitalizedModule = module.charAt(0).toUpperCase() + module.slice(1);
        
                if (isChecked) {
                    this[`listValueFieldsIntegration${type}${handleModule()}`] = listValueIntegration.filter(item => item !== name);
                    this[`isCheckAllIntegration${capitalizedModule}`] = false;
                } else {
                    this[`listValueFieldsIntegration${type}${handleModule()}`].push(name);

                    if(this[`listValueFieldsIntegration${type}${handleModule()}`].length == listAll.length){
                        this[`isCheckAllIntegration${capitalizedModule}`] = true;
                    }
                }
            }).catch(() => {
                return;
            });
        },
        hasChangedArray(prevData, currentData){

            if(prevData == undefined || currentData == undefined){
                return true;
            }

            if (prevData.length !== currentData.length) {
                return true;
            }

            // Check each element in the array
            for (let i = 0; i < prevData.length; i++) {
                if (prevData[i] !== currentData[i]) {
                    return true; // Return true if any element is different
                }
            }

            // Return false if all elements are the same
            return false;
        },
        getCustomFieldsByType(type, fields, filteredList) {
            const listCustomFields = fields
                .filter(item => item.type === type)
                .map(item => item.name);

            return filteredList.filter(item => listCustomFields.includes(item));
        },
        handleDefaultLogsCustomFields(name) {
            this[`prevListValueFieldsIntegration${name}`] = [];
            this[`prevListValueFieldsIntegration${name}b2b`] = [];
            this[`prevListValueFieldsIntegration${name}advance`] = [];

            const listDisabledCustomFields = (this.customFieldsBySlug[name.toLowerCase()] || []).filter(item => item.disabled).map(item => item.name);
            const filteredListGeneral = (this[`listValueFieldsIntegration${name}`] || []).filter(item => !listDisabledCustomFields.includes(item));
            const filteredListB2b = (this[`listValueFieldsIntegration${name}b2b`] || []).filter(item => !listDisabledCustomFields.includes(item));
            const filteredListAdvance = (this[`listValueFieldsIntegration${name}advance`] || []).filter(item => !listDisabledCustomFields.includes(item));

            this[`prevListValueFieldsIntegration${name}`] = filteredListGeneral;
            this[`prevListValueFieldsIntegration${name}b2b`] = filteredListB2b;
            this[`prevListValueFieldsIntegration${name}advance`] = filteredListAdvance;
        },
        handleCustomFieldsEmpty(integrations, name) {
            const integrationsItem = integrations.data.find(item => item.integration_slug === name.toLowerCase());

            if(!integrationsItem){
                const listCustomFieldsGeneral = (this.customFieldsBySlug[name.toLowerCase()] || []).filter(field => field.type === 'general').map(item => item.name)
                const listCustomFieldsB2b = (this.customFieldsBySlug[name.toLowerCase()] || []).filter(field => field.type === 'b2b').map(item => item.name)
                const listCustomFieldsAdvance = (this.customFieldsBySlug[name.toLowerCase()] || []).filter(field => field.type === 'advance').map(item => item.name)

                this[`listValueFieldsIntegration${name}`] = listCustomFieldsGeneral
                this[`listValueFieldsIntegration${name}b2b`] = listCustomFieldsB2b
                this[`listValueFieldsIntegration${name}advance`] = listCustomFieldsAdvance
            }
        },
        handleFilterListCustomFields(name) {
            const listDisabledCustomFields = this.customFieldsBySlug[name.toLowerCase()].filter(item => item.disabled).map(item => item.name)
            const filteredListGeneral = this[`listValueFieldsIntegration${name}`].filter(item => !listDisabledCustomFields.includes(item));
            const filteredListB2b = this[`listValueFieldsIntegration${name}b2b`].filter(item => !listDisabledCustomFields.includes(item));
            const filteredListAdvance = this[`listValueFieldsIntegration${name}advance`].filter(item => !listDisabledCustomFields.includes(item));

            return { filteredListGeneral, filteredListB2b, filteredListAdvance }
        },
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        async handleCheckAllCustomFields(value, slug, type){
            const handleType = () => {
                switch (type) {
                    case 'general':
                        return 'General';
                    case 'b2b':
                        return 'B2b';
                    case 'advance':
                        return 'Advance';
                    default:
                        return '';
                }
            }

            const listAll = this.customFieldsBySlug[slug.toLowerCase()].filter(item => item.type == type).map(item => item.name)
            const stillChecked = this.customFieldsBySlug[slug.toLowerCase()]
            .filter(item => item.disabled && item.type == type)
            .map(item => item.name);

           await MessageBox.confirm(
                !value 
                    ? `Unchecking "all" will stop sending this data to your CRM. Are you sure?` 
                    : `Checking "all" will create this custom field in your CRM, and start sending this data. Are your sure?`,
                'Warning',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }
            ).then(() => {
                const typeRewrite = handleType() == 'General' ? '' : handleType().toLowerCase();

                if (value) {
                    this[`listValueFieldsIntegration${slug}${typeRewrite}`] = listAll;
                    this[`isCheckAllIntegration${handleType()}`] = true;
                } else {
                    this[`listValueFieldsIntegration${slug}${typeRewrite}`] = stillChecked;
                    this[`isCheckAllIntegration${handleType()}`] = false;
                }
            }).catch(() => {
                return;
            });
        },
        handleDefaultCheckAllCustomFields(type, slug){
            if (this.customFieldsBySlug[slug.toLowerCase()] !== null && this.customFieldsBySlug[slug.toLowerCase()] !== '') {
                const stillChecked = this.customFieldsBySlug[slug.toLowerCase()]
                .filter(item => item.type == type.toLowerCase())
                .map(item => item.name);

                const rewriteType = type.toLowerCase() == 'general' ? '' : type.toLowerCase();

                if(stillChecked.length == this[`listValueFieldsIntegration${slug}${rewriteType}`].length){
                    this[`isCheckAllIntegration${type}`] = true;
                } else {
                    this[`isCheckAllIntegration${type}`] = false;
                }
            }
        },
        onInput(input, field) {
            if (input == "0") {
               this[field] = 1
            }
        },
        getValidationErrorMessage(data) {
            // Get specific error message without showing notification (for wizard mode)
            const rules = {
                sendgrid: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        return 'API Key is required';
                    }
                    return null;
                },
                gohighlevel: () => {
                    const version = this.integrationVersion.gohighlevel;
                    if (version == 1) {
                        if (!data.api_key || data.api_key.trim() === '') {
                            return 'API Key is required';
                        }
                    } else {
                        if (!this.ghlV2Connected) {
                            return 'Please connect account first';
                        }
                    }
                    return null;
                },
                zapier: () => {
                    if (
                        !Array.isArray(data.api_key) ||
                        data.api_key.length === 0 ||
                        data.api_key.some(key => !key || key.trim() === '')
                    ) {
                        return 'Webhook URL is required';
                    }
                    return null;
                },
                mailboxpower: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        return 'API Key is required';
                    }
                    return null;
                },
                kartra: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        return 'API Key is required';
                    }
                    if (!this.kartraApiPassword || this.kartraApiPassword.trim() === '') {
                        return 'Password is required';
                    }
                    return null;
                },
                agencyzoom: () => {
                    if (
                        !Array.isArray(data.api_key) ||
                        data.api_key.length === 0 ||
                        data.api_key.some(key => !key || key.trim() === '')
                    ) {
                        return 'Webhook URL is required';
                    }
                    return null;
                },
                clickfunnels: () => {
                    const { subdomain, workspaceId } = this.clickfunnels;
                    const apiKey = data.api_key;
                    let missingFields = [];
                    if (!apiKey || apiKey.trim() === "") missingFields.push("API Key");
                    if (!subdomain || subdomain.trim() === "") missingFields.push("Subdomain");
                    if (!workspaceId || workspaceId.trim() === "") missingFields.push("Workspace ID");
                    if (missingFields.length > 0) {
                        return `Please fill in: ${missingFields.join(', ')}`;
                    }
                    return null;
                },
            };

            if (rules[data.integration_slug]) {
                return rules[data.integration_slug]();
            }

            return null;
        },
        validateConfiguration(data) {
            // console.log('validateConfiguration', { data });
            const notifyError = (message) => {
                this.$notify({
                    type: 'primary',
                    icon: 'fas fa-exclamation-circle',
                    message
                });
            };

            const rules = {
                sendgrid: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        notifyError('API Key is required');
                        return false;
                    }
                    return true;
                },
                gohighlevel: () => {
                    const version = this.integrationVersion.gohighlevel;
                    if (version == 1) {
                        if (!data.api_key || data.api_key.trim() === '') {
                            notifyError('API Key is required');
                            return false;
                        }
                    } else {
                        if (!this.ghlV2Connected) {
                            notifyError('Please connect account first');
                            return false;
                        }
                    }
                    return true;
                },
                zapier: () => {
                    if (
                        !Array.isArray(data.api_key) ||
                        data.api_key.length === 0 ||
                        data.api_key.some(key => !key || key.trim() === '')
                    ) {
                        notifyError('Url is required');
                        return false;
                    }
                    return true;
                },
                mailboxpower: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        notifyError('API Key is required');
                        return false;
                    }
                    return true;
                },
                kartra: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        notifyError('API Key is required');
                        return false;
                    }
                    if (!this.kartraApiPassword || this.kartraApiPassword.trim() === '') {
                        notifyError('Password is required');
                        return false;
                    }
                    return true;
                },
                agencyzoom: () => {
                    if (
                        !Array.isArray(data.api_key) ||
                        data.api_key.length === 0 ||
                        data.api_key.some(key => !key || key.trim() === '')
                    ) {
                        notifyError('Url is required');
                        return false;
                    }
                    return true;
                },
            };

            if (rules[data.integration_slug]) {
                return rules[data.integration_slug]();
            }

            return true;
        }

    },

    mounted() {
        const userData = this.$store.getters.userData;
        this.companyID = userData.company_id;
         _sppubkey = this.$global.sppubkey;
         _this = this;
        this.selectsPaymentTerm.PaymentTerm = this.$global.rootpaymentterm;

        const protectAccessMenu = () => {
            if(!this.$global.stripeaccountconnected) {
                this.$router.push({ name: 'General Setting' });
                return;
            }
        }
        protectAccessMenu();
        
        if(this.$global.idsys == this.$global.masteridsys) {
            this.getMinimumValueSimplifi();
        }

        this.GetClientList();
        this.cardfailetoload = false;
        this.moduleAgency = this.$global.agencyfilteredmodules

        this.customsidebarleadmenu = this.$global.agencyfilteredmodules;
        // console.log({'customsidebarleadmenu': this.customsidebarleadmenu});
        

        this.selectedModulesCreate = this.initializeSelectedModules




        if (typeof(_sppubkey) == "undefined" || _sppubkey == "") {
            this.cardfailetoload = true;
        }else{
            this.initstripelib();
        }
        this.getStateList();
        this.reset();
        
        $('.phonenum input').usPhoneFormat({
            format: 'xxx-xxx-xxxx',
        });

        const sidebarAgency = this.$global.agency_side_menu && this.$global.agency_side_menu.find(menu => menu.type == 'b2b')
        if((this.$global.globalModulNameLink.b2b.name == null && this.$global.globalModulNameLink.b2b.url == null) || (sidebarAgency && !sidebarAgency.status)){            
            this.isHideB2b = true;
        }

        const sidebarAgencyAdvance = this.$global.agency_side_menu && this.$global.agency_side_menu.find(menu => menu.type == 'enhance')
        if((this.$global.globalModulNameLink.enhance.name == null && this.$global.globalModulNameLink.enhance.url == null) || (sidebarAgencyAdvance && !sidebarAgencyAdvance.status)){
            this.isHideAdvance = true;
        }

        this.getCustomIntegrations();
        this.ghlv2GetListSubAccounts();

        window.addEventListener("resize", this.updateWindowWidth);
        window.addEventListener("message", this.handleFeedbackConnectGhlV2); // untuk menerima sinyal/feedback saat connect ghl, dan sistem kita di iframe
        
        // Add classes to disabled pricing fields for better styling
        this.updateDisabledFieldStyles();
    },
    updated() {
        // Update disabled field styles when component updates
        this.$nextTick(() => {
            this.updateDisabledFieldStyles();
        });
    },

    watch: {
        'modals.integrations': function(newValue) {
            this.selects.ghlv2SubAccount = '';
        },
        'modals.whitelist': function(newValue) {
            if(!newValue) {
                this.supressionProgress = [];
                clearTimeout(this.supressionTimeout);
                clearInterval(this.supressionInterval);
            }
        },
        'modals.cardsetup': function(newValue) {
            if(newValue){
                this.$nextTick(() => {
                    // Initialize Stripe card element for standalone modal
                    initcreditcard();
                });
            }
        },
        'modals.create': function(newValue) {
            if(newValue){
                // Ensure state is reset when modal is opened
                this.$nextTick(() => {
                    // Reset button state to default if modal is opened fresh
                    if(this.campaignCreateActiveStep === 0) {
                        this.updateSaveNextButtonState({ text: 'Save & Next', disabled: false, loading: false });
                    }
                });
            }
        },
        'modals.pricesetup': function(newValue) {
            if(newValue){
                this.$nextTick(() => {
                    if (this.moduleAgency.local != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'LeadsPeek';
                    } else if (this.moduleAgency.locator != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'locator';
                    } else if (this.moduleAgency.enhance != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'enhance';
                    } else if(this.moduleAgency.b2b != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'b2b';
                    } else if(this.moduleAgency.simplifi != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'simplifi';
                    }
                });
            }
        },
        
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        // searchQuery(value) {
        //     let result = this.tableData;
        //     var temp = Array();
        //     if (value !== '') {
        //         result = this.fuseSearch.search(this.searchQuery);
        //         for(let i=0;i<result.length;i++) {
        //             temp.push(result[i].item);
        //             //console.log(result[i].item);
        //         }

        //         if (result.length == 0) {
        //             if (this.tableData.length > 0) {
        //                 this.tableDataOri = [];
        //                 this.tableDataOri = this.tableData;
        //             }
        //             this.tableData = [];
        //         }
                
        //     }else{
        //         this.tableData = this.tableDataOri;
        //     }
        //     this.searchedData = temp;
        // }
    },
    
    beforeDestroy() {
        window.removeEventListener("resize", this.updateWindowWidth);
        window.removeEventListener("message", this.handleFeedbackConnectGhlV2); // untuk menerima sinyal/feedback saat connect ghl, dan sistem kita di iframe
        
        // hapus event scroll dari select sub account ghl 
        const dropdownAdd = this.$refs.selectGhlV2SubAccountAdd.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        const dropdownEdit = this.$refs.selectGhlV2SubAccountEdit.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        if (dropdownAdd) {
            dropdownAdd.removeEventListener('scroll', this.handleScrollGhlV2SubAccount);
        }
        if (dropdownEdit) {
            dropdownEdit.removeEventListener('scroll', this.handleScrollGhlV2SubAccount);
        }
    }
}

function initcreditcard() {
    
    // console.log('initcreditcard called')
    let cardId = _this.modals.create ? '#card-element-create' : '#card-element'
  if (!$(cardId).length) {
    // console.log('Card element not found in DOM');
    return
  }

  // Check if Stripe public key is available
  if (!_sppubkey || _sppubkey === '') {
    console.error('Stripe public key not set');
    _this.cardfailetoload = true;
    return;
  }

  // Unmount existing card element if it exists
  if (typeof(_cardElement) != "undefined" && _cardElement) {
    try {
    //   console.log('Unmounting existing card element');
      _cardElement.unmount();
    } catch(e) {
    //   console.log('Error unmounting card element:', e);
    }
  }


	_stripe = Stripe(_sppubkey);
	/** ATTACHED CARD ELEMENTS */
   _elements = _stripe.elements();
    _cardElement = _elements.create('card', {
    hidePostalCode: true,
    style: {
        base: {
                color: 'rgba(82, 95, 127, 0.8)',
                fontSize: '16px',
                fontFamily: '"Open Sans", sans-serif',
                fontSmoothing: 'antialiased',
                '::placeholder': {
                  color: 'rgba(82, 95, 127, 0.3)',
                },
            },
            invalid: {
                color: '#e5424d',
                ':focus': {
                  color: 'rgba(82, 95, 127, 0.3)',
                },
            },
        },
    });

    _this.cardfailetoload = false;

    if (typeof(_cardElement) == "undefined") {
      _this.cardfailetoload = true;
    }
    //var cardElement = elements.create('card');
    // console.log('Mounting card element to #card-element');
    _cardElement.mount(cardId);
    // console.log('Card element mounted successfully');
    /** ATTACHED CARD ELEMENTS */

    /** CARD ELEMENT VALIDATION */
    _cardElement.on('change', function(event) {
        if (event.error) {
          console.log('Card Error :' + event.error.message);
          $('#carderror').html('<small style="color:red !important;"><sup>*</sup>' + event.error.message + '</small>');
          $('#carderror').show();
          $('.card-border').addClass('error-border');
        } else {
          $('#carderror').hide();
            $('.card-border').removeClass('error-border');
        }
    });


}

</script>

<style scoped>
/* FOR DIVIDER IN GHL VERSION 2 */
.divider-ghl2 {
    border-top: 1px solid #dcdfe6;
    padding-top: 1rem;
    margin-top: 1rem;
    margin-left: 0px;
    border-left: none;
}
@media (min-width: 768px) {
    .divider-ghl2 {
        border-left: 1px solid #dcdfe6;
        border-top: none;
        padding-top: 0;
        margin-top: 0;
        margin-left: -2px;
    }
}
/* FOR DIVIDER IN GHL VERSION 2 */

/* FOR INPUT COST PER LEAD AND INPUT LEADS PER DAY */
@media (min-width: 768px) {
    .inputCostPerContact {
        margin-top: 23px;
    }
    .checkboxEnableMinimumLeadsPerDay {
        margin-top: -5px;
    }
}
/* FOR INPUT COST PER LEAD AND INPUT LEADS PER DAY */
</style>
<style>
.sj-quicksend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}
.sj-quicksend-item {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: all .15s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.sj-quicksend-item img { width: 100%; height: 100px; object-fit: cover; }
.sj-quicksend-item .sj-quicksend-name { padding: 6px; font-size: 12px; text-align: center; width: 100%; }
.sj-quicksend-item.selected { border-color: #409EFF; box-shadow: 0 0 0 2px rgba(64,158,255,.2); }
.sj-quicksend-empty { color: #6b7280; font-size: 12px; }
.error-input-price-simplifi {
  border: 1px solid #942434 !important;
}

.error-message-price-simplifi {
  color:#942434;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 4px;
  display: flex;
  word-wrap: break-word; 
  white-space: normal; 
  text-align: left;
}

#modalSetCard .select-primary.el-select .el-input input {
     color: rgba(82, 95, 127, 0.8);
}

#modalSetCard .form-control {
    color: rgba(82, 95, 127, 0.8);
    border: 1px solid #525f7f;
}

#modalSetCard {
    /*top:-10%;*/
}

#modalSetCard .card-border {
  width: 95% !important;
  left: 15px;
  line-height: 1.5;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #525f7f;
  border-radius:4px;
  padding: 8px 12px 6px 12px;
  margin:8px 0px 4px -1px;
  height:36px;
  box-sizing: border-box;
  transform: translateZ(0);
  -webkit-user-select:text;
}

.card-border.error-border {
    border: 1px solid red !important;
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
}

#modalSetPrice input:read-only {
    background-color: white;
}

#modalSetPrice .el-input__prefix, #modalSetPrice .el-input__suffix {
    color: #525f7f;
}

#modalSetPrice .leadlimitdate {
    width: auto !important;
}

#modalSetPrice .el-input__inner {
    background-color: transparent;
    border-width: 1px;
    border-color: #2b3553;
    color: #942434;
}

.frmSetCost .input-group .input-group-prepend .input-group-text i {
    color: #525f7f;
}

.frmSetCost .input-group input[type=text], .frmSetCost input[type=text],.frmSetCost .input-group .input-group-prepend .input-group-text {
    color: #525f7f;
    border-color: #525f7f;
}
.black-center input[type=text] {
    color: #525f7f;
    text-align: center;
}
.clickable-rows td {
    cursor: pointer;
}
/* .clickable-rows .el-table, .el-table__expanded-cell {
    background-color:#1e1e2f;
} */
.clickable-rows tr .el-table__expanded-cell {
    cursor: default;
}

/* .iconcampaign {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    margin-right: 5px;
} */

/* .iconcampaign {
    padding-inline: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    border-radius: 8px;
} */

/* .iconcampaign + .iconcampaign {
  margin-left: 5px;
} */

.cmpActive {
    background-color: green; /* You can change the background color as needed */
}

.cmpPauseStop {
    background-color: #646769; /* You can change the background color as needed */
}

.icons-container {
    display: inline-flex;
    gap: 5px;
    line-height: normal;
}
.integratios-list-wrapper{
    gap:8px;
}
.integrations__modal-item-wrapper {
    min-height: 100px;
    max-height: 100px;
    width: 128px; /* 96px content + 32px padding (16px each side) */
    flex: 0 0 128px; /* Don't grow, don't shrink, fixed width */
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;
    padding:16px;
    position: relative;
}
.integrations__modal-item{
    width:96px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
}
/* .integrations__modal-item.--active{
    
} */
.integrations__modal-item-wrapper:hover{
    background-color: #5e72e4 !important;
    color: #f4f5f7 !important;
}
.integrarion-brand-name{
    font-size:12px;
    line-height:16px;
    font-weight:400px;
}
.check-icon {
    position: absolute;
    top: 6px;
    right: 6px;
    background-color: #22c55e;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    animation: popIn 0.25s ease-out;
}
@keyframes popIn {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}
.wizard-full-integration-disabled {
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.wizard-full-integration-disabled i.fa-lock {
    animation: pulse 2s ease-in-out infinite;
}
@keyframes pulse {
    0%, 100% {
        opacity: 0.5;
    }
    50% {
        opacity: 0.8;
    }
}
.integrations-modal-footer-wrapper{
    padding:12px 24px;
    width: 100%;
}
.integrations-modal-footer-wrapper .d-flex{
    gap:16px;
}
.financial-modules-wrapper .financial-modules-item{
    font-size: 1.2rem;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s ease;
}
.client-payment-modal-form-label{
    color:#222a42 !important;
    font-size:16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 8px;
    display: block;
}
.client-payment-modal-form-helper-text{
    color:#6b7280 !important;
    font-size:12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: 4px;
    display: block;
}
.client-payment-setup-form-wrapper{
    display: flex;
    flex-direction: column;
    gap: 0px;
}

.campaign-cost-input.form-group .form-control:not(.has-danger){
    border: none !important;
}
.campaign-cost-input.el-date-editor .el-input__inner{
    border-color: black;
}
.campaign-cost-input.el-date-editor .el-input__inner:hover{
    border-color:var(--red);
}
.campaign-cost-input.form-group{
       border:1px solid black;
        color: #525f7f;
        border-radius: 4px;
  
}
.campaign-cost-input.form-group:hover{
      border-color:var(--red);
  
}
.campaign-cost-input .input-group .input-group-text{
    border: none;
        color: #525f7f;

}
.campaign-cost-input{
    border: none;
}

/* Styling for disabled pricing fields - make them grayer like Billing Frequency */
.campaign-cost-input.form-group .form-control:disabled,
.campaign-cost-input.form-group .form-control[disabled],
.campaign-cost-input.form-group input:disabled,
.campaign-cost-input.form-group input[disabled] {
    background-color: #f5f7fa !important;
    color: #c0c4cc !important;
    cursor: not-allowed;
    opacity: 1;
}

/* Style the form-group wrapper when it contains disabled inputs (using :has() for modern browsers) */
.campaign-cost-input.form-group:has(.form-control:disabled),
.campaign-cost-input.form-group:has(.form-control[disabled]),
.campaign-cost-input.form-group:has(input:disabled),
.campaign-cost-input.form-group:has(input[disabled]) {
    background-color: #f5f7fa !important;
    border-color: #e4e7ed !important;
}

/* Style input group text (icons) when input is disabled */
.campaign-cost-input.form-group:has(.form-control:disabled) .input-group-text,
.campaign-cost-input.form-group:has(.form-control[disabled]) .input-group-text,
.campaign-cost-input.form-group:has(input:disabled) .input-group-text,
.campaign-cost-input.form-group:has(input[disabled]) .input-group-text {
    background-color: #f5f7fa !important;
    color: #c0c4cc !important;
    border-color: #e4e7ed !important;
}

/* Fallback: Style adjacent input-group-text when input is disabled (for browsers without :has() support) */
.campaign-cost-input.form-group .input-group-prepend + .form-control:disabled ~ .input-group-append .input-group-text,
.campaign-cost-input.form-group .input-group-prepend .input-group-text:has(+ .form-control:disabled),
.campaign-cost-input.form-group .input-group-prepend .input-group-text:has(+ input:disabled) {
    background-color: #f5f7fa !important;
    color: #c0c4cc !important;
    border-color: #e4e7ed !important;
}

/* More specific selector for input-group-prepend when followed by disabled input */
.campaign-cost-input.form-group .input-group-prepend .input-group-text:has(+ input:disabled),
.campaign-cost-input.form-group .input-group-prepend .input-group-text:has(+ .form-control:disabled) {
    background-color: #f5f7fa !important;
    color: #c0c4cc !important;
    border-color: #e4e7ed !important;
}

/* Fallback class-based styling for browsers without :has() support */
.campaign-cost-input.form-group.disabled-field {
    background-color: #f5f7fa !important;
    border-color: #e4e7ed !important;
}

.campaign-cost-input.form-group.disabled-field .form-control,
.campaign-cost-input.form-group.disabled-field input {
    background-color: #f5f7fa !important;
    color: #c0c4cc !important;
}

.campaign-cost-input.form-group.disabled-field .input-group-text {
    background-color: #f5f7fa !important;
    color: #c0c4cc !important;
    border-color: #e4e7ed !important;
}

/* Ensure select fields also have gray disabled state (matching Element UI disabled style) */
.select__form__client.el-select.is-disabled .el-input__inner,
.select__form__client.el-select .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa !important;
    border-color: #e4e7ed !important;
    color: #c0c4cc !important;
}

.dropdown-hidden {
  display: none !important;
}

.menu__prices {
  padding: 8px 16px;
  border-radius: 4px;
  color: gray;
  cursor: pointer;
  font-weight: 600;
  font-size: 18px;
  border: 1px solid transparent;
  transition: border 300ms ease;
}

.active__menu__prices {
  color: black;
  border: 1px solid #222a42;
}

.country-region-select-wrapper {
    margin-bottom: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.country-region-select-wrapper .country-label {
    font-size: .80143rem;
    margin-bottom: 5px;
    display: block;
}

.country-region-select-wrapper .country-region-select {
    background: transparent;
    width: 100%;
    border: none;
    padding: 10px 18px;
    border-radius: 6px;
    border: 1px solid var(--input-border-color);
    outline: none !important;
    color: var(--primary-input-text-color);
}

.country-region-select-wrapper .country-region-select option{
    padding: 10px 18px;
    color: black !important;
}

.input__client__management .el-input__inner {
    padding-left: 30px;
    padding-right: 30px;
}

.client__management__card__credit {
    width: 50%;
    margin: 0 auto;
}

.add-webhook-url{
    height: 40px;
    width: 40px;
    background: gray;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    color: white;
}
.webhook-url-wrapper{
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
}

.webhook-section {
    width: 100%;
    padding: 16px 18px;
    border-radius: 10px;
    border: 1px solid rgba(15, 23, 42, 0.08) !important;
    background: #f8fafc !important;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
    margin-top: 12px;
}

.webhook-section__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 12px;
}

.webhook-section__title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2px;
    color: #222a42 !important;
}

.webhook-section__subtitle {
    font-size: 12px;
    margin: 0;
    color: #64748b !important;
}

.webhook-section__body {
    margin-top: 8px;
}

.webhook-section__label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 2px;
    color: #222a42 !important;
}

.webhook-section__helper {
    font-size: 11px;
    color: #64748b !important;
    margin-bottom: 8px;
}

.webhook-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.webhook-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
}

.webhook-item__main {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.webhook-item__badge {
    min-width: 24px;
    height: 24px;
    border-radius: 999px;
    background: #e2e8f0 !important;
    color: #0f172a !important;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.webhook-item__input {
    width: 100%;
    flex: 1;
}

.webhook-item__input .el-input__inner {
    background-color: #ffffff !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
}

.webhook-item__input .el-input__inner:focus {
    border-color: #409eff !important;
}

.webhook-item__fields {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    width: 100%;
}

.webhook-item__label-input {
    flex: 0 0 220px;
    max-width: 260px;
    font-size: 11px;
}

.webhook-item__label-input .el-input__inner {
    background-color: #ffffff !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
}

.webhook-item__label-input .el-input__inner:focus {
    border-color: #409eff !important;
}

.webhook-item__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.webhook-item__actions .el-button--text {
    color: #606266 !important;
}

.webhook-item__actions .el-button--text:hover {
    color: #409eff !important;
}

.webhook-section__footer {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
}

.webhook-section__extras {
    margin-top: 12px;
}
.webhook-section__footer .el-button--primary {
    background-color: #409eff !important;
    border-color: #409eff !important;
}

.webhook-section__footer .el-button--primary:hover {
    background-color: #66b1ff !important;
    border-color: #66b1ff !important;
}

.webhook-section .el-input__inner::placeholder {
    color: #c0c4cc !important;
}

.webhook-section .el-checkbox__label {
    color: #606266 !important;
}

.checkbox-field-integration {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.error-banner {
    padding: 8px 16px;
    background-color: #ffe6e6; /* Light red background for error */
    border-radius: 4px;
    border-left: 5px solid #dc3545; /* Red border for error */
    margin: 20px 0;
    font-size: 14px;
    color: #721c24; /* Darker red text for readability */
    line-height: 1.5em;
}

.error-banner p {
    margin: 0;
}

.logo-wrap-client-management {
  height: 36px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
  flex-shrink: 0;
}

.tag__custom {
    padding: 0 6px 16px 6px;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 11px;
    height: 16px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid transparent;
    font-weight: bold;
}

.tooltip-content {
  max-width: 300px;
  white-space: normal;
  word-break: break-word;
}

.el-b__checkbox .el-checkbox__label{
        font-size: 14px !important;
}

/* Integration notification styling */
.integration-notify-card {
    background: #ffffff !important;
    border: 1px solid #ebeef5 !important;
    box-shadow: 0 10px 40px rgba(31, 45, 61, 0.12) !important;
    border-radius: 12px !important;
    padding: 16px 18px !important;
    color: #2f3640 !important;
    max-width: 440px;
}
.integration-notify-card .el-notification__title {
    font-weight: 800;
    color: #1f2d3d !important;
    line-height: 1.4;
    font-size: 15px;
    letter-spacing: 0.1px;
}
.integration-notify-card .el-notification__content {
    margin-top: 10px;
    color: #2f3640;
    line-height: 1.65;
    font-size: 13.5px;
}
.integration-notify-card .el-notification__closeBtn {
    color: #c0c4cc;
}
.integration-notify-card .el-notification__closeBtn:hover {
    color: #909399;
}
.integration-notify-card .int-section {
    margin-bottom: 12px;
}
.integration-notify-card .int-section:last-child {
    margin-bottom: 0;
}
.integration-notify-card .int-section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 14.5px;
    letter-spacing: 0.2px;
    margin-bottom: 4px;
}
.integration-notify-card .int-success {
    color: #1c7c33;
}
.integration-notify-card .int-warning {
    color: #b26a00;
}
.integration-notify-card .int-danger {
    color: #c1121f;
}
.integration-notify-card .int-list {
    list-style: none;
    margin: 6px 0 0 0;
    padding: 0 0 0 2px;
}
.integration-notify-card .int-list li {
    margin: 6px 0;
}
.integration-notify-card .int-item {
    font-weight: 500;
    color: #303133;
}
.integration-notify-card .int-sub {
    color: #909399;
    font-size: 12px;
    margin-top: 2px;
}
.integration-notify-card .int-section.int-success {
    border-left: 4px solid #1c7c33;
    padding-left: 8px;
}
.integration-notify-card .int-section.int-warning {
    border-left: 4px solid #b26a00;
    padding-left: 8px;
}
.integration-notify-card .int-section.int-danger {
    border-left: 4px solid #c1121f;
    padding-left: 8px;
}
.integration-notify-card .int-footer {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    font-size: 12.5px;
    color: #606266;
}
.integration-notify-card .int-footer.danger {
    color: #d63031;
    font-weight: 600;
}

@media (max-width: 992px) {
    .client__management__card__credit {
        width: 75%;
    }
}

@media (max-width: 768px) {
  .checkbox-field-integration {
    grid-template-columns: repeat(2, 1fr);
  }
}


@media (max-width: 576px) {
    .client__management__card__credit {
        width: 100%;
    }
}

@media (max-width: 469px) {
    .integratios-list-wrapper {
        justify-content: center;
    }
    .checkbox-field-integration {
        grid-template-columns: repeat(1, 1fr); 
    }
}
</style>